import { useState, useMemo, useRef, useEffect } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import HelpChatbot from "./HelpChatbot";
import DocumentImportModal from "./DocumentImport";

const FontLink = () => (
  <link href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet" />
);
const AKS_LOGO = "data:image/png;base64,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";


const B = {
  red:"#A51C30", redD:"#7B1020", black:"#141414", charcoal:"#222222",
  gray:"#4A4A4A", silver:"#8A8A8A", light:"#E8E8E8", offWhite:"#F5F4F2", white:"#FFFFFF",
  gold:"#D97706", blue:"#2563EB", teal:"#0891B2", green:"#16A34A", purple:"#7C3AED",
};

// ─── Role Definitions ─────────────────────────────────────────────────────────
// principal_broker → top of hierarchy, sees everything, manages associate brokers
// associate_broker → manages their assigned realtors, reviews their transactions
// realtor          → manages their own transactions only
const ROLES = {
  principal_broker: { label:"Principal Broker", short:"Principal", color:B.red,    icon:"👑" },
  associate_broker: { label:"Associate Broker", short:"Assoc. Broker", color:B.teal, icon:"🏢" },
  realtor:          { label:"Realtor®",          short:"Realtor",   color:B.silver, icon:"🏠" },
};

const RoleBadge = ({ role }) => {
  const r = ROLES[role] || ROLES.realtor;
  return (
    <span style={{ display:"inline-flex", alignItems:"center", gap:4, padding:"2px 9px", borderRadius:20,
      background:r.color+"18", color:r.color, border:`1px solid ${r.color}44`,
      fontSize:10, fontWeight:700, letterSpacing:"0.05em", whiteSpace:"nowrap", fontFamily:"'DM Sans',sans-serif" }}>
      {r.icon} {r.short}
    </span>
  );
};

// ─── Workflow States ──────────────────────────────────────────────────────────
const WF_STATES = {
  draft:             { label:"Draft",               color:"#6B7280", bg:"#F3F4F6" },
  submitted:         { label:"Submitted for Review", color:B.gold,    bg:"#FFFBEB" },
  changes_requested: { label:"Changes Requested",    color:"#DC2626", bg:"#FFF5F5" },
  approved:          { label:"Approved",             color:B.teal,    bg:"#ECFEFF" },
  closed:            { label:"Closed",               color:B.green,   bg:"#F0FDF4" },
  fallen_through:    { label:"Fallen Through",       color:"#DC2626", bg:"#FFF5F5" },
  archived:          { label:"Archived",             color:"#92400E", bg:"#FEF3C7" },
};

const WfBadge = ({ wfState }) => {
  const s = WF_STATES[wfState] || WF_STATES.draft;
  const icons = { draft:"✏", submitted:"⏳", changes_requested:"↩", approved:"✓", closed:"🏁", fallen_through:"✕" };
  return (
    <span style={{ display:"inline-flex", alignItems:"center", gap:4, padding:"3px 10px", borderRadius:20,
      background:s.bg, color:s.color, border:`1px solid ${s.color}44`,
      fontSize:11, fontWeight:700, letterSpacing:"0.04em", whiteSpace:"nowrap", fontFamily:"'DM Sans',sans-serif" }}>
      {icons[wfState]} {s.label}
    </span>
  );
};

// ─── Task Templates ───────────────────────────────────────────────────────────
// Structure:
//   mandatory: true  → document MUST be attached; task cannot be manually checked
//   mandatory: false → optional; can be manually checked OR completed via doc upload
//   side: "Both" | "Buyer" | "Seller"
//
// ── MANDATORY — Both Sides ────────────────────────────────────────────────────
//   1. RECAD
//   2. AKS Real Estate Agency Election
//   3. Net Sheet
//   4. Contract
//   5. Earnest Money
// ── MANDATORY — Buyer Side Only ───────────────────────────────────────────────
//   6. Exclusive Buyer Agency Agreement
// ── MANDATORY — Seller Side Only ─────────────────────────────────────────────
//   7. Exclusive Listing Agreement
// ── MANDATORY — Both Sides · Post-Closing ───────────────────────────────────
//   8. ALTA / Closing Disclosure
//   9. Closing Check
// ── OPTIONAL — Both Sides ────────────────────────────────────────────────────
//   10. Affiliated Business Disclosure
//   11. Inspection Addendum
//   12. Additional Documents (catch-all)

const DEFAULT_TASKS = [
  // ── Mandatory · Both sides ────────────────────────────────────────────────
  {
    templateId:"tpl_recad",
    title:"RECAD",
    mandatory:true, side:"Both", category:"Disclosure",
    description:"Real Estate Consumer's Agency and Disclosure form. Required by Alabama law for all transactions (AREC Rule 790-X-3-.09). Must be signed by all parties prior to or at time of contract.",
  },
  {
    templateId:"tpl_agency_election",
    title:"AKS Real Estate Agency Election",
    mandatory:true, side:"Both", category:"Agency",
    description:"AKS Realty Group agency election form confirming the representation type selected — seller's agent, buyer's agent, or disclosed dual agent.",
  },
  {
    templateId:"tpl_netsheet",
    title:"Net Sheet",
    mandatory:true, side:"Both", category:"Finance",
    description:"Estimated net sheet for Seller (proceeds after costs) or estimated cash-to-close for Buyer. Must be prepared and acknowledged before contract execution.",
  },
  {
    templateId:"tpl_contract",
    title:"Contract",
    mandatory:true, side:"Both", category:"Contract",
    description:"Fully executed purchase agreement / sales contract signed by all parties. Alabama Association of Realtors® approved form or equivalent.",
  },
  {
    templateId:"tpl_earnest_money",
    title:"Earnest Money",
    mandatory:true, side:"Both", category:"Finance",
    description:"Proof of earnest money deposit — copy of the check, wire confirmation, or receipt from the holding broker/escrow agent. Confirms good faith deposit has been received per contract terms.",
  },
  // ── Mandatory · Buyer side only ───────────────────────────────────────────
  {
    templateId:"tpl_buyer_agency",
    title:"Exclusive Buyer Agency Agreement",
    mandatory:true, side:"Buyer", category:"Agency",
    description:"Signed Exclusive Buyer Agency Agreement establishing AKS Realty Group as the buyer's exclusive agent. Required before showing properties or submitting offers.",
  },
  // ── Mandatory · Seller side only ─────────────────────────────────────────
  {
    templateId:"tpl_listing_agreement",
    title:"Exclusive Listing Agreement",
    mandatory:true, side:"Seller", category:"Agency",
    description:"Signed Exclusive Right to Sell Listing Agreement authorizing AKS Realty Group to market and sell the property. Includes listing price, commission, and term.",
  },
  // ── Mandatory · Both sides · Post-Closing ────────────────────────────────
  {
    templateId:"tpl_alta",
    title:"ALTA / Closing Disclosure",
    mandatory:true, side:"Both", category:"Closing",
    description:"ALTA Settlement Statement or Closing Disclosure showing all final charges, credits, and proceeds for both buyer and seller. Must be signed by all parties at or after closing.",
  },
  {
    templateId:"tpl_closing_check",
    title:"Closing Check",
    mandatory:true, side:"Both", category:"Closing",
    description:"Copy of the commission check or wire confirmation received from the closing attorney or title company confirming commission disbursement.",
  },
  // ── Optional · Both sides ─────────────────────────────────────────────────
  {
    templateId:"tpl_affiliated_biz",
    title:"Affiliated Business Disclosure",
    mandatory:false, side:"Both", category:"Disclosure",
    description:"Disclosure of any affiliated business arrangements (title companies, mortgage lenders, inspectors, etc.) in which AKS Realty Group has a financial interest. Required by RESPA when applicable.",
  },
  {
    templateId:"tpl_inspection_addendum",
    title:"Inspection Addendum",
    mandatory:false, side:"Both", category:"Inspection",
    description:"Signed inspection addendum documenting agreed repairs, credits, or as-is acceptance following home inspection results.",
  },
  {
    templateId:"tpl_additional_docs",
    title:"Additional Documents",
    mandatory:false, side:"Both", category:"Other",
    description:"Any supplemental documents relevant to this transaction — HOA addendum, lead-based paint disclosure, appraisal addendum, well/septic disclosure, survey, title commitment, closing disclosure, etc.",
  },
];

const CATEGORY_COLORS = {
  Disclosure: B.gold,
  Agency:     B.teal,
  Finance:    B.blue,
  Contract:   B.purple,
  Inspection: B.green,
  Closing:    "#16A34A",
  Other:      B.silver,
};

// Local/demo-mode fallback — same shape checklist_templates rows come in as,
// so buildTasks() and ChecklistTemplatePanel don't need to know which mode
// they're in.
function defaultChecklistTemplates() {
  return DEFAULT_TASKS.map((t,i) => ({
    id:t.templateId, templateId:t.templateId, title:t.title, mandatory:t.mandatory,
    side:t.side, category:t.category, description:t.description,
    sortOrder:i, active:true,
  }));
}

export function buildTasks(side, templates = DEFAULT_TASKS) {
  return templates
    .filter(t => t.active !== false)
    .filter(t => t.side === "Both" || t.side === side)
    .map(t => ({
      id:`task_${t.templateId}_${Date.now()}_${Math.random().toString(36).slice(2,6)}`,
      templateId:t.templateId, title:t.title, mandatory:t.mandatory,
      side:t.side, category:t.category, description:t.description,
      completed:false, dueDate:"", notes:"", documents:[],
    }));
}

// ─── Helpers ──────────────────────────────────────────────────────────────────
const fmt          = n => n?.toLocaleString("en-US",{style:"currency",currency:"USD",minimumFractionDigits:2,maximumFractionDigits:2})||"$0.00";
const fmtDate      = d => d ? new Date(d+"T00:00:00").toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";
const fmtTS        = ts => ts ? new Date(ts).toLocaleString("en-US",{month:"short",day:"numeric",hour:"numeric",minute:"2-digit"}) : "—";
const fmtSize      = b => b>1048576?(b/1048576).toFixed(1)+" MB":(b/1024).toFixed(0)+" KB";
export const genId        = () => "id_"+Date.now()+"_"+Math.random().toString(36).slice(2,7);
const calcGCI      = (p,pct) => (p*pct)/100;
// True brokerage earnings on a deal — gross commission minus any referral fee
// paid out to an outside agent/brokerage (that portion was never AKS's money).
const calcNetGCI    = (p,pct,ref) => calcGCI(p,pct) - Number(ref||0);
const calcNet      = (p,pct,ref,split) => ((calcGCI(p,pct)-ref)*split)/100;
const daysUntil    = d => d ? Math.ceil((new Date(d+"T00:00:00")-new Date())/86400000) : null;
const allMandatoryDone = tasks => tasks.filter(t=>t.mandatory).every(t=>t.documents.length>0);

// Get fee defaults from an agent's profile
export function getAgentFees(agentId, users) {
  const agent = users.find(u => u.id === agentId);
  if (!agent) return { agentSplit:95, transactionFee:0, eoFee:0, customFees:[] };
  // Brokers get 100% split (they keep everything, brokerage keeps 0%)
  if (agent.role === "principal_broker" || agent.role === "associate_broker") {
    return agent.fees?.agentSplit !== undefined
      ? agent.fees
      : { agentSplit:100, transactionFee:0, eoFee:0, customFees:[] };
  }
  return agent.fees || { agentSplit:95, transactionFee:0, eoFee:0, customFees:[] };
}

// Calculate total deductions and agent net using fee profile
function calcAgentNetFull(price, commissionPct, referralFee, fees) {
  const gci      = calcGCI(price, commissionPct);
  const afterRef = gci - Number(referralFee||0);
  const split    = (afterRef * Number(fees.agentSplit||95)) / 100;
  const txFee    = Number(fees.transactionFee||0);
  const eoFee    = Number(fees.eoFee||0);
  const customTotal = (fees.customFees||[]).reduce((s,f) => {
    if (f.type==="pct") return s + (afterRef * Number(f.amount||0)) / 100;
    return s + Number(f.amount||0);
  }, 0);
  return { gci, afterRef, split, txFee, eoFee, customTotal,
    agentNet: split - txFee - eoFee - customTotal,
    brokerageKeeps: afterRef - split + txFee + eoFee + customTotal };
}
const initials     = name => name.split(" ").map(n=>n[0]).join("").toUpperCase();

// ─── Initial User Roster ──────────────────────────────────────────────────────
// Two-tier hierarchy:
//   principal_broker → brokerId: null (top of org)
//   associate_broker → brokerId: points to principal_broker
//   realtor          → brokerId: points to their assigned associate_broker (or principal)
const INITIAL_USERS = [
  { id:"u_principal", name:"Srianil Peddi",  role:"principal_broker", brokerId:null,         licenseNo:"AL-100001", email:"speddi@aksrealtygroup.com",  phone:"205-821-9683", address:"500 Keystone Ct", city:"Pelham",    state:"AL", zip:"35124", dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
  { id:"u_ab1",       name:"Rachel Kim",      role:"associate_broker", brokerId:"u_principal",licenseNo:"AL-200001", email:"rkim@aksrealtygroup.com",     phone:"205-555-0101", address:"",               city:"Birmingham",state:"AL", zip:"",      dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
  { id:"u_r1",        name:"Bonnie Malec",    role:"realtor",          brokerId:"u_ab1",      licenseNo:"AL-300001", email:"bmalec@aksrealtygroup.com",   phone:"205-555-0111", address:"",               city:"Hoover",    state:"AL", zip:"",      dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
  { id:"u_r2",        name:"Jennifer Okafor", role:"realtor",          brokerId:"u_ab1",      licenseNo:"AL-300002", email:"jokafor@aksrealtygroup.com",  phone:"205-555-0112", address:"",               city:"Pelham",    state:"AL", zip:"",      dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
  { id:"u_r3",        name:"David Chen",      role:"realtor",          brokerId:"u_principal",licenseNo:"AL-300003", email:"dchen@aksrealtygroup.com",    phone:"205-555-0113", address:"",               city:"Alabaster", state:"AL", zip:"",      dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
  { id:"u_r4",        name:"Tanya Brooks",    role:"realtor",          brokerId:"u_principal",licenseNo:"AL-300004", email:"tbrooks@aksrealtygroup.com",  phone:"205-555-0114", address:"",               city:"Birmingham",state:"AL", zip:"",      dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
  { id:"u_r5",        name:"Carlos Rivera",   role:"realtor",          brokerId:"u_principal",licenseNo:"AL-300005", email:"crivera@aksrealtygroup.com",  phone:"205-555-0115", address:"",               city:"Hoover",    state:"AL", zip:"",      dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
  { id:"u_r6",        name:"Ashley Morgan",   role:"realtor",          brokerId:"u_ab1",      licenseNo:"AL-300006", email:"amorgan@aksrealtygroup.com",  phone:"205-555-0116", address:"",               city:"Pelham",    state:"AL", zip:"",      dob:"", emergency:{name:"",relationship:"",phone:"",email:""}, banking:{achDoc:null,w9Doc:null}, fees:{agentSplit:95,transactionFee:0,eoFee:0,customFees:[]} },
];

export const STAGES = ["Pre-Listing / Pre-Offer","Active / MLS","Under Contract","Inspection","Appraisal","Clear to Close","Closed","Fallen Through"];
const STAGE_COLORS = {
  "Pre-Listing / Pre-Offer":"#6B7280","Active / MLS":B.blue,"Under Contract":B.purple,
  "Inspection":B.gold,"Appraisal":B.green,"Clear to Close":B.teal,
  "Closed":B.green,"Fallen Through":"#DC2626",
};

// ─── Access Control Helpers ───────────────────────────────────────────────────
function canUserSeeTransaction(user, tx, users) {
  if (!user || !tx) return false;
  // Tenant guard, always first — RLS already scopes rows by brokerage, but
  // this is cheap belt-and-suspenders against ever rendering cross-tenant
  // data if a query ever returns more than it should.
  if (tx.brokerageId !== user.brokerageId) return false;
  if (user.role === "principal_broker") return true;
  if (user.role === "associate_broker") {
    if (tx.agentId === user.id) return true;
    const agent = users.find(u => u.id === tx.agentId);
    if (agent?.brokerId === user.id) return true;
    // If agent not found in users array yet, show it (users may still be loading)
    if (!agent && tx.agentId) return true;
    return false;
  }
  // realtor: only own transactions
  return tx.agentId === user.id;
}

function canReviewTransaction(user, tx, users) {
  if (tx.brokerageId !== user.brokerageId) return false; // tenant guard, always first
  if (user.role === "principal_broker") return true; // can step in on anything
  if (user.role === "associate_broker") {
    const agent = users.find(u => u.id === tx.agentId);
    return agent?.brokerId === user.id || tx.agentId === user.id;
  }
  return false;
}

// Authority to approve a *submitted* transaction — narrower than
// canReviewTransaction, which also covers closing your own already-approved
// transaction (legitimate: you own it). Nobody reviews their own submission:
// principal brokers use the separate self-approval flow, and associate
// brokers must submit up to the principal — so self-ownership never grants
// review authority here, regardless of role.
function canReviewSubmission(user, tx, users) {
  if (tx.agentId === user.id) return false;
  return canReviewTransaction(user, tx, users);
}

function canCloseTransaction(user) {
  return user.role === "principal_broker" || user.role === "associate_broker";
}

function getAssignedBroker(agentId, users) {
  const agent = users.find(u => u.id === agentId);
  if (!agent || !agent.brokerId) return null;
  return users.find(u => u.id === agent.brokerId) || null;
}

// ─── Sample Transactions ──────────────────────────────────────────────────────
function makeSample(users) {
  const rows = [
    {id:"t1",agentId:"u_r1",side:"Seller",address:"1204 Cahaba Crest Dr, Pelham, AL 35124",   clientName:"Robert & Lisa Harmon",    price:385000,stage:"Closed",          wfState:"closed",            commissionPct:3,referralFee:0,  agentSplit:70,contractDate:"2025-03-01",inspectionDeadline:"2025-03-10",appraisalDeadline:"2025-03-20",closingDate:"2025-03-28",notes:"Smooth transaction."},
    {id:"t2",agentId:"u_r2",side:"Buyer", address:"88 Stonegate Blvd, Hoover, AL 35244",      clientName:"Amara & James Powell",    price:465000,stage:"Clear to Close",   wfState:"submitted",         commissionPct:3,referralFee:0,  agentSplit:70,contractDate:"2025-04-10",inspectionDeadline:"2025-04-20",appraisalDeadline:"2025-04-30",closingDate:"2025-05-25",notes:"Appraisal came in at value."},
    {id:"t3",agentId:"u_r1",side:"Buyer", address:"312 Oak Ridge Ln, Alabaster, AL 35007",    clientName:"Derek Thompson",          price:295000,stage:"Inspection",        wfState:"changes_requested", commissionPct:3,referralFee:500,agentSplit:70,contractDate:"2025-04-25",inspectionDeadline:"2025-05-05",appraisalDeadline:"2025-05-15",closingDate:"2025-06-10",notes:"Minor HVAC issue found."},
    {id:"t4",agentId:"u_r3",side:"Seller",address:"5501 Inverness Pkwy, Birmingham, AL 35242",clientName:"Sandra Mitchell",         price:620000,stage:"Active / MLS",      wfState:"draft",             commissionPct:3,referralFee:0,  agentSplit:65,contractDate:"",           inspectionDeadline:"",          appraisalDeadline:"",           closingDate:"2025-07-01",notes:"Listed 5/1. Two showings."},
    {id:"t5",agentId:"u_r4",side:"Buyer", address:"720 Riverchase Dr, Hoover, AL 35244",      clientName:"Keisha & Marcus Ford",    price:510000,stage:"Under Contract",    wfState:"approved",          commissionPct:3,referralFee:0,  agentSplit:70,contractDate:"2025-04-28",inspectionDeadline:"2025-05-08",appraisalDeadline:"2025-05-18",closingDate:"2025-06-15",notes:"Inspection scheduled 5/7."},
    {id:"t6",agentId:"u_r5",side:"Seller",address:"1033 Shelby Forest Dr, Pelham, AL 35124",  clientName:"Anthony & Grace Nguyen", price:340000,stage:"Fallen Through",    wfState:"fallen_through",    commissionPct:3,referralFee:0,  agentSplit:70,contractDate:"2025-03-15",inspectionDeadline:"",          appraisalDeadline:"",           closingDate:"",          notes:"Buyer financing fell through."},
    {id:"t7",agentId:"u_principal",side:"Seller",address:"500 Keystone Ct, Pelham, AL 35124", clientName:"Daniel & Patricia Moore",price:425000,stage:"Appraisal",          wfState:"approved",          commissionPct:6,referralFee:0,  agentSplit:100,contractDate:"2025-04-20",inspectionDeadline:"2025-04-30",appraisalDeadline:"2025-05-20",closingDate:"2025-06-01",notes:"Dual agency. Appraisal ordered."},
    {id:"t8",agentId:"u_r6",side:"Buyer", address:"204 Timberlake Dr, Alabaster, AL 35007",   clientName:"Patrick & Diane Walsh",  price:320000,stage:"Under Contract",    wfState:"submitted",         commissionPct:3,referralFee:0,  agentSplit:70,contractDate:"2025-05-01",inspectionDeadline:"2025-05-12",appraisalDeadline:"2025-05-22",closingDate:"2025-06-20",notes:"First-time buyers."},
  ];
  return rows.map(tx => {
    const role = tx.side==="Buyer" ? "buyer" : "seller";
    const names = tx.clientName.split(" & ");
    const parties = names.filter(Boolean).map(name => ({
      id:"p_"+Math.random().toString(36).slice(2,8),
      role, name, email:"", phone:"", address:"",
    }));
    return {
    ...tx,
    parties,
    contacts:[],
    tasks: buildTasks(tx.side),
    reviewLog: tx.wfState==="changes_requested"
      ? [{id:genId(),action:"changes_requested",by:"u_ab1",byName:"Rachel Kim",at:new Date("2025-05-10T14:30:00").toISOString(),comment:"Please attach the signed RECAD form and earnest money receipt before resubmitting."}]
      : tx.wfState==="approved"
      ? [{id:genId(),action:"approved",by:"u_ab1",byName:"Rachel Kim",at:new Date("2025-05-15T09:00:00").toISOString(),comment:"All documents in order. Approved for closing."}]
      : [],
    submittedAt: tx.wfState!=="draft" ? new Date("2025-05-08T10:00:00").toISOString() : null,
  };
  });
}

// ─── Shared UI Atoms ──────────────────────────────────────────────────────────
const pill = (label, color) => (
  <span style={{display:"inline-block",padding:"2px 9px",borderRadius:20,background:color+"22",color,border:`1px solid ${color}44`,fontSize:11,fontWeight:700,letterSpacing:"0.04em",whiteSpace:"nowrap",fontFamily:"'DM Sans',sans-serif"}}>{label}</span>
);
const StageBadge = ({stage}) => pill(stage, STAGE_COLORS[stage]||B.gray);
const SideBadge  = ({side})  => pill(side, side==="Buyer"?B.blue:B.red);

const StatCard = ({label,value,sub,accent}) => (
  <div style={{background:B.white,borderRadius:12,padding:"18px 22px",border:`1px solid ${B.light}`,boxShadow:"0 1px 4px rgba(0,0,0,0.06)",borderLeft:`4px solid ${accent||B.red}`}}>
    <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:5,fontFamily:"'DM Sans',sans-serif"}}>{label}</div>
    <div style={{fontSize:24,fontWeight:800,color:B.black,fontFamily:"'Playfair Display',serif"}}>{value}</div>
    {sub&&<div style={{fontSize:11,color:B.silver,marginTop:3,fontFamily:"'DM Sans',sans-serif"}}>{sub}</div>}
  </div>
);

const Avatar = ({name, role, size=34, photo=null}) => {
  const r = ROLES[role]||ROLES.realtor;
  if (photo) {
    return (
      <div style={{width:size,height:size,borderRadius:"50%",overflow:"hidden",flexShrink:0,border:`2px solid ${r.color}88`,boxShadow:"0 1px 4px rgba(0,0,0,0.2)"}}>
        <img src={photo} alt={name} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
      </div>
    );
  }
  return (
    <div style={{width:size,height:size,borderRadius:"50%",background:r.color,display:"flex",alignItems:"center",justifyContent:"center",color:B.white,fontSize:size*0.35,fontWeight:700,flexShrink:0,fontFamily:"'DM Sans',sans-serif",border:`2px solid ${r.color}88`}}>
      {initials(name)}
    </div>
  );
};



// ─── Document Preview Modal ───────────────────────────────────────────────────
function DocPreviewModal({ doc, onClose }) {
  if (!doc) return null;
  const isPdf   = doc.type?.includes("pdf");
  const isImage = doc.type?.includes("image");

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.85)", zIndex:2000,
      display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}
      onClick={onClose}>
      <div style={{ width:"min(900px,95vw)", maxHeight:"90vh", display:"flex", flexDirection:"column",
        borderRadius:14, overflow:"hidden", boxShadow:"0 32px 80px rgba(0,0,0,0.6)" }}
        onClick={e=>e.stopPropagation()}>

        {/* Header */}
        <div style={{ background:B.black, padding:"14px 20px", display:"flex", alignItems:"center",
          justifyContent:"space-between", gap:12, flexShrink:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, minWidth:0 }}>
            <span style={{ fontSize:20 }}>{isPdf?"📄":isImage?"🖼":"📎"}</span>
            <div style={{ minWidth:0 }}>
              <div style={{ fontSize:13, fontWeight:700, color:B.white, fontFamily:"'DM Sans',sans-serif",
                overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{doc.name}</div>
              <div style={{ fontSize:10, color:B.silver, fontFamily:"'DM Sans',sans-serif", marginTop:1 }}>
                {fmtSize(doc.size)} · {new Date(doc.uploadedAt).toLocaleDateString()} · Uploaded by {doc.uploadedBy}
              </div>
            </div>
          </div>
          <div style={{ display:"flex", gap:8, flexShrink:0 }}>
            <a href={doc.dataUrl} download={doc.name}
              style={{ padding:"7px 14px", borderRadius:8, border:"1px solid "+B.green+"55",
                background:B.green+"18", color:B.green, fontSize:12, fontWeight:700,
                fontFamily:"'DM Sans',sans-serif", textDecoration:"none", display:"flex", alignItems:"center", gap:5 }}>
              ↓ Download
            </a>
            <button onClick={onClose}
              style={{ padding:"7px 14px", borderRadius:8, border:"1px solid "+B.gray,
                background:"transparent", cursor:"pointer", fontSize:12, color:B.silver,
                fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", gap:5 }}>
              ✕ Close
            </button>
          </div>
        </div>

        {/* Content */}
        <div style={{ flex:1, overflowY:"auto", background: isPdf?"#525659":isImage?"#1a1a1a":"#1a1a1a",
          display:"flex", alignItems:"center", justifyContent:"center", minHeight:200 }}>
          {isImage && (
            <img src={doc.dataUrl} alt={doc.name}
              style={{ maxWidth:"100%", maxHeight:"80vh", objectFit:"contain", display:"block" }}/>
          )}
          {isPdf && (
            <iframe src={doc.dataUrl} title={doc.name}
              style={{ width:"100%", height:"80vh", border:"none" }}/>
          )}
          {!isImage && !isPdf && (
            <div style={{ textAlign:"center", padding:40 }}>
              <div style={{ fontSize:60, marginBottom:16 }}>📎</div>
              <div style={{ fontSize:14, color:B.silver, fontFamily:"'DM Sans',sans-serif", marginBottom:20 }}>
                Preview not available for this file type.
              </div>
              <a href={doc.dataUrl} download={doc.name}
                style={{ padding:"10px 24px", borderRadius:10, border:"none",
                  background:B.red, color:B.white, fontSize:13, fontWeight:700,
                  fontFamily:"'DM Sans',sans-serif", textDecoration:"none" }}>
                ↓ Download to View
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── User Profile Panel ───────────────────────────────────────────────────────
// Access rules:
//   - Any user can open and edit their OWN profile
//   - Principal Broker can open and edit ANYONE's profile
//   - Associate Broker can VIEW (not edit) profiles of their assigned Realtors
//   - ACH and W9 docs visible to the profile owner + any broker in their chain
function UserProfilePanel({ targetUser, currentUser, onSave, onClose }) {
  const isPrincipal  = currentUser.role === "principal_broker";
  const isOwnProfile = currentUser.id   === targetUser.id;
  const canEdit      = isOwnProfile || isPrincipal;

  // ── local form state ──
  const [tab,    setTab]    = useState("contact");  // contact | emergency | banking
  const [form,   setForm]   = useState({
    name:         targetUser.name         || "",
    email:        targetUser.email        || "",
    phone:        targetUser.phone        || "",
    address:      targetUser.address      || "",
    city:         targetUser.city         || "",
    state:        targetUser.state        || "AL",
    zip:          targetUser.zip          || "",
    dob:          targetUser.dob          || "",
    licenseNo:    targetUser.licenseNo    || "",
  });
  const [emergency, setEmergency] = useState({
    name:         targetUser.emergency?.name         || "",
    relationship: targetUser.emergency?.relationship || "",
    phone:        targetUser.emergency?.phone        || "",
    email:        targetUser.emergency?.email        || "",
  });
  const [banking, setBanking] = useState({
    achDoc: targetUser.banking?.achDoc || null,
    w9Doc:  targetUser.banking?.w9Doc  || null,
  });

  // Fees state — only Principal Broker can edit
  const canEditFees = currentUser.role === "principal_broker";

  // Security / password change state
  const [, setPwCurrent]  = useState("");  // write-only, cleared after password change
  const [pwNew,      setPwNew]      = useState("");
  const [pwConfirm,  setPwConfirm]  = useState("");
  const [pwLoading,  setPwLoading]  = useState(false);
  const [pwError,    setPwError]    = useState("");
  const [pwSuccess,  setPwSuccess]  = useState(false);

  async function handleChangePassword() {
    setPwError(""); setPwSuccess(false);
    if (!pwNew)               { setPwError("Please enter a new password."); return; }
    if (pwNew.length < 8)     { setPwError("Password must be at least 8 characters."); return; }
    if (pwNew !== pwConfirm)  { setPwError("Passwords do not match."); return; }
    setPwLoading(true);
    try {
      if (window._supabaseUpdatePassword) {
        await window._supabaseUpdatePassword(pwNew);
      } else {
        throw new Error("Password update not available in demo mode.");
      }
      setPwSuccess(true);
      setPwCurrent(""); setPwNew(""); setPwConfirm("");
    } catch(e) {
      setPwError(e.message || "Failed to update password.");
    } finally {
      setPwLoading(false);
    }
  }
  const isBrokerRole = targetUser.role === "principal_broker" || targetUser.role === "associate_broker";
  const defaultSplit = isBrokerRole ? 100 : 95;
  const [fees, setFees] = useState({
    agentSplit:     targetUser.fees?.agentSplit     ?? defaultSplit,
    transactionFee: targetUser.fees?.transactionFee ?? 0,
    eoFee:          targetUser.fees?.eoFee          ?? 0,
    customFees:     targetUser.fees?.customFees     || [],
  });
  function setFee(k,v) { setFees(f=>({...f,[k]:v})); }
  function addCustomFeeLine() { setFees(f=>({...f,customFees:[...f.customFees,{id:genId(),label:"",amount:0,type:"flat"}]})); }
  function updateCustomLine(id,patch) { setFees(f=>({...f,customFees:f.customFees.map(x=>x.id===id?{...x,...patch}:x)})); }
  function removeCustomLine(id) { setFees(f=>({...f,customFees:f.customFees.filter(x=>x.id!==id)})); }
  const [uploading, setUploading] = useState(null); // "ach" | "w9"
  const [photo, setPhoto] = useState(targetUser.photo || null);
  const fileRef     = useRef();
  const photoRef    = useRef();
  const [previewDoc, setPreviewDoc] = useState(null);

  function handlePhotoUpload(files) {
    const file = files[0];
    if (!file) return;
    // Validate it's an image
    if (!file.type.startsWith("image/")) { alert("Please upload an image file (JPG, PNG, etc.)"); return; }
    // Warn if file is large
    if (file.size > 5 * 1024 * 1024) { alert("Photo must be under 5MB."); return; }
    const reader = new FileReader();
    reader.onload = e => setPhoto(e.target.result);
    reader.readAsDataURL(file);
  }

  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const setE = (k,v) => setEmergency(e=>({...e,[k]:v}));

  function handleDocUpload(docType, files) {
    const file = files[0]; if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      const doc = { id:genId(), name:file.name, size:file.size, type:file.type,
        dataUrl:e.target.result, uploadedAt:new Date().toISOString(), uploadedBy:currentUser.name };
      setBanking(b => ({ ...b, [docType==="ach"?"achDoc":"w9Doc"]: doc }));
    };
    reader.readAsDataURL(file);
    setUploading(null);
  }

  function removeDoc(docType) {
    setBanking(b => ({ ...b, [docType==="ach"?"achDoc":"w9Doc"]: null }));
  }

  const [savingProfile, setSavingProfile] = useState(false);
  async function handleSave() {
    setSavingProfile(true);
    await onSave({ ...targetUser, ...form, emergency, banking, fees, photo });
    setSavingProfile(false);
    onClose();
  }

  const inp = { width:"100%", padding:"9px 12px", borderRadius:8, border:"1px solid "+B.light,
    fontSize:13, fontFamily:"'DM Sans',sans-serif",
    background: canEdit ? B.offWhite : "#F3F3F3",
    color: B.black, outline:"none", boxSizing:"border-box" };
  const lbl = { fontSize:10, fontWeight:700, color:B.silver, letterSpacing:"0.09em",
    textTransform:"uppercase", display:"block", marginBottom:4, fontFamily:"'DM Sans',sans-serif" };
  const F = (label, key, type="text", src="form") => (
    <div style={{marginBottom:14}}>
      <label style={lbl}>{label}</label>
      <input type={type} disabled={!canEdit}
        value={src==="form" ? form[key] : emergency[key]}
        onChange={e => src==="form" ? set(key,e.target.value) : setE(key,e.target.value)}
        style={inp} />
    </div>
  );

  const DocRow = ({ docType, label, color }) => {
    const doc = docType==="ach" ? banking.achDoc : banking.w9Doc;
    return (
      <div style={{border:"1px solid "+color+"44", borderRadius:10, padding:"16px 18px", background:color+"08", marginBottom:14}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:doc?12:0}}>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{label}</div>
            <div style={{fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif",marginTop:2}}>
              {docType==="ach" ? "ACH Direct Deposit Authorization form" : "IRS Form W-9 — Request for Taxpayer ID"}
            </div>
          </div>
          {!doc && canEdit && (
            <button onClick={()=>{ setUploading(docType); setTimeout(()=>fileRef.current?.click(),50); }}
              style={{padding:"7px 14px",borderRadius:8,border:"1.5px dashed "+color,background:color+"0D",color,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif",flexShrink:0}}>
              📎 Upload
            </button>
          )}
        </div>
        {doc && (
          <div style={{borderRadius:8,border:"1px solid "+B.light,overflow:"hidden",background:B.white}}>
            {/* Image preview */}
            {doc.type?.includes("image")&&(
              <div style={{background:"#000",maxHeight:160,overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <img src={doc.dataUrl} alt={doc.name} style={{maxWidth:"100%",maxHeight:160,objectFit:"contain"}}/>
              </div>
            )}
            {/* PDF banner */}
            {doc.type?.includes("pdf")&&(
              <div style={{background:B.purple+"0D",borderBottom:"1px solid "+B.purple+"22",padding:"8px 12px",display:"flex",alignItems:"center",gap:8}}>
                <span style={{fontSize:18}}>📄</span>
                <span style={{fontSize:11,color:B.purple,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>PDF Document — click Open to view</span>
              </div>
            )}
            {/* File info + actions */}
            <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",flexWrap:"wrap"}}>
              {!doc.type?.includes("image")&&!doc.type?.includes("pdf")&&<span style={{fontSize:20}}>📎</span>}
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600,color:B.black,fontFamily:"'DM Sans',sans-serif",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{doc.name}</div>
                <div style={{fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif",marginTop:2}}>{fmtSize(doc.size)} · {new Date(doc.uploadedAt).toLocaleDateString()} · {doc.uploadedBy}</div>
              </div>
              <div style={{display:"flex",gap:6,flexShrink:0}}>
                {(doc.type?.includes("image")||doc.type?.includes("pdf"))&&(
                  <button onClick={()=>setPreviewDoc(doc)}
                    style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.blue+"44",background:B.blue+"0D",color:B.blue,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",cursor:"pointer"}}>
                    👁 Preview
                  </button>
                )}
                <a href={doc.dataUrl} download={doc.name}
                  style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.green+"44",background:B.green+"0D",color:B.green,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",textDecoration:"none"}}>
                  ↓ Download
                </a>
                {canEdit&&(
                  <button onClick={()=>removeDoc(docType)}
                    style={{padding:"4px 8px",borderRadius:6,border:"1px solid #FEE2E2",background:"#FFF5F5",cursor:"pointer",color:"#DC2626",fontSize:12,fontWeight:700}}>
                    ✕
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {!doc && (
          <div style={{marginTop:10,padding:"10px 14px",background:B.white,borderRadius:8,border:"1.5px dashed "+B.light,textAlign:"center",fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>
            {canEdit ? "No file uploaded yet" : "Not yet uploaded by agent"}
          </div>
        )}
      </div>
    );
  };

  const TabBtn = ({id,label,icon}) => (
    <button onClick={()=>setTab(id)}
      style={{padding:"8px 16px",borderRadius:"8px 8px 0 0",border:"none",cursor:"pointer",
        background: tab===id ? B.white : B.offWhite,
        borderBottom: tab===id ? "2px solid "+B.red : "2px solid transparent",
        fontSize:12,fontWeight:700,color:tab===id?B.red:B.silver,
        fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",gap:6}}>
      {icon} {label}
    </button>
  );

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1300,display:"flex",alignItems:"stretch",justifyContent:"flex-end"}}>
      <div style={{width:"min(560px,100vw)",background:B.white,display:"flex",flexDirection:"column",boxShadow:"-8px 0 40px rgba(0,0,0,0.2)",animation:"slideIn 0.25s ease"}}>

        {/* Header */}
        <div style={{padding:"20px 24px 0",borderBottom:"1px solid "+B.light,background:B.black,flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
            <div style={{display:"flex",alignItems:"center",gap:16}}>
              {/* Photo circle — click to upload if editable */}
              <div style={{position:"relative",flexShrink:0}}>
                <Avatar name={targetUser.name} role={targetUser.role} size={60} photo={photo}/>
                {canEdit && (
                  <>
                    <input type="file" accept="image/*" ref={photoRef} style={{display:"none"}}
                      onChange={e=>handlePhotoUpload(e.target.files)}/>
                    <button onClick={()=>photoRef.current?.click()}
                      title="Upload profile photo"
                      style={{position:"absolute",bottom:-2,right:-2,width:22,height:22,borderRadius:"50%",
                        background:B.red,border:"2px solid "+B.black,cursor:"pointer",
                        display:"flex",alignItems:"center",justifyContent:"center",
                        fontSize:11,color:B.white,lineHeight:1}}>
                      📷
                    </button>
                    {photo && (
                      <button onClick={()=>setPhoto(null)}
                        title="Remove photo"
                        style={{position:"absolute",top:-2,right:-2,width:18,height:18,borderRadius:"50%",
                          background:"#DC2626",border:"2px solid "+B.black,cursor:"pointer",
                          display:"flex",alignItems:"center",justifyContent:"center",
                          fontSize:9,color:B.white,lineHeight:1}}>
                        ✕
                      </button>
                    )}
                  </>
                )}
              </div>
              <div>
                <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>{targetUser.name}</h2>
                <div style={{display:"flex",alignItems:"center",gap:8,marginTop:5,flexWrap:"wrap"}}>
                  <RoleBadge role={targetUser.role}/>
                  {targetUser.licenseNo&&<span style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>Lic: {targetUser.licenseNo}</span>}
                  {isOwnProfile&&<span style={{fontSize:10,color:B.green,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>(Your Profile)</span>}
                  {!canEdit&&<span style={{fontSize:10,color:B.gold,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>View Only</span>}
                </div>
                {canEdit&&<div style={{fontSize:10,color:B.silver,marginTop:4,fontFamily:"'DM Sans',sans-serif"}}>Click 📷 to {photo?"change":"upload"} profile photo</div>}
              </div>
            </div>
            <button onClick={onClose} style={{background:"none",border:"none",color:B.silver,fontSize:22,cursor:"pointer",marginTop:-4}}>✕</button>
          </div>
          {!canEdit&&(
            <div style={{padding:"8px 12px",background:B.gold+"22",border:"1px solid "+B.gold+"44",borderRadius:8,fontSize:11,color:B.gold,fontFamily:"'DM Sans',sans-serif",fontWeight:600,marginBottom:12}}>
              👁 View only — only the agent or Principal Broker can edit this profile.
            </div>
          )}
          <div style={{display:"flex",gap:4}}>
            <TabBtn id="contact"   label="Contact Info"  icon="📋"/>
            <TabBtn id="emergency" label="Emergency"     icon="🚨"/>
            <TabBtn id="banking"   label="Banking & Tax" icon="🏦"/>
            <TabBtn id="fees"      label="Fees"          icon="💰"/>
            {isOwnProfile&&<TabBtn id="security" label="Security" icon="🔑"/>}
          </div>
        </div>

        {/* Body */}
        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>

          {/* ── CONTACT INFO TAB ── */}
          {tab==="contact"&&(
            <div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
                <div style={{gridColumn:"1/-1"}}>{F("Full Name","name")}</div>
                {F("Primary Phone","phone","tel")}
                {F("Email Address","email","email")}
                {F("License Number","licenseNo")}
                {F("Date of Birth","dob","date")}
                <div style={{gridColumn:"1/-1"}}>{F("Street Address","address")}</div>
                {F("City","city")}
                <div>
                  <label style={lbl}>State</label>
                  <select disabled={!canEdit} value={form.state} onChange={e=>set("state",e.target.value)} style={inp}>
                    {["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"].map(s=><option key={s}>{s}</option>)}
                  </select>
                </div>
                {F("ZIP Code","zip")}
              </div>
            </div>
          )}

          {/* ── EMERGENCY CONTACT TAB ── */}
          {tab==="emergency"&&(
            <div>
              <div style={{background:"#FFF5F5",border:"1px solid #FCA5A5",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:12,color:"#991B1B",fontFamily:"'DM Sans',sans-serif"}}>
                🚨 This information is used in case of emergency and is only visible to you and your broker.
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
                <div style={{gridColumn:"1/-1"}}>{F("Contact Name","name","text","emergency")}</div>
                {F("Relationship","relationship","text","emergency")}
                {F("Phone Number","phone","tel","emergency")}
                <div style={{gridColumn:"1/-1"}}>{F("Email Address","email","email","emergency")}</div>
              </div>
              {!emergency.name&&(
                <div style={{marginTop:8,padding:"14px 16px",background:B.offWhite,borderRadius:10,border:"1.5px dashed "+B.light,textAlign:"center",fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>
                  No emergency contact on file yet.
                </div>
              )}
            </div>
          )}

          {/* ── BANKING & TAX TAB ── */}
          {tab==="banking"&&(
            <div>
              <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:12,color:"#1E40AF",fontFamily:"'DM Sans',sans-serif"}}>
                🔒 Banking documents are confidential and only visible to you and your broker.
              </div>
              <input type="file" ref={fileRef} style={{display:"none"}} onChange={e=>handleDocUpload(uploading,e.target.files)}/>
              <DocRow docType="ach" label="ACH Direct Deposit Authorization" color={B.green}/>
              <DocRow docType="w9"  label="W-9 — Request for Taxpayer ID"    color={B.teal}/>
              <div style={{marginTop:4,fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif",lineHeight:1.6}}>
                <strong>ACH form</strong> allows commission payments to be deposited directly to your bank account.<br/>
                <strong>W-9</strong> is required by the IRS for all independent contractors earning $600+ per year.
              </div>
            </div>
          )}

          {tab==="fees"&&(
            <div>
              {!canEditFees ? (
                <div style={{background:B.gold+"11",border:"1px solid "+B.gold+"33",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:12,color:B.gold,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
                  🔒 Fee structure is set by your Principal Broker. Contact them to make changes.
                </div>
              ) : (
                <div style={{background:B.green+"11",border:"1px solid "+B.green+"33",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:12,color:B.green,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
                  ✏ You are editing this agent's fee structure. Changes apply to all future transactions.
                </div>
              )}

              {/* Standard fees */}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
                <div style={{marginBottom:14}}>
                  <label style={lbl}>Agent Split % <span style={{color:B.red,fontWeight:700}}>*</span></label>
                  <div style={{position:"relative"}}>
                    <input type="number" min="0" max="100" value={fees.agentSplit}
                      onChange={e=>setFee("agentSplit",Number(e.target.value))}
                      disabled={!canEditFees} style={{...inp,paddingRight:28}}/>
                    <span style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>%</span>
                  </div>
                  <div style={{fontSize:10,color:B.silver,marginTop:3,fontFamily:"'DM Sans',sans-serif"}}>Agent keeps {fees.agentSplit}% · Brokerage keeps {100-Number(fees.agentSplit)}%</div>
                </div>
                <div style={{marginBottom:14}}>
                  <label style={lbl}>Transaction Fee</label>
                  <div style={{position:"relative"}}>
                    <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>$</span>
                    <input type="number" min="0" value={fees.transactionFee}
                      onChange={e=>setFee("transactionFee",Number(e.target.value))}
                      disabled={!canEditFees} style={{...inp,paddingLeft:22}}/>
                  </div>
                  <div style={{fontSize:10,color:B.silver,marginTop:3,fontFamily:"'DM Sans',sans-serif"}}>Flat fee deducted per transaction</div>
                </div>
                <div style={{marginBottom:14}}>
                  <label style={lbl}>E&O Fee (Errors & Omissions)</label>
                  <div style={{position:"relative"}}>
                    <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>$</span>
                    <input type="number" min="0" value={fees.eoFee}
                      onChange={e=>setFee("eoFee",Number(e.target.value))}
                      disabled={!canEditFees} style={{...inp,paddingLeft:22}}/>
                  </div>
                  <div style={{fontSize:10,color:B.silver,marginTop:3,fontFamily:"'DM Sans',sans-serif"}}>E&O insurance contribution per transaction</div>
                </div>
              </div>

              {/* Custom fee lines */}
              {fees.customFees.length>0&&(
                <div style={{marginBottom:12}}>
                  <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:8,fontFamily:"'DM Sans',sans-serif"}}>Custom Fees</div>
                  {fees.customFees.map(f=>(
                    <div key={f.id} style={{display:"grid",gridTemplateColumns:"1fr 100px 80px 32px",gap:8,marginBottom:8,alignItems:"end"}}>
                      <div>
                        <label style={lbl}>Label</label>
                        <input value={f.label} onChange={e=>updateCustomLine(f.id,{label:e.target.value})}
                          disabled={!canEditFees} style={inp} placeholder="e.g. Admin Fee"/>
                      </div>
                      <div>
                        <label style={lbl}>Amount</label>
                        <input type="number" value={f.amount} onChange={e=>updateCustomLine(f.id,{amount:Number(e.target.value)})}
                          disabled={!canEditFees} style={inp}/>
                      </div>
                      <div>
                        <label style={lbl}>Type</label>
                        <select value={f.type} onChange={e=>updateCustomLine(f.id,{type:e.target.value})}
                          disabled={!canEditFees} style={inp}>
                          <option value="flat">$ Flat</option>
                          <option value="pct">% GCI</option>
                        </select>
                      </div>
                      {canEditFees&&<button onClick={()=>removeCustomLine(f.id)} style={{height:36,borderRadius:6,border:"1px solid #FEE2E2",background:"#FFF5F5",cursor:"pointer",color:"#DC2626",fontSize:14,alignSelf:"flex-end"}}>✕</button>}
                    </div>
                  ))}
                </div>
              )}
              {canEditFees&&(
                <button onClick={addCustomFeeLine}
                  style={{display:"flex",alignItems:"center",gap:6,padding:"8px 14px",borderRadius:8,border:"1.5px dashed "+B.light,background:"transparent",color:B.silver,cursor:"pointer",fontSize:12,fontFamily:"'DM Sans',sans-serif",marginBottom:16}}>
                  + Add Custom Fee
                </button>
              )}

              {/* Live preview */}
              <div style={{background:B.offWhite,borderRadius:10,padding:"14px 18px",border:"1px solid "+B.light}}>
                <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:10,fontFamily:"'DM Sans',sans-serif"}}>Preview — Example on $300,000 sale at 3% commission</div>
                {(()=>{
                  const ex = calcAgentNetFull(300000, 3, 0, fees);
                  return (
                    <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
                      {[["GCI",fmt(ex.gci),B.red],["Agent Split ("+fees.agentSplit+"%)",fmt(ex.split),B.blue],["Deductions",fmt(ex.txFee+ex.eoFee+ex.customTotal),"#DC2626"],["Agent Net",fmt(ex.agentNet),B.green],["Brokerage Keeps",fmt(ex.brokerageKeeps),B.black]].map(([l,v,c])=>(
                        <div key={l}><div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.06em",textTransform:"uppercase",marginBottom:2,fontFamily:"'DM Sans',sans-serif"}}>{l}</div><div style={{fontSize:14,fontWeight:800,color:c,fontFamily:"'Playfair Display',serif"}}>{v}</div></div>
                      ))}
                    </div>
                  );
                })()}
              </div>
            </div>
          )}

          {/* ── SECURITY TAB ── */}
          {tab==="security"&&isOwnProfile&&(
            <div>
              <div style={{background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:12,color:"#1E40AF",fontFamily:"'DM Sans',sans-serif"}}>
                🔑 Change your login password. You will remain logged in after changing.
              </div>

              {pwSuccess&&(
                <div style={{background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:10,padding:"12px 16px",marginBottom:16,fontSize:13,color:"#166534",fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
                  ✓ Password updated successfully!
                </div>
              )}
              {pwError&&(
                <div style={{background:"#FFF5F5",border:"1px solid #FCA5A5",borderRadius:10,padding:"12px 16px",marginBottom:16,fontSize:13,color:"#DC2626",fontFamily:"'DM Sans',sans-serif"}}>
                  ⚠ {pwError}
                </div>
              )}

              <div style={{marginBottom:14}}>
                <label style={lbl}>New Password</label>
                <input type="password" value={pwNew} onChange={e=>{setPwNew(e.target.value);setPwError("");setPwSuccess(false);}}
                  style={inp} placeholder="Minimum 8 characters"/>
              </div>
              <div style={{marginBottom:20}}>
                <label style={lbl}>Confirm New Password</label>
                <input type="password" value={pwConfirm} onChange={e=>{setPwConfirm(e.target.value);setPwError("");setPwSuccess(false);}}
                  style={inp} placeholder="Repeat new password"/>
              </div>

              {/* Password strength hints */}
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:20}}>
                {[["8+ chars",/^.{8,}$/.test(pwNew)],["Uppercase",/[A-Z]/.test(pwNew)],["Number",/[0-9]/.test(pwNew)]].map(([l,ok])=>(
                  <span key={l} style={{fontSize:11,padding:"2px 10px",borderRadius:12,
                    background:ok?"#F0FDF4":"#F5F4F2",color:ok?B.green:B.silver,
                    border:"1px solid "+(ok?"#86EFAC":B.light),
                    fontFamily:"'DM Sans',sans-serif",fontWeight:700}}>
                    {ok?"✓":"○"} {l}
                  </span>
                ))}
              </div>

              <button onClick={handleChangePassword} disabled={pwLoading||!pwNew||!pwConfirm}
                style={{width:"100%",padding:"12px",borderRadius:10,border:"none",
                  background:pwLoading||!pwNew||!pwConfirm?B.light:B.red,
                  color:pwLoading||!pwNew||!pwConfirm?B.silver:B.white,
                  cursor:pwLoading||!pwNew||!pwConfirm?"not-allowed":"pointer",
                  fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
                {pwLoading?"Updating…":"Update Password"}
              </button>
            </div>
          )}

        </div>

        {/* Footer */}
        <div style={{padding:"16px 24px",borderTop:"1px solid "+B.light,display:"flex",justifyContent:"flex-end",gap:10,background:B.offWhite,flexShrink:0}}>
          <button onClick={onClose} style={{padding:"10px 20px",borderRadius:8,border:"1px solid "+B.light,background:B.white,cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>Close</button>
          {canEdit&&tab!=="security"&&<button onClick={handleSave} disabled={savingProfile} style={{padding:"10px 24px",borderRadius:8,border:"none",background:savingProfile?B.light:B.red,color:savingProfile?B.silver:B.white,cursor:savingProfile?"wait":"pointer",fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>{savingProfile?"Saving…":"Save Profile"}</button>}
        </div>
      </div>
      {previewDoc&&<DocPreviewModal doc={previewDoc} onClose={()=>setPreviewDoc(null)}/>}
    </div>
  );
}

// ─── User Management Panel ────────────────────────────────────────────────────
function UserManagementPanel({ users, currentUser, onUpdateUsers, onClose, onViewProfile, onInviteUser, onDeleteUser }) {
  const [userList, setUserList] = useState(users);
  const [showForm, setShowForm] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [form, setForm] = useState({ name:"", role:"realtor", brokerId:"", licenseNo:"", email:"", phone:"" });

  const isPrincipal = currentUser.role === "principal_broker";
  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  function openAdd() { setForm({name:"",role:"realtor",brokerId:"",licenseNo:"",email:"",phone:""}); setEditUser(null); setShowForm(true); }
  function openEdit(u) { setForm({name:u.name,role:u.role,brokerId:u.brokerId||"",licenseNo:u.licenseNo||"",email:u.email||"",phone:u.phone||""}); setEditUser(u); setShowForm(true); }

  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [inviteSent, setInviteSent] = useState(false);

  async function saveUser() {
    if (!form.name.trim()) return;
    if (!editUser && !form.email.trim()) { setSaveError("Email is required to invite a new user."); return; }
    setSaving(true); setSaveError("");
    const principalId = userList.find(u=>u.role==="principal_broker")?.id || null;
    const brokerId = form.role==="principal_broker" ? null : (form.brokerId || principalId);

    if (editUser) {
      // Editing existing user — update profile only
      if (onInviteUser) {
        try {
          await onInviteUser({ action:"update", userId:editUser.id, ...form, brokerId });
        } catch(e) { setSaveError(e.message); setSaving(false); return; }
      }
      setUserList(prev => prev.map(u => u.id===editUser.id ? {...u,...form,brokerId} : u));
      setShowForm(false);
    } else {
      // New user — send Supabase invitation email
      if (onInviteUser) {
        try {
          const newUser = await onInviteUser({ action:"invite", ...form, brokerId });
          if (newUser) setUserList(prev => [...prev, newUser]);
          setInviteSent(true);
          setTimeout(() => { setInviteSent(false); setShowForm(false); }, 3000);
        } catch(e) { setSaveError(e.message||"Failed to send invitation."); setSaving(false); return; }
      } else {
        // Local mode fallback
        setUserList(prev => [...prev, {id:genId(),...form,brokerId}]);
        setShowForm(false);
      }
    }
    setSaving(false);
  }

  const [deletingId, setDeletingId] = useState(null);

  async function removeUser(id) {
    if (id === currentUser.id) { alert("You cannot remove yourself."); return; }
    if (!window.confirm("Permanently remove this user? Their transactions will remain, but this cannot be undone.")) return;
    if (!onDeleteUser) { setUserList(prev => prev.filter(u => u.id !== id)); return; }
    setDeletingId(id);
    try {
      await onDeleteUser(id);
      setUserList(prev => prev.filter(u => u.id !== id));
    } catch(e) {
      alert("Could not remove user: " + e.message);
    } finally {
      setDeletingId(null);
    }
  }

  const brokers = userList.filter(u => u.role==="principal_broker"||u.role==="associate_broker");
  const inputSt = {width:"100%",padding:"8px 11px",borderRadius:7,border:`1px solid ${B.light}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",background:B.offWhite,outline:"none",color:B.black,boxSizing:"border-box"};
  const labelSt = {fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",display:"block",marginBottom:4,fontFamily:"'DM Sans',sans-serif"};

  // Group display: principal → associate brokers → realtors per broker
  const principal = userList.find(u=>u.role==="principal_broker");
  const assocBrokers = userList.filter(u=>u.role==="associate_broker");
  const unassignedRealtors = userList.filter(u=>u.role==="realtor"&&(u.brokerId===principal?.id||!u.brokerId));

  const UserRow = ({u, indent=0}) => (
    <div style={{display:"flex",alignItems:"center",gap:12,padding:"12px 16px",background:B.white,borderRadius:10,border:`1px solid ${B.light}`,marginBottom:8,marginLeft:indent}}>
      <Avatar name={u.name} role={u.role} size={38} photo={u.photo||null}/>
      <div style={{flex:1,minWidth:0}}>
        <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          <span style={{fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{u.name}</span>
          <RoleBadge role={u.role}/>
          {u.id===currentUser.id&&<span style={{fontSize:10,color:B.green,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>(You)</span>}
        </div>
        <div style={{fontSize:11,color:B.silver,marginTop:3,fontFamily:"'DM Sans',sans-serif",display:"flex",gap:16,flexWrap:"wrap"}}>
          {u.licenseNo&&<span>License: {u.licenseNo}</span>}
          {u.email&&<span>{u.email}</span>}
          {u.phone&&<span>{u.phone}</span>}
        </div>
      </div>
      <div style={{display:"flex",gap:6}}>
        {onViewProfile&&<button onClick={()=>onViewProfile(u)} style={{padding:"5px 12px",borderRadius:6,border:"1px solid "+B.teal+"44",background:B.teal+"11",cursor:"pointer",fontSize:11,color:B.teal,fontFamily:"'DM Sans',sans-serif"}}>👤 Profile</button>}
        {isPrincipal&&<button onClick={()=>openEdit(u)} style={{padding:"5px 12px",borderRadius:6,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>Edit</button>}
        {isPrincipal&&u.id!==currentUser.id&&<button onClick={()=>removeUser(u.id)} disabled={deletingId===u.id} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #FEE2E2",background:"#FFF5F5",cursor:deletingId===u.id?"default":"pointer",fontSize:11,color:"#DC2626",opacity:deletingId===u.id?0.5:1}}>{deletingId===u.id?"…":"✕"}</button>}
      </div>
    </div>
  );

  return (
    <div onClick={()=>{if(!showForm)onClose();}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1200,display:"flex",alignItems:"stretch",justifyContent:"flex-end"}}>
      <div onClick={e=>e.stopPropagation()} style={{width:"min(640px,100vw)",background:B.white,display:"flex",flexDirection:"column",boxShadow:"-8px 0 40px rgba(0,0,0,0.2)",animation:"slideIn 0.25s ease"}}>
        <style>{`@keyframes slideIn{from{transform:translateX(100%)}to{transform:translateX(0)}}`}</style>
        {/* Header */}
        <div style={{padding:"20px 24px",borderBottom:`1px solid ${B.light}`,background:B.black,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:10,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif",marginBottom:4}}>Brokerage Management</div>
            <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>Team & Roles</h2>
          </div>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            {isPrincipal&&<button onClick={openAdd} style={{padding:"8px 16px",borderRadius:8,border:"none",background:B.red,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>+ Add User</button>}
            <button onClick={()=>{onUpdateUsers(userList);onClose();}} style={{background:"none",border:"none",color:B.silver,fontSize:22,cursor:"pointer"}}>✕</button>
          </div>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
          {/* Add/Edit form */}
          {showForm&&(
            <div style={{background:B.offWhite,borderRadius:12,padding:20,marginBottom:24,border:`1px solid ${B.light}`}}>
              <div style={{fontSize:13,fontWeight:700,color:B.black,marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>{editUser?"Edit User":"Invite New User"}</div>
              {!editUser&&<div style={{fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif",marginBottom:16}}>An invitation email will be sent to the address below. They'll click the link to set their password and access the app.</div>}
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
                <div style={{gridColumn:"1/-1"}}><label style={labelSt}>Full Name *</label><input value={form.name} onChange={e=>set("name",e.target.value)} style={inputSt} placeholder="First Last"/></div>
                <div>
                  <label style={labelSt}>Role *</label>
                  <select value={form.role} onChange={e=>set("role",e.target.value)} style={inputSt}>
                    <option value="realtor">Realtor®</option>
                    <option value="associate_broker">Associate Broker</option>
                    {isPrincipal&&<option value="principal_broker">Principal Broker</option>}
                  </select>
                </div>
                <div>
                  <label style={labelSt}>Assigned Broker</label>
                  <select value={form.brokerId} onChange={e=>set("brokerId",e.target.value)} style={inputSt} disabled={form.role==="principal_broker"}>
                    {brokers.map(b=><option key={b.id} value={b.id}>{b.name}{b.role==="principal_broker"?" (Principal Broker)":""}</option>)}
                  </select>
                </div>
                <div><label style={labelSt}>License No.</label><input value={form.licenseNo} onChange={e=>set("licenseNo",e.target.value)} style={inputSt} placeholder="AL-XXXXXX"/></div>
                <div><label style={labelSt}>Phone</label><input value={form.phone} onChange={e=>set("phone",e.target.value)} style={inputSt} placeholder="205-555-0100"/></div>
                <div style={{gridColumn:"1/-1"}}><label style={labelSt}>Email</label><input value={form.email} onChange={e=>set("email",e.target.value)} style={inputSt} placeholder="name@aksrealtygroup.com"/></div>
              </div>
              {saveError&&(
                <div style={{padding:"8px 12px",background:"#FFF5F5",border:"1px solid #FCA5A5",borderRadius:8,fontSize:12,color:"#DC2626",fontFamily:"'DM Sans',sans-serif",marginBottom:10}}>
                  ⚠ {saveError}
                </div>
              )}
              {inviteSent&&(
                <div style={{padding:"8px 12px",background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:8,fontSize:12,color:B.green,fontFamily:"'DM Sans',sans-serif",marginBottom:10}}>
                  ✓ Invitation sent to {form.email}! They'll receive an email to set their password.
                </div>
              )}
              <div style={{display:"flex",gap:8}}>
                <button onClick={saveUser} disabled={saving}
                  style={{padding:"9px 20px",borderRadius:8,border:"none",background:saving?B.light:B.red,color:saving?B.silver:B.white,cursor:saving?"not-allowed":"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
                  {saving ? "Sending…" : editUser ? "Save Changes" : "Send Invitation"}
                </button>
                <button onClick={()=>{setShowForm(false);setSaveError("");}} style={{padding:"9px 14px",borderRadius:8,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:12,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>Cancel</button>
              </div>
            </div>
          )}

          {/* Org chart style display */}
          {/* Principal */}
          {principal&&(
            <div style={{marginBottom:20}}>
              <div style={{fontSize:10,fontWeight:700,color:B.red,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:10,fontFamily:"'DM Sans',sans-serif"}}>👑 Principal Broker</div>
              <UserRow u={principal}/>
            </div>
          )}

          {/* Associate Brokers + their Realtors */}
          {assocBrokers.map(ab=>{
            const myRealtors = userList.filter(u=>u.role==="realtor"&&u.brokerId===ab.id);
            return(
              <div key={ab.id} style={{marginBottom:20}}>
                <div style={{fontSize:10,fontWeight:700,color:B.teal,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:10,fontFamily:"'DM Sans',sans-serif"}}>🏢 Associate Broker — {ab.name}'s Team</div>
                <UserRow u={ab}/>
                {myRealtors.map(r=>(
                  <div key={r.id} style={{marginLeft:24,position:"relative"}}>
                    <div style={{position:"absolute",left:-16,top:20,width:12,height:1,background:B.light}}/>
                    <UserRow u={r} indent={0}/>
                  </div>
                ))}
                {myRealtors.length===0&&<div style={{marginLeft:24,fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif",fontStyle:"italic",marginBottom:8}}>No realtors assigned to this broker yet.</div>}
              </div>
            );
          })}

          {/* Realtors directly under principal */}
          {unassignedRealtors.length>0&&(
            <div style={{marginBottom:20}}>
              <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:10,fontFamily:"'DM Sans',sans-serif"}}>🏠 Realtors (Direct to Principal)</div>
              {unassignedRealtors.map(r=><UserRow key={r.id} u={r}/>)}
            </div>
          )}

          {/* Summary */}
          <div style={{background:B.offWhite,borderRadius:10,padding:"14px 18px",display:"flex",gap:24,flexWrap:"wrap"}}>
            {[
              ["Principal Brokers", userList.filter(u=>u.role==="principal_broker").length, B.red],
              ["Associate Brokers", userList.filter(u=>u.role==="associate_broker").length, B.teal],
              ["Realtors®",         userList.filter(u=>u.role==="realtor").length,          B.silver],
              ["Total Team",        userList.length, B.black],
            ].map(([l,v,c])=>(
              <div key={l}><div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif"}}>{l}</div><div style={{fontSize:20,fontWeight:800,color:c,fontFamily:"'Playfair Display',serif"}}>{v}</div></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Checklist Template Panel ──────────────────────────────────────────────────
const CHECKLIST_CATEGORIES = ["Disclosure","Agency","Finance","Contract","Inspection","Closing","Other"];

function ChecklistTemplatePanel({ templates, currentUser, onClose, onCreate, onUpdate, onDelete, onSync }) {
  const [list, setList] = useState(templates);
  const [showForm, setShowForm] = useState(false);
  const [editTpl, setEditTpl] = useState(null);
  const blankForm = { title:"", mandatory:true, side:"Both", category:"Contract", description:"" };
  const [form, setForm] = useState(blankForm);
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [deletingId, setDeletingId] = useState(null);

  const isPrincipal = currentUser.role === "principal_broker";
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const inputSt = {width:"100%",padding:"8px 11px",borderRadius:7,border:`1px solid ${B.light}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",background:B.offWhite,outline:"none",color:B.black,boxSizing:"border-box"};
  const labelSt = {fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",display:"block",marginBottom:4,fontFamily:"'DM Sans',sans-serif"};

  function openAdd() { setForm(blankForm); setEditTpl(null); setShowForm(true); }
  function openEdit(t) { setForm({title:t.title,mandatory:t.mandatory,side:t.side,category:t.category,description:t.description}); setEditTpl(t); setShowForm(true); }

  async function saveTemplate() {
    if (!form.title.trim()) return;
    setSaving(true); setSaveError("");
    try {
      if (editTpl) {
        if (onUpdate) {
          const updated = await onUpdate(editTpl.id, form);
          setList(prev => prev.map(t => t.id===editTpl.id ? updated : t));
        } else {
          setList(prev => prev.map(t => t.id===editTpl.id ? {...t,...form} : t));
        }
      } else {
        const sortOrder = list.length ? Math.max(...list.map(t=>t.sortOrder||0))+1 : 0;
        if (onCreate) {
          const created = await onCreate({ ...form, sortOrder, active:true });
          setList(prev => [...prev, created]);
        } else {
          setList(prev => [...prev, { id:genId(), ...form, sortOrder, active:true }]);
        }
      }
      setShowForm(false);
    } catch(e) { setSaveError(e.message||"Failed to save."); }
    setSaving(false);
  }

  async function toggleActive(t) {
    try {
      if (onUpdate) {
        const updated = await onUpdate(t.id, { active: !t.active });
        setList(prev => prev.map(x => x.id===t.id ? updated : x));
      } else {
        setList(prev => prev.map(x => x.id===t.id ? {...x,active:!x.active} : x));
      }
    } catch(e) { alert("Could not update: "+e.message); }
  }

  async function removeTemplate(t) {
    if (!window.confirm(`Delete "${t.title}" from the checklist? This won't affect existing transactions.`)) return;
    setDeletingId(t.id);
    try {
      if (onDelete) await onDelete(t.id);
      setList(prev => prev.filter(x => x.id!==t.id));
    } catch(e) { alert("Could not delete: "+e.message); }
    setDeletingId(null);
  }

  async function move(t, dir) {
    const sorted = [...list].sort((a,b)=>(a.sortOrder||0)-(b.sortOrder||0));
    const idx = sorted.findIndex(x=>x.id===t.id);
    const swapIdx = idx+dir;
    if (swapIdx<0 || swapIdx>=sorted.length) return;
    const other = sorted[swapIdx];
    try {
      if (onUpdate) {
        const [u1,u2] = await Promise.all([
          onUpdate(t.id, {sortOrder:other.sortOrder}),
          onUpdate(other.id, {sortOrder:t.sortOrder}),
        ]);
        setList(prev => prev.map(x => x.id===u1.id?u1:x.id===u2.id?u2:x));
      } else {
        setList(prev => prev.map(x => x.id===t.id?{...x,sortOrder:other.sortOrder}:x.id===other.id?{...x,sortOrder:t.sortOrder}:x));
      }
    } catch(e) { alert("Could not reorder: "+e.message); }
  }

  const sortedList = [...list].sort((a,b)=>(a.sortOrder||0)-(b.sortOrder||0));

  return (
    <div onClick={()=>{if(!showForm)onClose();}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1200,display:"flex",alignItems:"stretch",justifyContent:"flex-end"}}>
      <div onClick={e=>e.stopPropagation()} style={{width:"min(680px,100vw)",background:B.white,display:"flex",flexDirection:"column",boxShadow:"-8px 0 40px rgba(0,0,0,0.2)",animation:"slideIn 0.25s ease"}}>
        <style>{`@keyframes slideIn{from{transform:translateX(100%)}to{transform:translateX(0)}}`}</style>
        <div style={{padding:"20px 24px",borderBottom:`1px solid ${B.light}`,background:B.black,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:10,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif",marginBottom:4}}>Brokerage Settings</div>
            <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>Checklist Templates</h2>
          </div>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            {isPrincipal&&<button onClick={openAdd} style={{padding:"8px 16px",borderRadius:8,border:"none",background:B.red,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>+ Add Item</button>}
            <button onClick={()=>{onSync&&onSync(list);onClose();}} style={{background:"none",border:"none",color:B.silver,fontSize:22,cursor:"pointer"}}>✕</button>
          </div>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
          <div style={{fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif",marginBottom:16}}>
            These items are added to every new transaction's document checklist automatically (filtered by Buyer/Seller side). Editing or deactivating an item only affects transactions created from now on — existing checklists don't change.
          </div>

          {showForm&&(
            <div style={{background:B.offWhite,borderRadius:12,padding:20,marginBottom:24,border:`1px solid ${B.light}`}}>
              <div style={{fontSize:13,fontWeight:700,color:B.black,marginBottom:16,fontFamily:"'DM Sans',sans-serif"}}>{editTpl?"Edit Checklist Item":"Add Checklist Item"}</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
                <div style={{gridColumn:"1/-1"}}><label style={labelSt}>Title *</label><input value={form.title} onChange={e=>set("title",e.target.value)} style={inputSt} placeholder="e.g. Termite Letter"/></div>
                <div>
                  <label style={labelSt}>Side</label>
                  <select value={form.side} onChange={e=>set("side",e.target.value)} style={inputSt}>
                    <option value="Both">Both</option><option value="Buyer">Buyer</option><option value="Seller">Seller</option>
                  </select>
                </div>
                <div>
                  <label style={labelSt}>Category</label>
                  <select value={form.category} onChange={e=>set("category",e.target.value)} style={inputSt}>
                    {CHECKLIST_CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div style={{gridColumn:"1/-1",display:"flex",alignItems:"center",gap:8}}>
                  <input type="checkbox" id="tpl_mandatory" checked={form.mandatory} onChange={e=>set("mandatory",e.target.checked)}/>
                  <label htmlFor="tpl_mandatory" style={{fontSize:12,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>Mandatory (blocks closing until a document is attached)</label>
                </div>
                <div style={{gridColumn:"1/-1"}}>
                  <label style={labelSt}>Description</label>
                  <textarea value={form.description} onChange={e=>set("description",e.target.value)} style={{...inputSt,minHeight:60,resize:"vertical"}} placeholder="Shown to agents when they expand this checklist item"/>
                </div>
              </div>
              {saveError&&<div style={{fontSize:12,color:"#DC2626",marginBottom:10,fontFamily:"'DM Sans',sans-serif"}}>{saveError}</div>}
              <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                <button onClick={()=>setShowForm(false)} style={{padding:"8px 16px",borderRadius:8,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:12,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>Cancel</button>
                <button onClick={saveTemplate} disabled={saving} style={{padding:"8px 18px",borderRadius:8,border:"none",background:saving?B.light:B.red,color:saving?B.silver:B.white,cursor:saving?"wait":"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>{saving?"Saving…":(editTpl?"Save Changes":"Add Item")}</button>
              </div>
            </div>
          )}

          {sortedList.map((t,i) => (
            <div key={t.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 16px",background:t.active===false?B.offWhite:B.white,borderRadius:10,border:`1px solid ${B.light}`,marginBottom:8,opacity:t.active===false?0.6:1}}>
              <div style={{display:"flex",flexDirection:"column",gap:2}}>
                <button onClick={()=>move(t,-1)} disabled={i===0} style={{border:"none",background:"none",cursor:i===0?"default":"pointer",color:i===0?B.light:B.silver,fontSize:11,padding:0}}>▲</button>
                <button onClick={()=>move(t,1)} disabled={i===sortedList.length-1} style={{border:"none",background:"none",cursor:i===sortedList.length-1?"default":"pointer",color:i===sortedList.length-1?B.light:B.silver,fontSize:11,padding:0}}>▼</button>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                  <span style={{fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{t.title}</span>
                  {t.mandatory&&<span style={{fontSize:9,fontWeight:700,color:B.red,background:B.red+"11",border:"1px solid "+B.red+"33",borderRadius:20,padding:"2px 8px",fontFamily:"'DM Sans',sans-serif"}}>MANDATORY</span>}
                  <span style={{fontSize:9,fontWeight:700,color:CATEGORY_COLORS[t.category]||B.silver,background:(CATEGORY_COLORS[t.category]||B.silver)+"11",border:"1px solid "+(CATEGORY_COLORS[t.category]||B.silver)+"33",borderRadius:20,padding:"2px 8px",fontFamily:"'DM Sans',sans-serif"}}>{t.category}</span>
                  <span style={{fontSize:9,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{t.side}</span>
                  {t.active===false&&<span style={{fontSize:9,fontWeight:700,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>INACTIVE</span>}
                </div>
                {t.description&&<div style={{fontSize:11,color:B.silver,marginTop:3,fontFamily:"'DM Sans',sans-serif"}}>{t.description}</div>}
              </div>
              {isPrincipal&&(
                <div style={{display:"flex",gap:6,flexShrink:0}}>
                  <button onClick={()=>toggleActive(t)} style={{padding:"5px 10px",borderRadius:6,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{t.active===false?"Activate":"Deactivate"}</button>
                  <button onClick={()=>openEdit(t)} style={{padding:"5px 10px",borderRadius:6,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>Edit</button>
                  <button onClick={()=>removeTemplate(t)} disabled={deletingId===t.id} style={{padding:"5px 10px",borderRadius:6,border:"1px solid #FEE2E2",background:"#FFF5F5",cursor:deletingId===t.id?"default":"pointer",fontSize:11,color:"#DC2626",opacity:deletingId===t.id?0.5:1}}>{deletingId===t.id?"…":"✕"}</button>
                </div>
              )}
            </div>
          ))}
          {sortedList.length===0&&(
            <div style={{textAlign:"center",padding:"32px 0",color:B.silver,fontSize:12,fontStyle:"italic",fontFamily:"'DM Sans',sans-serif"}}>No checklist items yet. Add one above.</div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Branding Panel ─────────────────────────────────────────────────────────
function BrandingPanel({ brokerage, currentUser, users, transactions, onClose, onUpdate, onUploadLogo }) {
  const [name, setName] = useState(brokerage?.name || "");
  const [saving, setSaving] = useState(false);
  const [saveError, setSaveError] = useState("");
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [logoUrl, setLogoUrl] = useState(brokerage?.logoUrl || null);
  const fileRef = useRef();

  const isPrincipal = currentUser.role === "principal_broker";
  const inputSt = {width:"100%",padding:"8px 11px",borderRadius:7,border:`1px solid ${B.light}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",background:B.offWhite,outline:"none",color:B.black,boxSizing:"border-box"};
  const labelSt = {fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",display:"block",marginBottom:4,fontFamily:"'DM Sans',sans-serif"};

  async function handleLogoSelect(e) {
    const file = e.target.files?.[0];
    if (!file || !brokerage) return;
    setUploadingLogo(true);
    try {
      if (onUploadLogo) {
        const updated = await onUploadLogo(brokerage.id, file);
        setLogoUrl(updated.logoUrl);
      } else {
        setLogoUrl(URL.createObjectURL(file)); // local-mode preview only
      }
    } catch(e) { alert("Could not upload logo: "+e.message); }
    setUploadingLogo(false);
    if (fileRef.current) fileRef.current.value = "";
  }

  async function handleSave() {
    if (!name.trim() || !brokerage) return;
    setSaving(true); setSaveError("");
    try {
      if (onUpdate) await onUpdate(brokerage.id, { name });
    } catch(e) { setSaveError(e.message||"Failed to save."); setSaving(false); return; }
    setSaving(false);
    onClose();
  }

  const isDirty = name !== (brokerage?.name || "");

  return (
    <div onClick={()=>{if(!isDirty)onClose();}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1200,display:"flex",alignItems:"stretch",justifyContent:"flex-end"}}>
      <div onClick={e=>e.stopPropagation()} style={{width:"min(520px,100vw)",background:B.white,display:"flex",flexDirection:"column",boxShadow:"-8px 0 40px rgba(0,0,0,0.2)",animation:"slideIn 0.25s ease"}}>
        <style>{`@keyframes slideIn{from{transform:translateX(100%)}to{transform:translateX(0)}}`}</style>
        <div style={{padding:"20px 24px",borderBottom:`1px solid ${B.light}`,background:B.black,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:10,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif",marginBottom:4}}>Brokerage Settings</div>
            <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>Branding</h2>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:B.silver,fontSize:22,cursor:"pointer"}}>✕</button>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
          {!isPrincipal ? (
            <div style={{fontSize:12,color:B.silver,fontStyle:"italic",fontFamily:"'DM Sans',sans-serif"}}>Only the principal broker can edit branding.</div>
          ) : !brokerage ? (
            <div style={{fontSize:12,color:B.silver,fontStyle:"italic",fontFamily:"'DM Sans',sans-serif"}}>Branding isn't available in local/demo mode.</div>
          ) : (
            <>
              <div style={{fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif",marginBottom:20}}>
                Shown on the login screen and throughout the app for everyone at your brokerage.
              </div>

              <div style={{marginBottom:24,padding:"14px 16px",borderRadius:10,background:B.offWhite,border:`1px solid ${B.light}`}}>
                <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",marginBottom:10,fontFamily:"'DM Sans',sans-serif"}}>Plan &amp; Limits</div>
                <div style={{display:"flex",flexDirection:"column",gap:8}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:12.5,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>Team members</span>
                    <span style={{fontSize:12.5,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>
                      {(users||[]).length}{brokerage.maxUsers!=null?` / ${brokerage.maxUsers}`:" · Unlimited"}
                    </span>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:12.5,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>Transactions</span>
                    <span style={{fontSize:12.5,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>
                      {(transactions||[]).length}{brokerage.maxTransactions!=null?` / ${brokerage.maxTransactions}`:" · Unlimited"}
                    </span>
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <span style={{fontSize:12.5,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>🧞 Transaction Genie</span>
                    {brokerage.documentImportQuota>0 ? (
                      <span style={{fontSize:12.5,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>
                        {Math.max(0,brokerage.documentImportQuota-brokerage.documentImportUsed)} / {brokerage.documentImportQuota} remaining
                      </span>
                    ) : (
                      <span style={{fontSize:10.5,fontWeight:700,padding:"3px 10px",borderRadius:20,fontFamily:"'DM Sans',sans-serif",background:B.light,color:B.silver}}>
                        Not purchased
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div style={{marginBottom:20}}>
                <label style={labelSt}>Logo</label>
                <div style={{display:"flex",alignItems:"center",gap:14}}>
                  <div style={{width:64,height:64,borderRadius:"50%",overflow:"hidden",background:B.offWhite,border:`1px solid ${B.light}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    {logoUrl ? <img src={logoUrl} alt="Logo" style={{width:"100%",height:"100%",objectFit:"cover"}}/> : <span style={{fontSize:24}}>🏠</span>}
                  </div>
                  <div>
                    <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" onChange={handleLogoSelect} style={{display:"none"}} id="logo_upload"/>
                    <button type="button" onClick={()=>fileRef.current?.click()} disabled={uploadingLogo}
                      style={{padding:"7px 14px",borderRadius:8,border:`1px solid ${B.light}`,background:B.white,cursor:uploadingLogo?"wait":"pointer",fontSize:12,fontWeight:700,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>
                      {uploadingLogo?"Uploading…":"Upload Logo"}
                    </button>
                    <div style={{fontSize:10,color:B.silver,marginTop:6,fontFamily:"'DM Sans',sans-serif"}}>PNG, JPEG, WebP, or SVG — up to 2MB</div>
                  </div>
                </div>
              </div>

              <div style={{marginBottom:20}}>
                <label style={labelSt}>Brokerage Name</label>
                <input value={name} onChange={e=>setName(e.target.value)} style={inputSt} placeholder="e.g. AKS Realty Group"/>
              </div>

              {/* Primary color picker hidden for now — saved but not yet wired into
                  the app's styling anywhere, so it had no visible effect. Revisit
                  once the app's colors are theme-able. */}

              {saveError&&<div style={{fontSize:12,color:"#DC2626",marginBottom:14,fontFamily:"'DM Sans',sans-serif"}}>{saveError}</div>}

              <button onClick={handleSave} disabled={saving} style={{padding:"10px 22px",borderRadius:8,border:"none",background:saving?B.light:B.red,color:saving?B.silver:B.white,cursor:saving?"wait":"pointer",fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
                {saving?"Saving…":"Save Changes"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Review Log ───────────────────────────────────────────────────────────────
function ReviewLog({ log }) {
  if (!log||log.length===0) return null;
  const meta = {
    submitted:         {icon:"📤",label:"Submitted for Review",color:B.gold},
    changes_requested: {icon:"↩", label:"Changes Requested",   color:"#DC2626"},
    resubmitted:       {icon:"📤",label:"Resubmitted",          color:B.gold},
    approved:          {icon:"✓", label:"Approved",             color:B.teal},
    closed:            {icon:"🏁",label:"Closed",               color:B.green},
    reopened:          {icon:"↩", label:"Reopened",             color:"#D97706"},
    voided:            {icon:"✕", label:"Voided by Agent",      color:"#7C3AED"},
    archived:          {icon:"📦",label:"Archived",               color:"#92400E"},
    restored:          {icon:"↩", label:"Restored from Archive",  color:B.teal},
    self_approved:     {icon:"✓", label:"Self-Approved (Broker)",color:B.green},
  };
  return (
    <div style={{marginBottom:20}}>
      <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:12,fontFamily:"'DM Sans',sans-serif"}}>Review History</div>
      <div style={{position:"relative",paddingLeft:24}}>
        <div style={{position:"absolute",left:8,top:0,bottom:0,width:2,background:B.light,borderRadius:2}}/>
        {[...log].reverse().map(entry=>{
          const m=meta[entry.action]||{icon:"•",label:entry.action,color:B.silver};
          return(
            <div key={entry.id} style={{position:"relative",marginBottom:14}}>
              <div style={{position:"absolute",left:-20,top:3,width:16,height:16,borderRadius:"50%",background:m.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#fff",fontWeight:900}}>{m.icon}</div>
              <div style={{background:B.white,border:`1px solid ${m.color}44`,borderRadius:10,padding:"10px 14px"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                  <span style={{fontSize:12,fontWeight:700,color:m.color,fontFamily:"'DM Sans',sans-serif"}}>{m.label}</span>
                  <span style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{fmtTS(entry.at)}</span>
                </div>
                <div style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{entry.byName}</div>
                {entry.comment&&<div style={{fontSize:12,color:B.black,marginTop:8,padding:"8px 12px",background:m.color+"0D",borderRadius:8,fontFamily:"'DM Sans',sans-serif",borderLeft:`3px solid ${m.color}`,fontStyle:"italic"}}>"{entry.comment}"</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── Broker Review Modal ──────────────────────────────────────────────────────
function BrokerReviewModal({ tx, currentUser, users, onAction, onClose }) {
  const [comment, setComment] = useState("");
  const [action, setAction] = useState(null);
  const [previewDoc, setPreviewDoc] = useState(null);
  const agent = users.find(u=>u.id===tx.agentId);
  const assignedBroker = getAssignedBroker(tx.agentId, users);
  const isPrincipalSteppingIn = currentUser.role==="principal_broker" && assignedBroker && assignedBroker.id!==currentUser.id;

  function submit() {
    if(!action) return;
    if(!comment.trim()&&action==="request_changes"){alert("Please provide a reason for requesting changes.");return;}
    onAction(tx.id,action,comment.trim());
    onClose();
  }

  const inputSt={width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${B.light}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",background:B.offWhite,outline:"none",color:B.black,boxSizing:"border-box"};
  const labelSt={fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",display:"block",marginBottom:6,fontFamily:"'DM Sans',sans-serif"};

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1200,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:B.white,borderRadius:16,width:"100%",maxWidth:680,maxHeight:"90vh",display:"flex",flexDirection:"column",boxShadow:"0 24px 60px rgba(0,0,0,0.3)",overflow:"hidden"}}>
        <div style={{background:B.black,padding:"20px 24px",display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexShrink:0}}>
          <div>
            <div style={{fontSize:10,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif",marginBottom:4}}>Broker Review</div>
            <h2 style={{margin:0,fontSize:17,fontFamily:"'Playfair Display',serif",color:B.white}}>{tx.address.split(",")[0]}</h2>
            <div style={{display:"flex",alignItems:"center",gap:8,marginTop:6,flexWrap:"wrap"}}>
              <SideBadge side={tx.side}/>
              {agent&&<span style={{fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{agent.name}</span>}
              {agent&&<RoleBadge role={agent.role}/>}
            </div>
            {isPrincipalSteppingIn&&(
              <div style={{marginTop:8,fontSize:11,color:B.gold,fontFamily:"'DM Sans',sans-serif',fontWeight:600"}}>
                ⚡ Stepping in — assigned broker: {assignedBroker.name}
              </div>
            )}
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:B.silver,fontSize:20,cursor:"pointer"}}>✕</button>
        </div>
        <div style={{padding:"20px 24px",overflowY:"auto",flex:1}}>
          <div style={{marginBottom:20}}>
            <div style={{fontSize:11,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:10,fontFamily:"'DM Sans',sans-serif"}}>Required Documents</div>
            {[...(tx.tasks||[])].filter(t=>t.mandatory).map(t=>{
              const done = t.documents.length > 0;
              return (
                <div key={t.id} style={{borderRadius:10,border:"1px solid "+(done?"#16A34A44":"#DC262644"),background:done?"#F0FDF4":"#FFF8F8",marginBottom:8,overflow:"hidden"}}>
                  {/* Task header row */}
                  <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px"}}>
                    <span style={{fontSize:16,flexShrink:0}}>{done?"✅":"🔴"}</span>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:700,color:done?B.green:"#DC2626",fontFamily:"'DM Sans',sans-serif"}}>{t.title}</div>
                      {done
                        ? <div style={{fontSize:11,color:B.silver,marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>{t.documents.length} document{t.documents.length!==1?"s":""} attached</div>
                        : <div style={{fontSize:11,color:"#DC2626",marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>No document uploaded yet</div>
                      }
                    </div>
                    {done && pill(t.category, CATEGORY_COLORS[t.category]||B.silver)}
                  </div>
                  {/* Document list — always expanded in review mode */}
                  {t.documents.length > 0 && (
                    <div style={{padding:"0 14px 12px"}}>
                      {t.documents.map(doc=>(
                        <div key={doc.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",background:B.white,borderRadius:8,marginBottom:6,border:"1px solid "+B.light}}>
                          <span style={{fontSize:20,flexShrink:0}}>{doc.type?.includes("pdf")?"📄":doc.type?.includes("image")?"🖼":"📎"}</span>
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:12,fontWeight:600,color:B.black,fontFamily:"'DM Sans',sans-serif",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{doc.name}</div>
                            <div style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif",marginTop:1}}>{fmtSize(doc.size)} · Uploaded {new Date(doc.uploadedAt).toLocaleDateString()} by {doc.uploadedBy}</div>
                          </div>
                          {(doc.type?.includes("image")||doc.type?.includes("pdf"))&&(
                            <button onClick={()=>setPreviewDoc(doc)}
                              style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.blue+"44",background:B.blue+"0D",color:B.blue,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",cursor:"pointer",flexShrink:0}}>
                              👁 Preview
                            </button>
                          )}
                          <a href={doc.dataUrl} download={doc.name}
                            style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.green+"44",background:B.green+"0D",color:B.green,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",textDecoration:"none",flexShrink:0}}>
                            ↓ Download
                          </a>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
            {/* Optional tasks with docs */}
            {(tx.tasks||[]).filter(t=>!t.mandatory&&t.documents.length>0).length>0&&(
              <div style={{marginTop:14}}>
                <div style={{fontSize:11,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:8,fontFamily:"'DM Sans',sans-serif"}}>Additional Documents</div>
                {(tx.tasks||[]).filter(t=>!t.mandatory&&t.documents.length>0).map(t=>(
                  <div key={t.id} style={{borderRadius:10,border:"1px solid "+B.light,background:B.white,marginBottom:8,overflow:"hidden"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderBottom:"1px solid "+B.light}}>
                      <span style={{fontSize:14}}>📋</span>
                      <div style={{flex:1}}><div style={{fontSize:12,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{t.title}</div></div>
                      {pill(t.category, CATEGORY_COLORS[t.category]||B.silver)}
                      <span style={{fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{t.documents.length} doc{t.documents.length!==1?"s":""}</span>
                    </div>
                    <div style={{padding:"8px 14px"}}>
                      {t.documents.map(doc=>(
                        <div key={doc.id} style={{display:"flex",alignItems:"center",gap:10,padding:"7px 12px",background:B.offWhite,borderRadius:8,marginBottom:5,border:"1px solid "+B.light}}>
                          <span style={{fontSize:18}}>{doc.type?.includes("pdf")?"📄":doc.type?.includes("image")?"🖼":"📎"}</span>
                          <div style={{flex:1,minWidth:0}}>
                            <div style={{fontSize:12,fontWeight:600,color:B.black,fontFamily:"'DM Sans',sans-serif",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{doc.name}</div>
                            <div style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{fmtSize(doc.size)} · {doc.uploadedBy}</div>
                          </div>
                          {(doc.type?.includes("image")||doc.type?.includes("pdf"))&&<button onClick={()=>setPreviewDoc(doc)} style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.blue+"44",background:B.blue+"0D",color:B.blue,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",cursor:"pointer",flexShrink:0}}>👁 Preview</button>}
                          <a href={doc.dataUrl} download={doc.name} style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.green+"44",background:B.green+"0D",color:B.green,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",textDecoration:"none",flexShrink:0}}>↓ Download</a>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <ReviewLog log={tx.reviewLog||[]}/>
          <div style={{marginBottom:16}}>
            <label style={labelSt}>Your Decision</label>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {[["request_changes","↩ Request Changes","#DC2626","#FFF5F5"],["approve","✓ Approve",B.teal,"#ECFEFF"]].map(([a,l,c,bg])=>(
                <button key={a} onClick={()=>setAction(a)} style={{padding:"12px",borderRadius:10,border:`2px solid ${action===a?c:B.light}`,background:action===a?bg:B.white,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:13,color:action===a?c:B.gray}}>
                  {l}
                </button>
              ))}
            </div>
          </div>
          <div style={{marginBottom:20}}>
            <label style={labelSt}>{action==="request_changes"?"Reason (required)":"Approval Notes (optional)"}</label>
            <textarea value={comment} onChange={e=>setComment(e.target.value)} rows={3} placeholder={action==="request_changes"?"Explain what needs to be corrected…":"Add any notes for the agent…"} style={{...inputSt,resize:"vertical"}}/>
          </div>
          <div style={{display:"flex",gap:10,justifyContent:"flex-end",borderTop:"1px solid "+B.light,paddingTop:16,marginTop:4}}>
            <button onClick={onClose} style={{padding:"10px 20px",borderRadius:8,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>Cancel</button>
            <button onClick={submit} disabled={!action} style={{padding:"10px 24px",borderRadius:8,border:"none",background:!action?B.light:action==="approve"?B.teal:B.red,color:!action?B.silver:B.white,cursor:!action?"default":"pointer",fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
              {action==="approve"?"Approve":action==="request_changes"?"Send Back":"Select a Decision"}
            </button>
          </div>
        </div>
      </div>
      {previewDoc&&<DocPreviewModal doc={previewDoc} onClose={()=>setPreviewDoc(null)}/>}
    </div>
  );
}



// ─── Self-Approve Confirmation Modal ─────────────────────────────────────────
function SelfApproveConfirmModal({ tx, currentUser, onConfirm, onClose }) {
  const [note, setNote] = useState("");
  const gci      = calcGCI(tx.price, tx.commissionPct);
  const agentNet = calcAgentNetFull(tx.price, tx.commissionPct, tx.referralFee||0,
    {agentSplit:tx.agentSplit, transactionFee:tx.transactionFee||0, eoFee:tx.eoFee||0, customFees:tx.customFees||[]}).agentNet;
  const addr = tx.address.split(",")[0];
  const clientName = (tx.parties&&tx.parties.length>0)
    ? tx.parties.map(p=>p.name).filter(Boolean).join(" & ")
    : tx.clientName;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:1300,
      display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:B.white,borderRadius:16,width:"100%",maxWidth:460,
        boxShadow:"0 24px 60px rgba(0,0,0,0.35)",overflow:"hidden"}}>

        {/* Header */}
        <div style={{background:B.black,padding:"20px 24px"}}>
          <h2 style={{margin:0,fontSize:17,fontFamily:"'Playfair Display',serif",color:B.white}}>
            🏁 Self-Approve & Close
          </h2>
          <div style={{fontSize:12,color:B.silver,marginTop:4,fontFamily:"'DM Sans',sans-serif"}}>
            {addr} · {clientName}
          </div>
        </div>

        <div style={{padding:"20px 24px"}}>
          {/* Warning */}
          <div style={{background:"#FFFBEB",border:"1px solid #FCD34D",borderRadius:10,
            padding:"12px 16px",marginBottom:18,fontSize:12,color:"#92400E",
            fontFamily:"'DM Sans',sans-serif",lineHeight:1.6}}>
            ⚠ You are the agent on this transaction. By self-approving you confirm that all
            documents are in order and the transaction is ready to be marked closed.
          </div>

          {/* Financial summary */}
          <div style={{background:B.offWhite,borderRadius:10,padding:"14px 18px",
            marginBottom:18,display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            {[["Sale Price",fmt(tx.price),B.black],["GCI",fmt(gci),B.red],["Your Net",fmt(agentNet),B.green]].map(([l,v,c])=>(
              <div key={l}>
                <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.08em",
                  textTransform:"uppercase",marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>{l}</div>
                <div style={{fontSize:14,fontWeight:800,color:c,
                  fontFamily:"'Playfair Display',serif"}}>{v}</div>
              </div>
            ))}
          </div>

          {/* Notes */}
          <div style={{marginBottom:18}}>
            <label style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",
              textTransform:"uppercase",display:"block",marginBottom:6,
              fontFamily:"'DM Sans',sans-serif"}}>Closing Notes (optional)</label>
            <textarea value={note} onChange={e=>setNote(e.target.value)} rows={2}
              placeholder="Any final notes for this transaction…"
              style={{width:"100%",padding:"10px 12px",borderRadius:8,
                border:"1px solid "+B.light,fontSize:13,fontFamily:"'DM Sans',sans-serif",
                background:B.offWhite,outline:"none",color:B.black,
                boxSizing:"border-box",resize:"vertical"}}/>
          </div>

          {/* Confirmation question */}
          <div style={{background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:10,
            padding:"12px 16px",marginBottom:20,fontSize:13,color:"#166534",
            fontFamily:"'DM Sans',sans-serif",fontWeight:600,textAlign:"center"}}>
            Are you sure you want to self-approve and close this transaction?
          </div>

          {/* Yes / No buttons */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <button onClick={onClose}
              style={{padding:"11px",borderRadius:10,border:"1px solid "+B.light,
                background:B.white,cursor:"pointer",fontSize:13,fontWeight:700,
                fontFamily:"'DM Sans',sans-serif",color:B.gray}}>
              ✕ No, Cancel
            </button>
            <button onClick={()=>onConfirm(tx, note)}
              style={{padding:"11px",borderRadius:10,border:"none",
                background:B.green,color:B.white,cursor:"pointer",fontSize:13,
                fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
              ✓ Yes, Close It
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Reopen Transaction Modal ─────────────────────────────────────────────────
function ReopenTransactionModal({ tx, currentUser, onClose, onConfirm }) {
  const [reason, setReason] = useState("");

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1200,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:B.white,borderRadius:16,width:"100%",maxWidth:480,boxShadow:"0 24px 60px rgba(0,0,0,0.35)",overflow:"hidden"}}>
        <div style={{background:"#D97706",padding:"20px 24px"}}>
          <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>↩ Reopen Transaction</h2>
          <div style={{fontSize:12,color:"#FEF3C7",marginTop:4,fontFamily:"'DM Sans',sans-serif"}}>{tx.address.split(",")[0]}</div>
        </div>
        <div style={{padding:"20px 24px"}}>
          <div style={{background:"#FFFBEB",border:"1px solid #FCD34D",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:12,color:"#92400E",fontFamily:"'DM Sans',sans-serif"}}>
            ⚠ This will reopen the transaction and move it back to <strong>Changes Requested</strong> so the agent can make corrections and resubmit.
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",display:"block",marginBottom:6,fontFamily:"'DM Sans',sans-serif"}}>
              Reason for Reopening <span style={{color:B.red}}>*</span>
            </label>
            <textarea value={reason} onChange={e=>setReason(e.target.value)} rows={3}
              placeholder="Explain why this transaction is being reopened…"
              style={{width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${B.light}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",background:B.offWhite,outline:"none",color:B.black,boxSizing:"border-box",resize:"vertical"}}/>
          </div>
          <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
            <button onClick={onClose}
              style={{padding:"10px 20px",borderRadius:8,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>
              Cancel
            </button>
            <button onClick={()=>{ if(!reason.trim()){alert("Please provide a reason for reopening.");return;} onConfirm(tx.id,reason.trim()); }}
              style={{padding:"10px 24px",borderRadius:8,border:"none",background:"#D97706",color:B.white,cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
              ↩ Reopen Transaction
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}



// ─── Archive Transaction Modal ────────────────────────────────────────────────
function ArchiveTransactionModal({ tx, currentUser, onClose, onConfirm }) {
  const [note, setNote] = useState("");
  const addr = tx.address.split(",")[0];
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1200,
      display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:B.white,borderRadius:16,width:"100%",maxWidth:460,
        boxShadow:"0 24px 60px rgba(0,0,0,0.35)",overflow:"hidden"}}>
        <div style={{background:"#92400E",padding:"20px 24px"}}>
          <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>
            📦 Archive Transaction
          </h2>
          <div style={{fontSize:12,color:"#FEF3C7",marginTop:4,fontFamily:"'DM Sans',sans-serif"}}>
            {addr}
          </div>
        </div>
        <div style={{padding:"20px 24px"}}>
          <div style={{background:"#FFFBEB",border:"1px solid #FCD34D",borderRadius:10,
            padding:"12px 16px",marginBottom:20,fontSize:12,color:"#92400E",
            fontFamily:"'DM Sans',sans-serif",lineHeight:1.6}}>
            📦 This transaction will be moved to the <strong>Archive</strong>. It will be hidden
            from all active views but can be <strong>restored at any time</strong> from the
            Archive section. Nothing is permanently deleted.
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",
              textTransform:"uppercase",display:"block",marginBottom:6,
              fontFamily:"'DM Sans',sans-serif"}}>
              Archive Note (optional)
            </label>
            <textarea value={note} onChange={e=>setNote(e.target.value)} rows={2}
              placeholder="e.g. Duplicate entry, test transaction…"
              style={{width:"100%",padding:"10px 12px",borderRadius:8,
                border:"1px solid "+B.light,fontSize:13,fontFamily:"'DM Sans',sans-serif",
                background:B.offWhite,outline:"none",color:B.black,
                boxSizing:"border-box",resize:"vertical"}}/>
          </div>
          <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
            <button onClick={onClose}
              style={{padding:"10px 20px",borderRadius:8,border:"1px solid "+B.light,
                background:B.white,cursor:"pointer",fontSize:13,
                fontFamily:"'DM Sans',sans-serif",color:B.gray}}>
              Cancel
            </button>
            <button onClick={()=>onConfirm(tx.id, note.trim())}
              style={{padding:"10px 24px",borderRadius:8,border:"none",
                background:"#92400E",color:B.white,cursor:"pointer",
                fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
              📦 Move to Archive
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Archive Panel ────────────────────────────────────────────────────────────
function ArchivePanel({ transactions, currentUser, users, onRestore, onPermanentDelete, onClose }) {
  const archived = transactions.filter(t => t.wfState === "archived");
  return (
    <div onClick={onClose} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1100,
      display:"flex",alignItems:"stretch",justifyContent:"flex-end"}}>
      <div onClick={e=>e.stopPropagation()} style={{width:"min(700px,100vw)",background:B.white,display:"flex",
        flexDirection:"column",boxShadow:"-8px 0 40px rgba(0,0,0,0.2)",
        animation:"slideIn 0.25s ease"}}>
        {/* Header */}
        <div style={{padding:"20px 24px",borderBottom:"1px solid "+B.light,
          background:"#92400E",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",
                color:B.white}}>📦 Archive</h2>
              <div style={{fontSize:12,color:"#FEF3C7",marginTop:4,
                fontFamily:"'DM Sans',sans-serif"}}>
                {archived.length} archived transaction{archived.length!==1?"s":""}
                 · Restore or permanently delete
              </div>
            </div>
            <button onClick={onClose}
              style={{background:"none",border:"none",color:"#FEF3C7",
                fontSize:22,cursor:"pointer"}}>✕</button>
          </div>
        </div>
        {/* Body */}
        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
          {archived.length === 0 ? (
            <div style={{textAlign:"center",padding:"60px 20px",color:B.silver,
              fontFamily:"'DM Sans',sans-serif",fontSize:13}}>
              No archived transactions.
            </div>
          ) : (
            archived.map(tx => {
              const agent = users.find(u => u.id === tx.agentId);
              const archiveEntry = [...(tx.reviewLog||[])].reverse()
                .find(e => e.action === "archived");
              const clientName = (tx.parties&&tx.parties.length>0)
                ? tx.parties.map(p=>p.name).filter(Boolean).join(" & ")
                : tx.clientName;
              return (
                <div key={tx.id} style={{background:B.white,borderRadius:10,
                  border:"1px solid #FCD34D",marginBottom:12,overflow:"hidden"}}>
                  <div style={{padding:"14px 16px",background:"#FFFBEB"}}>
                    <div style={{display:"flex",justifyContent:"space-between",
                      alignItems:"flex-start",flexWrap:"wrap",gap:8}}>
                      <div>
                        <div style={{fontSize:14,fontWeight:700,color:B.black,
                          fontFamily:"'DM Sans',sans-serif"}}>{tx.address.split(",")[0]}</div>
                        <div style={{fontSize:11,color:B.silver,marginTop:3,
                          fontFamily:"'DM Sans',sans-serif"}}>
                          {clientName} · {agent?.name||"Unknown agent"} · {fmtDate(tx.closingDate)}
                        </div>
                        {archiveEntry?.comment&&(
                          <div style={{fontSize:11,color:"#92400E",marginTop:4,
                            fontStyle:"italic",fontFamily:"'DM Sans',sans-serif"}}>
                            Note: {archiveEntry.comment}
                          </div>
                        )}
                        {archiveEntry&&(
                          <div style={{fontSize:10,color:B.silver,marginTop:2,
                            fontFamily:"'DM Sans',sans-serif"}}>
                            Archived {fmtTS(archiveEntry.at)} by {archiveEntry.byName}
                          </div>
                        )}
                      </div>
                      <div style={{display:"flex",gap:8,flexShrink:0}}>
                        <button onClick={()=>onRestore(tx)}
                          style={{padding:"6px 14px",borderRadius:8,
                            border:"1px solid "+B.teal+"44",background:B.teal+"11",
                            color:B.teal,cursor:"pointer",fontSize:12,fontWeight:700,
                            fontFamily:"'DM Sans',sans-serif"}}>
                          ↩ Restore
                        </button>
                        <button onClick={()=>{
                          if(window.confirm("Permanently delete this transaction? This cannot be undone."))
                            onPermanentDelete(tx.id);
                        }}
                          style={{padding:"6px 12px",borderRadius:8,
                            border:"1px solid #FEE2E2",background:"#FFF5F5",
                            color:"#DC2626",cursor:"pointer",fontSize:12,fontWeight:700,
                            fontFamily:"'DM Sans',sans-serif"}}>
                          🗑 Delete
                        </button>
                      </div>
                    </div>
                    {/* Mini financial summary */}
                    <div style={{display:"flex",gap:20,marginTop:10,flexWrap:"wrap"}}>
                      {[["Price",fmt(tx.price)],["GCI",fmt(calcGCI(tx.price,tx.commissionPct))],
                        ["Stage",tx.stage]].map(([l,v])=>(
                        <div key={l}>
                          <div style={{fontSize:9,fontWeight:700,color:B.silver,
                            letterSpacing:"0.08em",textTransform:"uppercase",
                            fontFamily:"'DM Sans',sans-serif"}}>{l}</div>
                          <div style={{fontSize:12,fontWeight:700,color:B.gray,
                            fontFamily:"'DM Sans',sans-serif"}}>{v}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Void Transaction Modal ───────────────────────────────────────────────────
// Agents can void their own draft/changes_requested transactions
// Voiding marks as fallen_through (preserves audit trail) — not a hard delete
function VoidTransactionModal({ tx, currentUser, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const addr = tx.address.split(",")[0];

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1200,
      display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:B.white,borderRadius:16,width:"100%",maxWidth:460,
        boxShadow:"0 24px 60px rgba(0,0,0,0.35)",overflow:"hidden"}}>
        <div style={{background:"#7C3AED",padding:"20px 24px"}}>
          <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>
            ✕ Void Transaction
          </h2>
          <div style={{fontSize:12,color:"#DDD6FE",marginTop:4,fontFamily:"'DM Sans',sans-serif"}}>
            {addr}
          </div>
        </div>
        <div style={{padding:"20px 24px"}}>
          <div style={{background:"#F5F3FF",border:"1px solid #DDD6FE",borderRadius:10,
            padding:"12px 16px",marginBottom:20,fontSize:12,color:"#5B21B6",
            fontFamily:"'DM Sans',sans-serif",lineHeight:1.6}}>
            ⚠ Voiding marks this transaction as <strong>Fallen Through</strong> and locks it.
            The file is preserved for your broker's records — it cannot be permanently deleted by agents.
            Contact your broker if you need it removed entirely.
          </div>
          <div style={{marginBottom:20}}>
            <label style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",
              textTransform:"uppercase",display:"block",marginBottom:6,
              fontFamily:"'DM Sans',sans-serif"}}>
              Reason for Voiding <span style={{color:B.red}}>*</span>
            </label>
            <textarea value={reason} onChange={e=>setReason(e.target.value)} rows={3}
              placeholder="e.g. Created by mistake, deal fell through, duplicate entry…"
              style={{width:"100%",padding:"10px 12px",borderRadius:8,
                border:"1px solid "+B.light,fontSize:13,fontFamily:"'DM Sans',sans-serif",
                background:B.offWhite,outline:"none",color:B.black,
                boxSizing:"border-box",resize:"vertical"}}/>
          </div>
          <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
            <button onClick={onClose}
              style={{padding:"10px 20px",borderRadius:8,border:"1px solid "+B.light,
                background:B.white,cursor:"pointer",fontSize:13,
                fontFamily:"'DM Sans',sans-serif",color:B.gray}}>
              Cancel
            </button>
            <button
              onClick={()=>{ if(!reason.trim()){alert("Please provide a reason.");return;} onConfirm(tx.id, reason.trim()); }}
              style={{padding:"10px 24px",borderRadius:8,border:"none",
                background:"#7C3AED",color:B.white,cursor:"pointer",
                fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
              ✕ Void Transaction
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Close Transaction Modal ──────────────────────────────────────────────────
function CloseTransactionModal({ tx, users, onClose, onConfirm }) {
  const [note, setNote] = useState("");
  const agent    = users.find(u=>u.id===tx.agentId);
  const gci      = calcGCI(tx.price,tx.commissionPct);
  const agentNet = calcNet(tx.price,tx.commissionPct,tx.referralFee||0,tx.agentSplit);
  const missingDocs = (tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0);
  const isBlocked   = missingDocs.length > 0;

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",zIndex:1200,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:B.white,borderRadius:16,width:"100%",maxWidth:520,boxShadow:"0 24px 60px rgba(0,0,0,0.35)",overflow:"hidden"}}>
        {/* Header — red if blocked, green if ready */}
        <div style={{background:isBlocked?"#DC2626":B.green,padding:"20px 24px"}}>
          <h2 style={{margin:0,fontSize:18,fontFamily:"'Playfair Display',serif",color:B.white}}>
            {isBlocked?"🔒 Cannot Close Yet":"🏁 Close Transaction"}
          </h2>
          <div style={{fontSize:12,color:isBlocked?"#FECACA":"#BBF7D0",marginTop:4,fontFamily:"'DM Sans',sans-serif"}}>
            {tx.address.split(",")[0]} · {agent?.name}
          </div>
        </div>
        <div style={{padding:"20px 24px"}}>

          {/* Blocked — show missing docs list */}
          {isBlocked && (
            <div style={{background:"#FFF5F5",border:"1px solid #FCA5A5",borderRadius:10,padding:"14px 16px",marginBottom:20}}>
              <div style={{fontSize:13,fontWeight:700,color:"#DC2626",fontFamily:"'DM Sans',sans-serif",marginBottom:10}}>
                ⚠ {missingDocs.length} required document{missingDocs.length!==1?"s":""} must be uploaded before closing:
              </div>
              {missingDocs.map(t=>(
                <div key={t.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                  <span style={{fontSize:13}}>🔴</span>
                  <span style={{fontSize:12,color:"#DC2626",fontWeight:600,fontFamily:"'DM Sans',sans-serif"}}>{t.title}</span>
                  {t.side!=="Both"&&<span style={{fontSize:10,color:"#DC2626",opacity:0.7,fontFamily:"'DM Sans',sans-serif"}}>({t.side} only)</span>}
                </div>
              ))}
              <div style={{marginTop:12,fontSize:11,color:"#991B1B",fontFamily:"'DM Sans',sans-serif",fontStyle:"italic"}}>
                Ask the agent to upload the missing documents, then resubmit for review.
              </div>
            </div>
          )}

          {/* Financial summary */}
          <div style={{background:B.offWhite,borderRadius:10,padding:"16px 18px",marginBottom:20,display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12}}>
            {[["Sale Price",fmt(tx.price),B.black],["GCI",fmt(gci),B.red],["Agent Net",fmt(agentNet),B.green]].map(([l,v,c])=>(
              <div key={l}>
                <div style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>{l}</div>
                <div style={{fontSize:15,fontWeight:800,color:c,fontFamily:"'Playfair Display',serif"}}>{v}</div>
              </div>
            ))}
          </div>

          {!isBlocked && (
            <>
              <div style={{marginBottom:20}}>
                <label style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",display:"block",marginBottom:6,fontFamily:"'DM Sans',sans-serif"}}>Closing Notes</label>
                <textarea value={note} onChange={e=>setNote(e.target.value)} rows={3} placeholder="Any final notes…"
                  style={{width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${B.light}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",background:B.offWhite,outline:"none",color:B.black,boxSizing:"border-box",resize:"vertical"}}/>
              </div>
              <div style={{background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:10,padding:"12px 16px",marginBottom:20,fontSize:12,color:"#166534",fontFamily:"'DM Sans',sans-serif"}}>
                ✓ All required documents are on file. This will permanently mark the transaction as <strong>Closed</strong>.
              </div>
            </>
          )}

          <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
            <button onClick={onClose}
              style={{padding:"10px 20px",borderRadius:8,border:`1px solid ${B.light}`,background:B.white,cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>
              {isBlocked?"Dismiss":"Cancel"}
            </button>
            {!isBlocked && (
              <button onClick={()=>onConfirm(tx.id,note)}
                style={{padding:"10px 24px",borderRadius:8,border:"none",background:B.green,color:B.white,cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
                Confirm Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Workflow Action Bar ──────────────────────────────────────────────────────
function WorkflowActionBar({ tx, currentUser, users, onSubmit, onReview, onCloseTx, onReopen, onSelfApprove }) {
  const isRealtor      = currentUser.role==="realtor";
  const isPrincipal    = currentUser.role==="principal_broker";
  const isAssocBroker  = currentUser.role==="associate_broker";
  const isOwner        = tx.agentId===currentUser.id;
  // Self-approval ONLY for principal broker — assoc brokers submit to principal
  const isPrincipalOwned = isPrincipal && isOwner;
  // Associate broker owns this transaction — must submit to principal for review
  const isAssocBrokerOwned = isAssocBroker && isOwner;

  // Standard review/close flow (brokers reviewing others' transactions)
  // Also used by principal broker reviewing assoc broker-owned transactions
  const canReview   = canReviewSubmission(currentUser, tx, users) && tx.wfState==="submitted";
  const canClose    = canCloseTransaction(currentUser) && tx.wfState==="approved" && canReviewTransaction(currentUser,tx,users) && !isPrincipalOwned;

  // Realtor submit flow
  const canSubmit   = isRealtor && isOwner && (tx.wfState==="draft"||tx.wfState==="changes_requested") && allMandatoryDone(tx.tasks||[]);
  const cantSubmit  = isRealtor && isOwner && (tx.wfState==="draft"||tx.wfState==="changes_requested") && !allMandatoryDone(tx.tasks||[]);

  // Associate broker submit flow — same as realtor, submits to principal for review
  const canAssocSubmit  = isAssocBrokerOwned && (tx.wfState==="draft"||tx.wfState==="changes_requested") && allMandatoryDone(tx.tasks||[]);
  const cantAssocSubmit = isAssocBrokerOwned && (tx.wfState==="draft"||tx.wfState==="changes_requested") && !allMandatoryDone(tx.tasks||[]);

  // Principal broker self-approval — only for their OWN transactions
  const selfApprovable     = isPrincipalOwned && !["closed","fallen_through"].includes(tx.wfState);
  const selfApproveReady   = selfApprovable && allMandatoryDone(tx.tasks||[]);
  const selfApproveBlocked = selfApprovable && !allMandatoryDone(tx.tasks||[]);

  const missing      = (tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0).length;
  const closeBlocked = canClose && missing > 0;

  if(!canSubmit&&!cantSubmit&&!canAssocSubmit&&!cantAssocSubmit&&!canReview&&!canClose&&!selfApprovable) return null;

  return(
    <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap"}}>

      {/* ── Realtor flow ── */}
      {cantSubmit&&<div style={{fontSize:11,color:B.red,fontWeight:600,fontFamily:"'DM Sans',sans-serif"}}>🔒 {missing} required doc{missing!==1?"s":""} missing</div>}
      {canSubmit&&<button onClick={()=>onSubmit(tx.id)} style={{padding:"7px 16px",borderRadius:8,border:"none",background:B.gold,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>📤 Submit for Review</button>}

      {/* ── Associate Broker flow — submits to Principal for review ── */}
      {cantAssocSubmit&&(
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          <div style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif",fontStyle:"italic"}}>Your transaction — requires Principal Broker review</div>
          <div style={{fontSize:11,color:B.red,fontWeight:600,fontFamily:"'DM Sans',sans-serif"}}>🔒 {missing} required doc{missing!==1?"s":""} missing</div>
        </div>
      )}
      {canAssocSubmit&&(
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          <div style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif",fontStyle:"italic"}}>Your transaction — submit to Principal Broker</div>
          <button onClick={()=>onSubmit(tx.id)}
            style={{padding:"7px 16px",borderRadius:8,border:"none",background:B.gold,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
            📤 Submit for Review
          </button>
        </div>
      )}

      {/* ── Broker review flow ── */}
      {canReview&&<button onClick={()=>onReview(tx)} style={{padding:"7px 16px",borderRadius:8,border:"none",background:B.teal,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>🔍 Review</button>}
      {canClose&&!closeBlocked&&<button onClick={()=>onCloseTx(tx)} style={{padding:"7px 16px",borderRadius:8,border:"none",background:B.green,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>🏁 Close</button>}
      {closeBlocked&&(
        <div style={{display:"flex",alignItems:"center",gap:8,padding:"7px 14px",borderRadius:8,border:"1px solid #DC262644",background:"#FFF5F5"}}>
          <span style={{fontSize:12}}>🔒</span>
          <span style={{fontSize:11,color:"#DC2626",fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>{missing} required doc{missing!==1?"s":""} missing — cannot close</span>
        </div>
      )}

      {/* ── Principal broker self-owned transaction flow ── */}
      {selfApproveBlocked&&(
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          <div style={{fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif",fontStyle:"italic"}}>Your transaction — no review needed</div>
          <div style={{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",borderRadius:8,border:"1px solid #DC262644",background:"#FFF5F5"}}>
            <span style={{fontSize:11}}>🔒</span>
            <span style={{fontSize:11,color:"#DC2626",fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>{missing} required doc{missing!==1?"s":""} missing — upload to close</span>
          </div>
        </div>
      )}
      {selfApproveReady&&(
        <div style={{display:"flex",flexDirection:"column",gap:4}}>
          <div style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif",fontStyle:"italic",letterSpacing:"0.04em"}}>Principal Broker — self-approval (confirmation required)</div>
          <button onClick={()=>onSelfApprove(tx)}
            style={{padding:"7px 16px",borderRadius:8,border:"none",background:B.green,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",gap:6}}>
            🏁 Approve & Close
          </button>
        </div>
      )}

      {/* ── Reopen button — brokers only, closed transactions only ── */}
      {!isRealtor&&tx.wfState==="closed"&&onReopen&&(
        <button onClick={()=>onReopen(tx)} style={{padding:"7px 16px",borderRadius:8,border:"1px solid #D9770644",background:"#FFFBEB",color:"#D97706",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
          ↩ Reopen
        </button>
      )}
    </div>
  );
}

// ─── Task Panel ───────────────────────────────────────────────────────────────
function TaskPanel({ tx, currentUser, users, onUpdateTasks, onSubmit, onReview, onCloseTx, onReopen, onSelfApprove, onClose, onUploadDoc, onDeleteDoc }) {
  const [tasks,setTasks]         = useState(tx.tasks||[]);

  // Re-sync local tasks state when the tx prop's tasks change (e.g. after the
  // async DB fetch completes and replaces the initial empty/stale tasks array).
  // Without this, TaskPanel keeps showing stale data from its very first render.
  useEffect(() => {
    if (tx.tasks && tx.tasks.length > 0) setTasks(tx.tasks);
  }, [tx.tasks]); // eslint-disable-line
  const [expanded,setExpanded]   = useState(null);
  const [uploadingFor,setUploading]=useState(null);
  const [addingCustom,setAddingCustom]=useState(false);
  const [customForm,setCustomForm]=useState({title:"",mandatory:false,category:"Contract",description:"",dueDate:""});
  const fileRef = useRef();
  const [previewDoc, setPreviewDoc] = useState(null);

  const isReadOnly = currentUser.role==="realtor" && (tx.wfState==="submitted"||tx.wfState==="approved"||tx.wfState==="closed"||tx.wfState==="fallen_through");
  const mandatory  = tasks.filter(t=>t.mandatory);
  const optional   = tasks.filter(t=>!t.mandatory);
  const mandDone   = mandatory.filter(t=>t.documents.length>0).length;
  const optDone    = optional.filter(t=>t.completed||t.documents.length>0).length;
  const totalDone  = tasks.filter(t=>t.mandatory?t.documents.length>0:(t.completed||t.documents.length>0)).length;
  const pct        = tasks.length?Math.round(totalDone/tasks.length*100):0;

  const [uploadStatus, setUploadStatus] = useState({}); // {taskId: "uploading"|"success"|"error"}

  function updateTask(id,patch){setTasks(prev=>prev.map(t=>t.id===id?{...t,...patch}:t));}
  function toggleComplete(task){if(task.mandatory||isReadOnly)return;updateTask(task.id,{completed:!task.completed});}

  async function handleFileUpload(taskId,files){
    if(isReadOnly)return;
    const fileList = Array.from(files||[]);
    if(fileList.length===0)return;
    setUploading(null);

    if (typeof onUploadDoc === "function") {
      // ── Supabase mode — upload each file, one at a time, persisting to the database ──
      setUploadStatus(s=>({...s,[taskId]:"uploading"}));
      let successCount = 0;
      let firstError = null;
      for (const file of fileList) {
        try {
          const doc = await onUploadDoc(taskId, tx.id, file);
          setTasks(prev=>prev.map(t=>t.id===taskId?{...t,documents:[...t.documents,doc],completed:t.mandatory?false:true}:t));
          successCount++;
        } catch(e) {
          if (!firstError) firstError = e;
        }
      }
      if (firstError) {
        setUploadStatus(s=>({...s,[taskId]:"error"}));
        const failedCount = fileList.length - successCount;
        alert(
          (successCount>0 ? `${successCount} of ${fileList.length} documents uploaded successfully.\n\n` : "")+
          `${failedCount} document${failedCount!==1?"s":""} failed to upload: ${firstError.message}\n\nPlease try again for the failed file(s).`
        );
        setTimeout(()=>setUploadStatus(s=>{ const n={...s}; delete n[taskId]; return n; }), 5000);
      } else {
        setUploadStatus(s=>({...s,[taskId]:"success"}));
        setTimeout(()=>setUploadStatus(s=>{ const n={...s}; delete n[taskId]; return n; }), 3000);
      }
    } else {
      // ── Local/demo mode — held in browser memory only ──
      fileList.forEach(file => {
        const reader=new FileReader();
        reader.onload=e=>{
          const doc={id:genId(),name:file.name,size:file.size,type:file.type,dataUrl:e.target.result,uploadedAt:new Date().toISOString(),uploadedBy:currentUser.name};
          setTasks(prev=>prev.map(t=>t.id===taskId?{...t,documents:[...t.documents,doc],completed:t.mandatory?false:true}:t));
        };
        reader.readAsDataURL(file);
      });
    }
  }

  async function removeDoc(taskId,docId){
    if(isReadOnly)return;
    const task = tasks.find(t=>t.id===taskId);
    const doc  = task?.documents.find(d=>d.id===docId);
    if (typeof onDeleteDoc === "function" && doc?.storagePath) {
      try { await onDeleteDoc(docId, doc.storagePath, tx.id); }
      catch(e) { alert("Could not delete document: "+e.message); return; }
    }
    setTasks(prev=>prev.map(t=>t.id===taskId?{...t,documents:t.documents.filter(d=>d.id!==docId)}:t));
  }
  function addCustomTask(){
    if(!customForm.title.trim()||isReadOnly)return;
    setTasks(prev=>[...prev,{id:genId(),templateId:null,title:customForm.title,mandatory:customForm.mandatory,side:"Both",category:customForm.category,description:customForm.description,dueDate:customForm.dueDate,completed:false,notes:"",documents:[]}]);
    setCustomForm({title:"",mandatory:false,category:"Contract",description:"",dueDate:""});setAddingCustom(false);
  }

  // ── Detect standard tasks missing from this transaction's checklist ──────
  // (e.g. a new mandatory doc type like Earnest Money added after this transaction was created)
  const missingStandardTasks = DEFAULT_TASKS.filter(template => {
    const appliesToThisTx = template.side === "Both" || template.side === tx.side;
    if (!appliesToThisTx) return false;
    const alreadyHasTask = tasks.some(t => t.templateId === template.templateId);
    return !alreadyHasTask;
  });

  function syncMissingTasks() {
    if (isReadOnly) return;
    const newTasks = missingStandardTasks.map(t => ({
      id:`task_${t.templateId}_${Date.now()}_${Math.random().toString(36).slice(2,6)}`,
      templateId:t.templateId, title:t.title, mandatory:t.mandatory,
      side:t.side, category:t.category, description:t.description,
      completed:false, dueDate:"", notes:"", documents:[],
    }));
    setTasks(prev => [...prev, ...newTasks]);
  }
  const [saving, setSaving] = useState(false);
  async function save(){
    setSaving(true);
    await onUpdateTasks(tx.id,tasks);
    setSaving(false);
    onClose();
  }

  const inputSt={width:"100%",padding:"8px 11px",borderRadius:7,border:`1px solid ${B.light}`,fontSize:13,fontFamily:"'DM Sans',sans-serif",background:isReadOnly?"#F9F9F9":B.offWhite,outline:"none",color:B.black,boxSizing:"border-box"};
  const labelSt={fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.09em",textTransform:"uppercase",display:"block",marginBottom:4,fontFamily:"'DM Sans',sans-serif"};

  const TaskRow=({task})=>{
    const isExp=expanded===task.id;
    const hasDoc=task.documents.length>0;
    const isDone=task.mandatory?hasDoc:(task.completed||task.documents.length>0);
    const due=daysUntil(task.dueDate);const overdue=due!==null&&due<0;const urgent=due!==null&&due>=0&&due<=3;
    return(
      <div style={{borderRadius:10,border:`1px solid ${isDone?"#16A34A44":task.mandatory&&!hasDoc?B.red+"55":B.light}`,background:isDone?"#F0FDF4":task.mandatory&&!hasDoc?"#FFF8F8":B.white,marginBottom:8,overflow:"hidden"}}>
        <div style={{padding:"12px 14px",display:"flex",alignItems:"center",gap:12,cursor:"pointer"}} onClick={()=>setExpanded(isExp?null:task.id)}>
          <div onClick={e=>{e.stopPropagation();toggleComplete(task);}}
            style={{width:22,height:22,borderRadius:6,border:isDone?"2px solid "+B.green:task.mandatory?"2px dashed "+B.red:"2px solid "+B.silver,background:isDone?B.green:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,cursor:task.mandatory||isReadOnly?"not-allowed":"pointer"}}>
            {isDone?<span style={{color:"#fff",fontSize:12,fontWeight:900}}>✓</span>:task.mandatory?<span style={{fontSize:10}}>🔒</span>:null}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
              <span style={{fontSize:13,fontWeight:600,color:isDone?B.green:task.mandatory&&!hasDoc?B.red:B.black,fontFamily:"'DM Sans',sans-serif"}}>{task.title}</span>
              {task.mandatory?(isDone?pill("Required · Complete",B.green):pill("Required · Awaiting Doc",B.red)):null}
              {pill(task.category,CATEGORY_COLORS[task.category]||B.gray)}
            </div>
            {task.dueDate&&<div style={{fontSize:11,color:overdue?"#DC2626":urgent?B.gold:B.silver,marginTop:3,fontFamily:"'DM Sans',sans-serif",fontWeight:overdue||urgent?700:400}}>{overdue?"⚠ Overdue "+Math.abs(due)+"d":urgent?"⚡ Due in "+due+"d":"Due "+fmtDate(task.dueDate)}</div>}
            {task.mandatory&&!hasDoc&&!isExp&&!isReadOnly&&<div style={{fontSize:11,color:B.red,marginTop:3,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>↓ Attach document to complete</div>}
          </div>
          {hasDoc&&<span style={{fontSize:11,color:B.green,fontWeight:700,whiteSpace:"nowrap",fontFamily:"'DM Sans',sans-serif",background:"#DCFCE7",padding:"2px 8px",borderRadius:10}}>📎 {task.documents.length}</span>}
          <span style={{color:B.silver,fontSize:11,transform:isExp?"rotate(180deg)":"none",display:"inline-block"}}>▼</span>
        </div>
        {isExp&&(
          <div style={{padding:"0 14px 14px",borderTop:"1px solid "+B.light}}>
            {task.description&&<p style={{fontSize:12,color:B.gray,margin:"12px 0 10px",fontFamily:"'DM Sans',sans-serif",fontStyle:"italic"}}>{task.description}</p>}
            {task.mandatory&&!hasDoc&&<div style={{background:B.red+"11",border:"1px solid "+B.red+"44",borderRadius:8,padding:"10px 14px",marginBottom:14,display:"flex",alignItems:"center",gap:10}}><span style={{fontSize:20}}>🔒</span><div><div style={{fontSize:13,fontWeight:700,color:B.red,fontFamily:"'DM Sans',sans-serif"}}>Document Required</div><div style={{fontSize:11,color:B.red,opacity:0.85,fontFamily:"'DM Sans',sans-serif",marginTop:2}}>{isReadOnly?"Locked for review.":"Attach a document — task completes automatically."}</div></div></div>}
            {task.mandatory&&hasDoc&&<div style={{background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:8,padding:"10px 14px",marginBottom:14,display:"flex",alignItems:"center",gap:10}}><span style={{fontSize:18}}>✅</span><div style={{fontSize:13,fontWeight:700,color:B.green,fontFamily:"'DM Sans',sans-serif"}}>Complete — document on file.</div></div>}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
              <div><label style={labelSt}>Due Date</label><input type="date" value={task.dueDate} disabled={isReadOnly} onChange={e=>updateTask(task.id,{dueDate:e.target.value})} style={inputSt}/></div>
              <div><label style={labelSt}>Notes</label><input type="text" value={task.notes} disabled={isReadOnly} onChange={e=>updateTask(task.id,{notes:e.target.value})} placeholder="Add a note…" style={inputSt}/></div>
            </div>
            <div style={{marginBottom:10}}>
              <label style={labelSt}>Documents {task.mandatory&&<span style={{color:hasDoc?B.green:B.red,fontSize:10,fontWeight:600,marginLeft:6,textTransform:"none",letterSpacing:0}}>{hasDoc?"✓ attached":"— required"}</span>}</label>
              {task.documents.map(doc=>(
                <div key={doc.id} style={{borderRadius:8,marginBottom:8,border:"1px solid "+B.light,overflow:"hidden",background:B.white}}>
                  {/* Image preview */}
                  {doc.type?.includes("image")&&(
                    <div style={{background:"#000",maxHeight:180,overflow:"hidden",display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <img src={doc.dataUrl} alt={doc.name} style={{maxWidth:"100%",maxHeight:180,objectFit:"contain"}}/>
                    </div>
                  )}
                  {/* PDF preview banner */}
                  {doc.type?.includes("pdf")&&(
                    <div style={{background:B.purple+"0D",borderBottom:"1px solid "+B.purple+"22",padding:"8px 12px",display:"flex",alignItems:"center",gap:8}}>
                      <span style={{fontSize:20}}>📄</span>
                      <span style={{fontSize:11,color:B.purple,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>PDF Document — click Open to view</span>
                    </div>
                  )}
                  {/* File info + actions */}
                  <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 12px",flexWrap:"wrap"}}>
                    {!doc.type?.includes("image")&&!doc.type?.includes("pdf")&&<span style={{fontSize:18}}>📎</span>}
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:12,fontWeight:600,color:B.black,fontFamily:"'DM Sans',sans-serif",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{doc.name}</div>
                      <div style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{fmtSize(doc.size)} · {new Date(doc.uploadedAt).toLocaleDateString()} · {doc.uploadedBy}</div>
                    </div>
                    <div style={{display:"flex",gap:6,flexShrink:0}}>
                      {(doc.type?.includes("image")||doc.type?.includes("pdf"))&&(
                        <button onClick={()=>setPreviewDoc(doc)}
                          style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.blue+"44",background:B.blue+"0D",color:B.blue,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",cursor:"pointer"}}>
                          👁 Preview
                        </button>
                      )}
                      <a href={doc.dataUrl} download={doc.name}
                        style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.green+"44",background:B.green+"0D",color:B.green,fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",textDecoration:"none"}}>
                        ↓ Download
                      </a>
                      {!isReadOnly&&(
                        <button onClick={()=>removeDoc(task.id,doc.id)}
                          style={{padding:"4px 8px",borderRadius:6,border:"1px solid #FEE2E2",background:"#FFF5F5",cursor:"pointer",color:"#DC2626",fontSize:12,fontWeight:700}}>
                          ✕
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              {/* Upload status indicator */}
              {uploadStatus[task.id]==="uploading" && (
                <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 12px",
                  background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:8,marginBottom:8}}>
                  <span style={{fontSize:13}}>⏳</span>
                  <span style={{fontSize:12,color:"#1E40AF",fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
                    Uploading and saving document(s)…
                  </span>
                </div>
              )}
              {uploadStatus[task.id]==="success" && (
                <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 12px",
                  background:"#F0FDF4",border:"1px solid #86EFAC",borderRadius:8,marginBottom:8}}>
                  <span style={{fontSize:13}}>✓</span>
                  <span style={{fontSize:12,color:B.green,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
                    Document saved successfully
                  </span>
                </div>
              )}
              {uploadStatus[task.id]==="error" && (
                <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 12px",
                  background:"#FFF5F5",border:"1px solid #FCA5A5",borderRadius:8,marginBottom:8}}>
                  <span style={{fontSize:13}}>⚠</span>
                  <span style={{fontSize:12,color:"#DC2626",fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
                    Upload failed — document was NOT saved. Please try again.
                  </span>
                </div>
              )}
              {!isReadOnly&&(<>
                <input type="file" multiple ref={fileRef} style={{display:"none"}} onChange={e=>handleFileUpload(uploadingFor,e.target.files)}/>
                <button onClick={()=>{setUploading(task.id);setTimeout(()=>fileRef.current?.click(),50);}}
                  disabled={uploadStatus[task.id]==="uploading"}
                  style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,padding:"10px 14px",borderRadius:8,border:task.mandatory&&!hasDoc?"1.5px dashed "+B.red:"1.5px dashed "+B.light,background:task.mandatory&&!hasDoc?B.red+"0D":B.offWhite,color:task.mandatory&&!hasDoc?B.red:B.gray,cursor:uploadStatus[task.id]==="uploading"?"wait":"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif",width:"100%",opacity:uploadStatus[task.id]==="uploading"?0.6:1}}>
                  {uploadStatus[task.id]==="uploading" ? "⏳ Uploading…" : `📎 ${task.mandatory&&!hasDoc?"Attach Document(s) to Complete":"Attach More Document(s)"}`}
                </button>
              </>)}
            </div>
          </div>
        )}
      </div>
    );
  };

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:1100,display:"flex",alignItems:"stretch",justifyContent:"flex-end"}}>
      <div style={{width:"min(700px,100vw)",background:B.white,display:"flex",flexDirection:"column",boxShadow:"-8px 0 40px rgba(0,0,0,0.2)",animation:"slideIn 0.25s ease"}}>
        <style>{`@keyframes slideIn{from{transform:translateX(100%)}to{transform:translateX(0)}}`}</style>
        <div style={{padding:"20px 24px",borderBottom:"1px solid "+B.light,background:B.black}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div>
              <div style={{fontSize:10,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif",marginBottom:4}}>Transaction Checklist</div>
              <h2 style={{margin:0,fontSize:17,fontFamily:"'Playfair Display',serif",color:B.white}}>{tx.address.split(",")[0]}</h2>
              <div style={{display:"flex",alignItems:"center",gap:8,marginTop:6,flexWrap:"wrap"}}><SideBadge side={tx.side}/><span style={{color:B.silver,fontSize:12,fontFamily:"'DM Sans',sans-serif"}}>{(tx.parties&&tx.parties.length>0)?tx.parties.map(p=>p.name).filter(Boolean).join(" & "):tx.clientName}</span><WfBadge wfState={tx.wfState}/></div>
            </div>
            <button onClick={onClose} style={{background:"none",border:"none",color:B.silver,fontSize:22,cursor:"pointer"}}>✕</button>
          </div>
          <div style={{marginTop:16}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}><span style={{fontSize:11,fontWeight:700,color:B.silver,fontFamily:"'DM Sans',sans-serif",textTransform:"uppercase",letterSpacing:"0.08em"}}>Progress</span><span style={{fontSize:13,fontWeight:800,color:pct===100?B.green:B.red,fontFamily:"'Playfair Display',serif"}}>{pct}%</span></div>
            <div style={{height:6,background:"#333",borderRadius:3}}><div style={{height:"100%",borderRadius:3,background:pct===100?B.green:B.red,width:pct+"%",transition:"width 0.4s ease"}}/></div>
            <div style={{display:"flex",gap:20,marginTop:8}}><span style={{fontSize:11,color:"#DC2626",fontFamily:"'DM Sans',sans-serif"}}>✦ Required: {mandDone}/{mandatory.length}</span><span style={{fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>◇ Optional: {optDone}/{optional.length}</span></div>
          </div>
          {isReadOnly&&<div style={{marginTop:12,padding:"8px 12px",background:B.gold+"22",border:"1px solid "+B.gold+"44",borderRadius:8,fontSize:11,color:B.gold,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>🔒 Under review — editing locked until broker requests changes.</div>}
        </div>
        {missingStandardTasks.length>0 && !isReadOnly && (
          <div style={{margin:"16px 24px 0",padding:"12px 16px",background:"#FFFBEB",
            border:"1px solid #FCD34D",borderRadius:10,display:"flex",alignItems:"center",
            justifyContent:"space-between",gap:12,flexWrap:"wrap"}}>
            <div>
              <div style={{fontSize:12,fontWeight:700,color:"#92400E",fontFamily:"'DM Sans',sans-serif"}}>
                📋 {missingStandardTasks.length} new required document{missingStandardTasks.length!==1?"s":""} added to the standard checklist since this transaction was created
              </div>
              <div style={{fontSize:11,color:"#92400E",marginTop:2,fontFamily:"'DM Sans',sans-serif",opacity:0.8}}>
                Missing: {missingStandardTasks.map(t=>t.title).join(", ")}
              </div>
            </div>
            <button onClick={syncMissingTasks}
              style={{padding:"7px 16px",borderRadius:8,border:"none",background:"#92400E",
                color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,
                fontFamily:"'DM Sans',sans-serif",flexShrink:0}}>
              + Add to Checklist
            </button>
          </div>
        )}
        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>
          <ReviewLog log={tx.reviewLog||[]}/>
          <div style={{marginBottom:16}}><WorkflowActionBar tx={tx} currentUser={currentUser} users={users} onSubmit={id=>{onUpdateTasks(id,tasks);onSubmit(id);onClose();}} onReview={onReview} onCloseTx={onCloseTx}/></div>
          {((tx.parties&&tx.parties.length>0)||(tx.contacts&&tx.contacts.length>0))&&(
            <div style={{marginBottom:20}}>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                <div style={{height:1,flex:1,background:B.light}}/>
                <span style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.12em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif"}}>Parties & Contacts</span>
                <div style={{height:1,flex:1,background:B.light}}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                {(tx.parties||[]).filter(p=>p.role==="buyer").map(p=>(
                  <div key={p.id} style={{background:B.blue+"0D",border:"1px solid "+B.blue+"33",borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:9,fontWeight:700,color:B.blue,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>Buyer</div>
                    <div style={{fontSize:12,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{p.name||"—"}</div>
                    {p.email&&<div style={{fontSize:11,color:B.gray,marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>{p.email}</div>}
                    {p.phone&&<div style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{p.phone}</div>}
                  </div>
                ))}
                {(tx.parties||[]).filter(p=>p.role==="seller").map(p=>(
                  <div key={p.id} style={{background:B.red+"0D",border:"1px solid "+B.red+"33",borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:9,fontWeight:700,color:B.red,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>Seller</div>
                    <div style={{fontSize:12,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{p.name||"—"}</div>
                    {p.email&&<div style={{fontSize:11,color:B.gray,marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>{p.email}</div>}
                    {p.phone&&<div style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{p.phone}</div>}
                  </div>
                ))}
                {(tx.contacts||[]).filter(c=>c.type==="coop_agent").map(c=>(
                  <div key={c.id} style={{background:B.purple+"0D",border:"1px solid "+B.purple+"33",borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:9,fontWeight:700,color:B.purple,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>Coop Agent</div>
                    <div style={{fontSize:12,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{c.name||"—"}</div>
                    {c.company&&<div style={{fontSize:11,color:B.gray,marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>{c.company}</div>}
                    {c.phone&&<div style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{c.phone}</div>}
                    {c.licenseNo&&<div style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>Lic: {c.licenseNo}</div>}
                  </div>
                ))}
                {(tx.contacts||[]).filter(c=>c.type==="attorney").map(c=>(
                  <div key={c.id} style={{background:B.teal+"0D",border:"1px solid "+B.teal+"33",borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:9,fontWeight:700,color:B.teal,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>Attorney</div>
                    <div style={{fontSize:12,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{c.name||"—"}</div>
                    {c.company&&<div style={{fontSize:11,color:B.gray,marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>{c.company}</div>}
                    {c.phone&&<div style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{c.phone}</div>}
                  </div>
                ))}
                {(tx.contacts||[]).filter(c=>c.type==="title_company").map(c=>(
                  <div key={c.id} style={{background:B.gold+"0D",border:"1px solid "+B.gold+"33",borderRadius:8,padding:"10px 12px"}}>
                    <div style={{fontSize:9,fontWeight:700,color:B.gold,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:4,fontFamily:"'DM Sans',sans-serif"}}>Title Company</div>
                    <div style={{fontSize:12,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{c.name||c.company||"—"}</div>
                    {c.company&&c.name&&<div style={{fontSize:11,color:B.gray,marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>{c.company}</div>}
                    {c.phone&&<div style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{c.phone}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
          {mandatory.length>0&&(<div style={{marginBottom:24}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><div style={{height:1,flex:1,background:B.red+"33"}}/><span style={{fontSize:10,fontWeight:700,color:B.red,letterSpacing:"0.12em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif"}}>Required Documents</span><div style={{height:1,flex:1,background:B.red+"33"}}/></div>
            {mandatory.map(t=><TaskRow key={t.id} task={t}/>)}
          </div>)}
          {optional.length>0&&(<div style={{marginBottom:24}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><div style={{height:1,flex:1,background:B.light}}/><span style={{fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.12em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif"}}>Additional Tasks</span><div style={{height:1,flex:1,background:B.light}}/></div>
            {optional.map(t=><TaskRow key={t.id} task={t}/>)}
          </div>)}
          {!isReadOnly&&!addingCustom&&<button onClick={()=>setAddingCustom(true)} style={{width:"100%",padding:"11px",borderRadius:10,border:"1.5px dashed "+B.light,background:"transparent",color:B.silver,cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>+ Add Custom Task</button>}
          {!isReadOnly&&addingCustom&&(
            <div style={{border:"1px solid "+B.light,borderRadius:10,padding:16,background:B.offWhite}}>
              <div style={{fontSize:12,fontWeight:700,color:B.black,marginBottom:12,fontFamily:"'DM Sans',sans-serif"}}>New Custom Task</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div style={{gridColumn:"1/-1"}}><label style={labelSt}>Title *</label><input value={customForm.title} onChange={e=>setCustomForm(f=>({...f,title:e.target.value}))} style={inputSt}/></div>
                <div><label style={labelSt}>Category</label><select value={customForm.category} onChange={e=>setCustomForm(f=>({...f,category:e.target.value}))} style={inputSt}>{Object.keys(CATEGORY_COLORS).map(c=><option key={c} value={c}>{c}</option>)}</select></div>
                <div><label style={labelSt}>Due Date</label><input type="date" value={customForm.dueDate} onChange={e=>setCustomForm(f=>({...f,dueDate:e.target.value}))} style={inputSt}/></div>
                <div style={{display:"flex",alignItems:"center",gap:8}}><input type="checkbox" id="mc" checked={customForm.mandatory} onChange={e=>setCustomForm(f=>({...f,mandatory:e.target.checked}))}/><label htmlFor="mc" style={{fontSize:12,color:B.black,fontFamily:"'DM Sans',sans-serif",cursor:"pointer"}}>Required (needs document)</label></div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={addCustomTask} style={{padding:"8px 18px",borderRadius:8,border:"none",background:B.red,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>Add</button>
                <button onClick={()=>setAddingCustom(false)} style={{padding:"8px 14px",borderRadius:8,border:"1px solid "+B.light,background:B.white,cursor:"pointer",fontSize:12,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>Cancel</button>
              </div>
            </div>
          )}
        </div>
        <div style={{padding:"16px 24px",borderTop:"1px solid "+B.light,display:"flex",gap:12,justifyContent:"space-between",alignItems:"center",background:B.offWhite,flexWrap:"wrap"}}>
          <WorkflowActionBar tx={tx} currentUser={currentUser} users={users} onSubmit={id=>{onUpdateTasks(id,tasks);onSubmit(id);onClose();}} onReview={onReview} onCloseTx={onCloseTx}/>
          <div style={{display:"flex",gap:10,marginLeft:"auto"}}>
            <button onClick={onClose} style={{padding:"10px 20px",borderRadius:8,border:"1px solid "+B.light,background:B.white,cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",color:B.gray}}>Discard</button>
            {!isReadOnly&&<button onClick={save} disabled={saving} style={{padding:"10px 24px",borderRadius:8,border:"none",background:saving?B.light:B.red,color:saving?B.silver:B.white,cursor:saving?"wait":"pointer",fontSize:13,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>{saving?"Saving…":"Save Checklist"}</button>}
          </div>
        </div>
      </div>
      {previewDoc&&<DocPreviewModal doc={previewDoc} onClose={()=>setPreviewDoc(null)}/>}
    </div>
  );
}

// ─── Transaction Modal ────────────────────────────────────────────────────────
// Tabs: Details | Parties | Contacts

// Empty contact template
const emptyContact = (type) => ({
  id: "c_"+Math.random().toString(36).slice(2,8),
  type,           // "buyer"|"seller"|"coop_agent"|"attorney"|"title_company"
  name:"", email:"", phone:"", company:"", address:"", licenseNo:"",
});

// Empty party template (buyer / seller)
export const emptyParty = (role) => ({
  id:"p_"+Math.random().toString(36).slice(2,8),
  role,           // "buyer"|"seller"
  name:"", email:"", phone:"", address:"",
});

function ContactCard({ contact, onChange, onRemove, readOnly }) {
  const labels = {
    buyer:         { title:"Buyer",              color:B.blue,   showLicense:false, showCompany:false },
    seller:        { title:"Seller",             color:B.red,    showLicense:false, showCompany:false },
    coop_agent:    { title:"Cooperating Agent",  color:B.purple, showLicense:true,  showCompany:true  },
    attorney:      { title:"Closing Attorney",   color:B.teal,   showLicense:true,  showCompany:true  },
    title_company: { title:"Title Company",      color:B.gold,   showLicense:false, showCompany:true  },
  };
  const meta = labels[contact.type] || { title:"Contact", color:B.silver, showLicense:false, showCompany:false };
  const inp  = { width:"100%", padding:"7px 10px", borderRadius:7, border:"1px solid "+B.light, fontSize:12, fontFamily:"'DM Sans',sans-serif", background:readOnly?"#F9F9F9":B.offWhite, outline:"none", color:B.black, boxSizing:"border-box" };
  const lbl  = { fontSize:10, fontWeight:700, color:B.silver, letterSpacing:"0.08em", textTransform:"uppercase", display:"block", marginBottom:3, fontFamily:"'DM Sans',sans-serif" };
  const set  = (k,v) => onChange({ ...contact, [k]:v });

  return (
    <div style={{ border:"1px solid "+meta.color+"44", borderRadius:10, padding:"14px 16px", background:meta.color+"08", marginBottom:10 }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
        <span style={{ fontSize:11, fontWeight:700, color:meta.color, fontFamily:"'DM Sans',sans-serif", letterSpacing:"0.06em", textTransform:"uppercase" }}>{meta.title}</span>
        {!readOnly && <button onClick={onRemove} style={{ background:"none", border:"none", cursor:"pointer", color:B.silver, fontSize:16, lineHeight:1 }}>✕</button>}
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"8px 12px" }}>
        <div style={{ gridColumn:"1/-1" }}>
          <label style={lbl}>Full Name *</label>
          <input value={contact.name} onChange={e=>set("name",e.target.value)} disabled={readOnly} style={inp} placeholder="First Last" />
        </div>
        <div>
          <label style={lbl}>Email</label>
          <input value={contact.email} onChange={e=>set("email",e.target.value)} disabled={readOnly} style={inp} placeholder="name@email.com" />
        </div>
        <div>
          <label style={lbl}>Phone</label>
          <input value={contact.phone} onChange={e=>set("phone",e.target.value)} disabled={readOnly} style={inp} placeholder="205-555-0100" />
        </div>
        {meta.showCompany && (
          <div style={{ gridColumn:"1/-1" }}>
            <label style={lbl}>{contact.type==="title_company"?"Company Name":"Firm / Company"}</label>
            <input value={contact.company} onChange={e=>set("company",e.target.value)} disabled={readOnly} style={inp} placeholder="Company name" />
          </div>
        )}
        <div style={{ gridColumn:"1/-1" }}>
          <label style={lbl}>Address</label>
          <input value={contact.address} onChange={e=>set("address",e.target.value)} disabled={readOnly} style={inp} placeholder="Street, City, State ZIP" />
        </div>
        {meta.showLicense && (
          <div>
            <label style={lbl}>License No.</label>
            <input value={contact.licenseNo} onChange={e=>set("licenseNo",e.target.value)} disabled={readOnly} style={inp} placeholder="AL-XXXXXX" />
          </div>
        )}
      </div>
    </div>
  );
}

function TransactionModal({ tx, currentUser, users, checklistTemplates, onClose, onSave, onOpenChecklist }) {
  const isNew = !tx.id;
  const [activeTab, setActiveTab] = useState("details"); // details | parties | contacts

  const eligibleAgents = currentUser.role==="realtor"
    ? users.filter(u=>u.id===currentUser.id)
    : currentUser.role==="associate_broker"
    ? users.filter(u=>u.id===currentUser.id||(u.role==="realtor"&&u.brokerId===currentUser.id))
    : users;

  // ── Details form state ──
  const isPrincipal = currentUser.role === "principal_broker";

  // Pull fee defaults from agent profile when creating new transaction
  // Intentionally runs once on mount only — sets initial form defaults, should not re-run as user types
  const agentFees = useMemo(() => {
    const agentId = isNew ? currentUser.id : (tx.agentId || currentUser.id);
    return getAgentFees(agentId, users);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── Autosave draft key — unique per transaction (or "new" for a fresh one) ──
  const draftKey = "aks_draft_tx_" + (isNew ? "new" : tx.id);

  function loadDraft() {
    try {
      const raw = localStorage.getItem(draftKey);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      // Drafts older than 7 days are considered stale and ignored
      if (Date.now() - (parsed.savedAt||0) > 7*24*60*60*1000) {
        localStorage.removeItem(draftKey);
        return null;
      }
      return parsed;
    } catch { return null; }
  }

  const restoredDraft = loadDraft();
  const [draftRestored, setDraftRestored] = useState(!!restoredDraft);

  const [form, setForm] = useState(() => {
    if (restoredDraft?.form) return restoredDraft.form;
    return isNew
      ? { agentId:currentUser.id, side:"Buyer", address:"", clientName:"", price:"",
          stage:"Pre-Listing / Pre-Offer", commissionPct:2.5, referralFee:0,
          agentSplit:  agentFees.agentSplit,
          transactionFee: agentFees.transactionFee,
          eoFee:       agentFees.eoFee,
          customFees:  agentFees.customFees || [],
          contractDate:"", inspectionDeadline:"", appraisalDeadline:"", closingDate:"", notes:"" }
      : { ...tx,
          transactionFee: tx.transactionFee ?? agentFees.transactionFee,
          eoFee:          tx.eoFee          ?? agentFees.eoFee,
          customFees:     tx.customFees     || agentFees.customFees || [],
        };
  });
  const set    = (k,v) => setForm(f=>({...f,[k]:v}));
  const handle = k => e => set(k, e.target.value);

  // When agent changes on a new transaction, reload fee defaults
  function handleAgentChange(newAgentId) {
    set("agentId", newAgentId);
    if (isNew) {
      const fees = getAgentFees(newAgentId, users);
      setForm(f => ({ ...f, agentId:newAgentId,
        agentSplit: fees.agentSplit,
        transactionFee: fees.transactionFee,
        eoFee: fees.eoFee,
        customFees: fees.customFees || [],
      }));
    }
  }

  // Custom fee helpers
  function addCustomFeeLine() {
    set("customFees", [...(form.customFees||[]), { id:genId(), label:"", amount:0, type:"flat" }]);
  }
  function updateCustomFee(id, patch) {
    set("customFees", (form.customFees||[]).map(f => f.id===id ? {...f,...patch} : f));
  }
  function removeCustomFee(id) {
    set("customFees", (form.customFees||[]).filter(f => f.id!==id));
  }

  // ── Parties state (buyers + sellers) ──
  const [parties, setParties] = useState(() => {
    if (restoredDraft?.parties) return restoredDraft.parties;
    if (!isNew && tx.parties) return tx.parties;
    // Pre-populate one buyer or seller from legacy clientName field
    const name = isNew ? "" : (tx.clientName||"");
    const role = isNew ? (form.side==="Buyer"?"buyer":"seller") : (tx.side==="Buyer"?"buyer":"seller");
    return name ? [{ ...emptyParty(role), name }] : [];
  });

  // ── Contacts state (coop agent, attorney, title company) ──
  const [contacts, setContacts] = useState(() => {
    if (restoredDraft?.contacts) return restoredDraft.contacts;
    if (!isNew && tx.contacts) return tx.contacts;
    return [];
  });

  // ── Autosave draft to localStorage whenever form/parties/contacts change ──
  // This protects against Chrome tab discarding, accidental refresh, or crashes.
  // Skips the very first run (on mount) — otherwise merely opening a
  // transaction to look at it, with zero edits, would write a "draft" that
  // outlives the modal and falsely shows the "unsaved draft" banner later.
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) { isFirstRender.current = false; return; }
    const draft = { form, parties, contacts, savedAt: Date.now() };
    try { localStorage.setItem(draftKey, JSON.stringify(draft)); } catch {}
  }, [form, parties, contacts]); // eslint-disable-line

  function clearDraft() {
    try { localStorage.removeItem(draftKey); } catch {}
  }

  function discardDraftAndReset() {
    clearDraft();
    setDraftRestored(false);
    window.location.reload(); // simplest reliable way to fully reset the modal
  }

  function addParty(role) { setParties(p=>[...p, emptyParty(role)]); }
  function updateParty(id,patch) { setParties(p=>p.map(x=>x.id===id?{...x,...patch}:x)); }
  function removeParty(id) { setParties(p=>p.filter(x=>x.id!==id)); }

  function addContact(type) { setContacts(c=>[...c, emptyContact(type)]); }
  function updateContact(id,patch) { setContacts(c=>c.map(x=>x.id===id?{...x,...patch}:x)); }
  function removeContact(id) { setContacts(c=>c.filter(x=>x.id!==id)); }

  const assignedBroker = getAssignedBroker(form.agentId, users);
  const feeCalc = form.price
    ? calcAgentNetFull(Number(form.price), Number(form.commissionPct), Number(form.referralFee),
        { agentSplit:form.agentSplit, transactionFee:form.transactionFee,
          eoFee:form.eoFee, customFees:form.customFees })
    : { gci:0, agentNet:0, brokerageKeeps:0, txFee:0, eoFee:0, customTotal:0 };
  const gci      = feeCalc.gci;
  const agentNet = feeCalc.agentNet;

  // Derive clientName from parties list for display elsewhere
  const derivedClientName = parties.map(p=>p.name).filter(Boolean).join(" & ") || form.clientName || "";

  function handleSave() {
    clearDraft();
    onSave({
      ...form,
      id: form.id||genId(),
      price:          Number(form.price),
      commissionPct:  Number(form.commissionPct),
      referralFee:    Number(form.referralFee),
      agentSplit:     Number(form.agentSplit),
      transactionFee: Number(form.transactionFee||0),
      eoFee:          Number(form.eoFee||0),
      customFees:     form.customFees||[],
      clientName:     derivedClientName,
      parties,
      contacts,
      tasks:      isNew ? buildTasks(form.side, checklistTemplates) : (tx.tasks||[]),
      wfState:    isNew ? "draft" : (tx.wfState||"draft"),
      reviewLog:  isNew ? [] : (tx.reviewLog||[]),
      submittedAt: tx.submittedAt||null,
    });
  }

  const inputSt = { width:"100%", padding:"9px 12px", borderRadius:8, border:"1px solid "+B.light, fontSize:13, color:B.black, fontFamily:"'DM Sans',sans-serif", background:B.offWhite, outline:"none", boxSizing:"border-box" };
  const labelSt = { fontSize:10, fontWeight:700, color:B.silver, letterSpacing:"0.09em", textTransform:"uppercase", marginBottom:4, display:"block", fontFamily:"'DM Sans',sans-serif" };
  const field   = (label,key,type="text",options=null) => (
    <div style={{ marginBottom:14 }}>
      <label style={labelSt}>{label}</label>
      {options
        ? <select value={form[key]} onChange={handle(key)} style={inputSt}>{options.map(o=><option key={o.value||o} value={o.value||o}>{o.label||o}</option>)}</select>
        : <input type={type} value={form[key]} onChange={handle(key)} style={inputSt} />}
    </div>
  );

  // Tab counts for badges
  const buyerCount  = parties.filter(p=>p.role==="buyer").length;
  const sellerCount = parties.filter(p=>p.role==="seller").length;
  const contactCount= contacts.length;

  const TabBtn = ({ id, label, count }) => (
    <button onClick={()=>setActiveTab(id)}
      style={{ padding:"8px 18px", borderRadius:"8px 8px 0 0", border:"none", cursor:"pointer",
        background: activeTab===id ? B.white : B.offWhite,
        borderBottom: activeTab===id ? "2px solid "+B.red : "2px solid transparent",
        fontSize:12, fontWeight:700, color: activeTab===id ? B.red : B.silver,
        fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", gap:6 }}>
      {label}
      {count > 0 && <span style={{ background: activeTab===id ? B.red : B.light, color: activeTab===id ? B.white : B.silver, borderRadius:10, padding:"1px 7px", fontSize:10, fontWeight:700 }}>{count}</span>}
    </button>
  );

  const sectionHead = (title) => (
    <div style={{ display:"flex", alignItems:"center", gap:10, margin:"18px 0 12px" }}>
      <div style={{ height:1, flex:1, background:B.light }} />
      <span style={{ fontSize:10, fontWeight:700, color:B.silver, letterSpacing:"0.1em", textTransform:"uppercase", fontFamily:"'DM Sans',sans-serif" }}>{title}</span>
      <div style={{ height:1, flex:1, background:B.light }} />
    </div>
  );

  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:B.white, borderRadius:16, width:"100%", maxWidth:720, maxHeight:"92vh", overflow:"hidden", display:"flex", flexDirection:"column", boxShadow:"0 20px 60px rgba(0,0,0,0.25)" }}>

        {/* Header */}
        <div style={{ padding:"20px 28px 0", borderBottom:"1px solid "+B.light, flexShrink:0 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
            <h2 style={{ margin:0, fontSize:20, fontFamily:"'Playfair Display',serif", color:B.black }}>{isNew?"New Transaction":"Edit Transaction"}</h2>
            <button onClick={onClose} style={{ background:"none", border:"none", fontSize:22, cursor:"pointer", color:B.gray }}>✕</button>
          </div>
          {draftRestored && (
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10,
              background:"#EFF6FF", border:"1px solid #BFDBFE", borderRadius:8,
              padding:"8px 14px", marginBottom:14, flexWrap:"wrap" }}>
              <span style={{ fontSize:12, color:"#1E40AF", fontFamily:"'DM Sans',sans-serif" }}>
                💾 Restored your unsaved draft from before the page reloaded.
              </span>
              <button onClick={discardDraftAndReset}
                style={{ padding:"3px 10px", borderRadius:6, border:"1px solid #BFDBFE",
                  background:"transparent", cursor:"pointer", fontSize:11, color:"#1E40AF",
                  fontFamily:"'DM Sans',sans-serif", fontWeight:600, flexShrink:0 }}>
                Discard & Start Fresh
              </button>
            </div>
          )}
          {/* Tabs */}
          <div style={{ display:"flex", gap:4, alignItems:"center", flexWrap:"wrap" }}>
            <TabBtn id="details"  label="Details"  count={0} />
            <TabBtn id="parties"  label="Parties"  count={buyerCount+sellerCount} />
            <TabBtn id="contacts" label="Contacts" count={contactCount} />
            {!isNew && onOpenChecklist && (
              <button onClick={()=>onOpenChecklist(tx)}
                style={{ marginLeft:"auto", padding:"8px 16px", borderRadius:"8px 8px 0 0",
                  border:"none", borderBottom:"2px solid transparent",
                  background:"transparent", cursor:"pointer",
                  fontSize:12, fontWeight:700, color:B.teal,
                  fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", gap:6 }}>
                📎 Documents & Checklist
                {(() => {
                  const mandatory = (tx.tasks||[]).filter(t=>t.mandatory);
                  const done = mandatory.filter(t=>t.documents?.length>0).length;
                  return (
                    <span style={{ fontSize:10, padding:"1px 8px", borderRadius:10,
                      background: done===mandatory.length && mandatory.length>0 ? B.green+"22" : B.red+"22",
                      color: done===mandatory.length && mandatory.length>0 ? B.green : B.red,
                      fontWeight:700 }}>
                      {done}/{mandatory.length}
                    </span>
                  );
                })()}
              </button>
            )}
          </div>
        </div>

        {/* Scrollable body */}
        <div style={{ flex:1, overflowY:"auto", padding:"20px 28px" }}>

          {/* ── TAB: DETAILS ── */}
          {activeTab==="details" && (
            <div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 20px" }}>
                <div style={{ gridColumn:"1/-1" }}>{field("Property Address","address")}</div>
                <div style={{ marginBottom:14 }}>
          <label style={labelSt}>Agent</label>
          <select value={form.agentId} onChange={e=>handleAgentChange(e.target.value)} style={inputSt}>
            {eligibleAgents.map(u=><option key={u.id} value={u.id}>{u.name} ({ROLES[u.role].short})</option>)}
          </select>
        </div>
                {field("Transaction Side","side","text",["Buyer","Seller"])}
                {field("Stage","stage","text",STAGES)}
                {field("Sale Price ($)","price","number")}
                {field("Commission %","commissionPct","number")}
                {field("Referral Fee ($)","referralFee","number")}

                {/* ── Fee fields: locked for non-principal ── */}
                <div style={{ gridColumn:"1/-1" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:8, margin:"4px 0 12px" }}>
                    <div style={{ height:1, flex:1, background:B.light }}/>
                    <span style={{ fontSize:10, fontWeight:700, color:isPrincipal?B.red:B.silver, letterSpacing:"0.1em", textTransform:"uppercase", fontFamily:"'DM Sans',sans-serif" }}>
                      {isPrincipal?"✏ Fee Structure (editable)":"🔒 Fee Structure (set by broker)"}
                    </span>
                    <div style={{ height:1, flex:1, background:B.light }}/>
                  </div>
                  {!isPrincipal&&(
                    <div style={{ background:B.gold+"11", border:"1px solid "+B.gold+"33", borderRadius:8, padding:"8px 12px", marginBottom:12, fontSize:11, color:B.gold, fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>
                      ℹ Fee defaults are set by your broker on your agent profile. Contact your broker to make changes.
                    </div>
                  )}
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 20px" }}>
                    <div style={{ marginBottom:14 }}>
                      <label style={labelSt}>Agent Split %</label>
                      <input type="number" value={form.agentSplit} onChange={handle("agentSplit")} disabled={!isPrincipal}
                        style={{ ...inputSt, background:isPrincipal?B.offWhite:"#F3F3F3" }}/>
                    </div>
                    <div style={{ marginBottom:14 }}>
                      <label style={labelSt}>Transaction Fee ($)</label>
                      <input type="number" value={form.transactionFee||0} onChange={handle("transactionFee")} disabled={!isPrincipal}
                        style={{ ...inputSt, background:isPrincipal?B.offWhite:"#F3F3F3" }}/>
                    </div>
                    <div style={{ marginBottom:14 }}>
                      <label style={labelSt}>E&O Fee ($)</label>
                      <input type="number" value={form.eoFee||0} onChange={handle("eoFee")} disabled={!isPrincipal}
                        style={{ ...inputSt, background:isPrincipal?B.offWhite:"#F3F3F3" }}/>
                    </div>
                  </div>
                  {(form.customFees||[]).map(f=>(
                    <div key={f.id} style={{ display:"grid", gridTemplateColumns:"1fr 100px 80px 32px", gap:8, marginBottom:8, alignItems:"end" }}>
                      <div><label style={labelSt}>Fee Label</label><input value={f.label} onChange={e=>updateCustomFee(f.id,{label:e.target.value})} disabled={!isPrincipal} style={{ ...inputSt, background:isPrincipal?B.offWhite:"#F3F3F3" }} placeholder="e.g. Admin Fee"/></div>
                      <div><label style={labelSt}>Amount</label><input type="number" value={f.amount} onChange={e=>updateCustomFee(f.id,{amount:e.target.value})} disabled={!isPrincipal} style={{ ...inputSt, background:isPrincipal?B.offWhite:"#F3F3F3" }}/></div>
                      <div><label style={labelSt}>Type</label><select value={f.type} onChange={e=>updateCustomFee(f.id,{type:e.target.value})} disabled={!isPrincipal} style={{ ...inputSt, background:isPrincipal?B.offWhite:"#F3F3F3" }}><option value="flat">$ Flat</option><option value="pct">% of GCI</option></select></div>
                      {isPrincipal&&<button onClick={()=>removeCustomFee(f.id)} style={{ height:36, borderRadius:6, border:"1px solid #FEE2E2", background:"#FFF5F5", cursor:"pointer", color:"#DC2626", fontSize:14, alignSelf:"flex-end" }}>✕</button>}
                    </div>
                  ))}
                  {isPrincipal&&<button onClick={addCustomFeeLine} style={{ display:"flex", alignItems:"center", gap:6, padding:"7px 14px", borderRadius:8, border:"1.5px dashed "+B.light, background:"transparent", color:B.silver, cursor:"pointer", fontSize:12, fontFamily:"'DM Sans',sans-serif", marginBottom:8 }}>+ Add Custom Fee</button>}
                </div>
                {field("Contract Date","contractDate","date")}
                {field("Inspection Deadline","inspectionDeadline","date")}
                {field("Appraisal Deadline","appraisalDeadline","date")}
                {field("Closing Date","closingDate","date")}
                <div style={{ gridColumn:"1/-1", marginBottom:14 }}>
                  <label style={labelSt}>Notes</label>
                  <textarea value={form.notes} onChange={handle("notes")} rows={3} style={{ ...inputSt, resize:"vertical" }} />
                </div>
              </div>

              {assignedBroker && (
                <div style={{ background:B.teal+"11", border:"1px solid "+B.teal+"44", borderRadius:10, padding:"10px 16px", marginBottom:16, display:"flex", alignItems:"center", gap:10 }}>
                  <Avatar name={assignedBroker.name} role={assignedBroker.role} size={28} photo={assignedBroker.photo||null}/>
                  <div style={{ fontSize:12, color:B.teal, fontFamily:"'DM Sans',sans-serif" }}>
                    <strong>{assignedBroker.name}</strong> will review this transaction when submitted.
                  </div>
                </div>
              )}

              {form.price > 0 && (
                <div style={{ background:B.offWhite, borderRadius:10, padding:"16px 18px", marginBottom:16 }}>
                  <div style={{ display:"flex", gap:24, flexWrap:"wrap", marginBottom:(feeCalc.txFee>0||feeCalc.eoFee>0||feeCalc.customTotal>0)?12:0 }}>
                    {[["GCI",fmt(gci),B.red],["Agent Net",fmt(agentNet),B.green],["Brokerage Keeps",fmt(feeCalc.brokerageKeeps),B.black]].map(([l,v,c])=>(
                      <div key={l}><div style={{ fontSize:10, fontWeight:700, color:B.silver, letterSpacing:"0.08em", textTransform:"uppercase", marginBottom:2, fontFamily:"'DM Sans',sans-serif" }}>{l}</div><div style={{ fontSize:16, fontWeight:800, color:c, fontFamily:"'Playfair Display',serif" }}>{v}</div></div>
                    ))}
                  </div>
                  {(feeCalc.txFee>0||feeCalc.eoFee>0||feeCalc.customTotal>0)&&(
                    <div style={{ borderTop:"1px solid "+B.light, paddingTop:10, display:"flex", gap:16, flexWrap:"wrap" }}>
                      <span style={{ fontSize:10, fontWeight:700, color:B.silver, letterSpacing:"0.08em", textTransform:"uppercase", fontFamily:"'DM Sans',sans-serif", alignSelf:"center" }}>Deductions:</span>
                      {feeCalc.txFee>0&&<span style={{ fontSize:12, color:B.gray, fontFamily:"'DM Sans',sans-serif" }}>Tx Fee: <strong>{fmt(feeCalc.txFee)}</strong></span>}
                      {feeCalc.eoFee>0&&<span style={{ fontSize:12, color:B.gray, fontFamily:"'DM Sans',sans-serif" }}>E&O: <strong>{fmt(feeCalc.eoFee)}</strong></span>}
                      {(form.customFees||[]).filter(f=>Number(f.amount)>0).map(f=>(
                        <span key={f.id} style={{ fontSize:12, color:B.gray, fontFamily:"'DM Sans',sans-serif" }}>{f.label||"Custom"}: <strong>{f.type==="pct"?f.amount+"%":fmt(Number(f.amount))}</strong></span>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {isNew && <div style={{ background:B.red+"11", border:"1px solid "+B.red+"33", borderRadius:10, padding:"10px 16px", fontSize:12, color:B.red, fontFamily:"'DM Sans',sans-serif" }}>📋 Task checklist auto-created on save based on transaction side.</div>}
            </div>
          )}

          {/* ── TAB: PARTIES ── */}
          {activeTab==="parties" && (
            <div>
              {/* Buyers */}
              {sectionHead("Buyers")}
              {parties.filter(p=>p.role==="buyer").map(p=>(
                <ContactCard key={p.id} contact={p} onChange={patch=>updateParty(p.id,patch)} onRemove={()=>removeParty(p.id)} readOnly={false}/>
              ))}
              <button onClick={()=>addParty("buyer")}
                style={{ display:"flex", alignItems:"center", gap:8, width:"100%", padding:"10px 14px", borderRadius:8, border:"1.5px dashed "+B.blue, background:B.blue+"08", color:B.blue, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", marginBottom:8 }}>
                + Add Buyer
              </button>

              {/* Sellers */}
              {sectionHead("Sellers")}
              {parties.filter(p=>p.role==="seller").map(p=>(
                <ContactCard key={p.id} contact={p} onChange={patch=>updateParty(p.id,patch)} onRemove={()=>removeParty(p.id)} readOnly={false}/>
              ))}
              <button onClick={()=>addParty("seller")}
                style={{ display:"flex", alignItems:"center", gap:8, width:"100%", padding:"10px 14px", borderRadius:8, border:"1.5px dashed "+B.red, background:B.red+"08", color:B.red, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif" }}>
                + Add Seller
              </button>

              {parties.length===0 && (
                <div style={{ textAlign:"center", padding:"24px 0", color:B.silver, fontSize:12, fontFamily:"'DM Sans',sans-serif", fontStyle:"italic" }}>No parties added yet. Add buyers and/or sellers above.</div>
              )}
            </div>
          )}

          {/* ── TAB: CONTACTS ── */}
          {activeTab==="contacts" && (
            <div>
              {/* Cooperating Agent */}
              {sectionHead("Cooperating Agent")}
              {contacts.filter(c=>c.type==="coop_agent").map(c=>(
                <ContactCard key={c.id} contact={c} onChange={patch=>updateContact(c.id,patch)} onRemove={()=>removeContact(c.id)} readOnly={false}/>
              ))}
              {contacts.filter(c=>c.type==="coop_agent").length===0 && (
                <button onClick={()=>addContact("coop_agent")}
                  style={{ display:"flex", alignItems:"center", gap:8, width:"100%", padding:"10px 14px", borderRadius:8, border:"1.5px dashed "+B.purple, background:B.purple+"08", color:B.purple, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", marginBottom:8 }}>
                  + Add Cooperating Agent
                </button>
              )}

              {/* Closing Attorney */}
              {sectionHead("Closing Attorney")}
              {contacts.filter(c=>c.type==="attorney").map(c=>(
                <ContactCard key={c.id} contact={c} onChange={patch=>updateContact(c.id,patch)} onRemove={()=>removeContact(c.id)} readOnly={false}/>
              ))}
              {contacts.filter(c=>c.type==="attorney").length===0 && (
                <button onClick={()=>addContact("attorney")}
                  style={{ display:"flex", alignItems:"center", gap:8, width:"100%", padding:"10px 14px", borderRadius:8, border:"1.5px dashed "+B.teal, background:B.teal+"08", color:B.teal, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif", marginBottom:8 }}>
                  + Add Closing Attorney
                </button>
              )}

              {/* Title Company */}
              {sectionHead("Title Company")}
              {contacts.filter(c=>c.type==="title_company").map(c=>(
                <ContactCard key={c.id} contact={c} onChange={patch=>updateContact(c.id,patch)} onRemove={()=>removeContact(c.id)} readOnly={false}/>
              ))}
              {contacts.filter(c=>c.type==="title_company").length===0 && (
                <button onClick={()=>addContact("title_company")}
                  style={{ display:"flex", alignItems:"center", gap:8, width:"100%", padding:"10px 14px", borderRadius:8, border:"1.5px dashed "+B.gold, background:B.gold+"08", color:B.gold, cursor:"pointer", fontSize:12, fontWeight:700, fontFamily:"'DM Sans',sans-serif" }}>
                  + Add Title Company
                </button>
              )}

              {contacts.length===0 && (
                <div style={{ textAlign:"center", padding:"24px 0", color:B.silver, fontSize:12, fontFamily:"'DM Sans',sans-serif", fontStyle:"italic" }}>No contacts added yet. Add cooperating agent, attorney, or title company above.</div>
              )}
            </div>
          )}

        </div>

        {/* Footer */}
        <div style={{ padding:"16px 28px", borderTop:"1px solid "+B.light, display:"flex", gap:10, justifyContent:"space-between", alignItems:"center", background:B.offWhite, flexShrink:0 }}>
          <div style={{ fontSize:11, color:B.silver, fontFamily:"'DM Sans',sans-serif" }}>
            {derivedClientName && <span>👤 {derivedClientName}</span>}
          </div>
          <div style={{ display:"flex", gap:10 }}>
            <button onClick={onClose} style={{ padding:"10px 20px", borderRadius:8, border:"1px solid "+B.light, background:B.white, cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif", color:B.gray }}>Cancel</button>
            <button onClick={handleSave} style={{ padding:"10px 24px", borderRadius:8, border:"none", background:B.red, color:B.white, cursor:"pointer", fontSize:13, fontWeight:700, fontFamily:"'DM Sans',sans-serif" }}>{isNew?"Add Transaction":"Save Changes"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}


// ─── Realtor Dashboard ────────────────────────────────────────────────────────
function RealtorDashboard({ currentUser, transactions, users, onOpenChecklist }) {
  const myTx      = transactions.filter(t => t.agentId === currentUser.id);
  const activeTx  = myTx.filter(t => !["closed","fallen_through"].includes(t.wfState));
  const closedTx  = myTx.filter(t => t.wfState === "closed");
  const pendingTx = myTx.filter(t => t.wfState === "submitted");
  const approvedTx= myTx.filter(t => t.wfState === "approved");

  // Financials
  const closedGCI   = closedTx.reduce((s,t) => s + calcAgentNetFull(t.price,t.commissionPct,t.referralFee||0,
    {agentSplit:t.agentSplit,transactionFee:t.transactionFee||0,eoFee:t.eoFee||0,customFees:t.customFees||[]}).agentNet, 0);
  const pipelineGCI = activeTx.reduce((s,t) => s + calcAgentNetFull(t.price,t.commissionPct,t.referralFee||0,
    {agentSplit:t.agentSplit,transactionFee:t.transactionFee||0,eoFee:t.eoFee||0,customFees:t.customFees||[]}).agentNet, 0);

  // Broker feedback alerts — changes_requested with comments
  const brokerAlerts = myTx
    .filter(t => t.wfState === "changes_requested")
    .map(t => {
      const lastRequest = [...(t.reviewLog||[])].reverse().find(e => e.action === "changes_requested");
      return { tx:t, entry:lastRequest };
    })
    .filter(a => a.entry);

  // Compliance — transactions with missing mandatory docs (not closed/fallen)
  const complianceIssues = activeTx.map(t => {
    const missing = (t.tasks||[]).filter(task => task.mandatory && task.documents.length === 0);
    return { tx:t, missing };
  }).filter(c => c.missing.length > 0);

  // Upcoming deadlines — next 30 days across all active transactions
  const today = new Date();
  const deadlines = [];
  activeTx.forEach(t => {
    const clientName = (t.parties&&t.parties.length>0) ? t.parties.map(p=>p.name).filter(Boolean).join(" & ") : t.clientName;
    const addr = t.address.split(",")[0];
    [
      { label:"Inspection",  date:t.inspectionDeadline },
      { label:"Appraisal",   date:t.appraisalDeadline  },
      { label:"Closing",     date:t.closingDate        },
      { label:"Contract",    date:t.contractDate       },
    ].forEach(({ label, date }) => {
      if (!date) return;
      const d   = new Date(date + "T00:00:00");
      const due = Math.ceil((d - today) / 86400000);
      if (due <= 30) deadlines.push({ tx:t, label, date, due, addr, clientName });
    });
  });
  deadlines.sort((a,b) => a.due - b.due);

  // Stage counts for mini pipeline
  const stageCounts = {};
  STAGES.forEach(s => { stageCounts[s] = 0; });
  myTx.forEach(t => { if (stageCounts[t.stage] !== undefined) stageCounts[t.stage]++; });

  const assignedBroker = getAssignedBroker(currentUser.id, users);

  // ── 12-month closed transaction ledger — address, side, price, agent/broker commission ──
  const ledgerTx = useMemo(() => {
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    return closedTx
      .filter(tx => tx.closingDate && new Date(tx.closingDate+"T00:00:00") >= oneYearAgo)
      .map(tx => {
        // Use the transaction's OWN stored fee terms (snapshotted at creation/edit time),
        // not the agent's current profile — a later profile change shouldn't alter
        // the recorded commission split on a historical deal.
        const fees = {
          agentSplit:     tx.agentSplit,
          transactionFee: tx.transactionFee,
          eoFee:          tx.eoFee,
          customFees:     tx.customFees || [],
        };
        const calc = calcAgentNetFull(tx.price, tx.commissionPct, tx.referralFee, fees);
        return { ...tx, agentCommission: calc.agentNet, brokerCommission: calc.brokerageKeeps };
      })
      .sort((a,b) => new Date(b.closingDate) - new Date(a.closingDate));
  }, [closedTx]);

  return (
    <div>
      {/* Welcome bar */}
      <div style={{ background:B.black, borderRadius:12, padding:"18px 24px", marginBottom:24,
        display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12 }}>
        <div style={{ display:"flex", alignItems:"center", gap:14 }}>
          <Avatar name={currentUser.name} role={currentUser.role} size={48} photo={currentUser.photo||null}/>
          <div>
            <div style={{ fontSize:18, fontWeight:800, color:B.white, fontFamily:"'Playfair Display',serif" }}>
              Welcome back, {currentUser.name.split(" ")[0]}
            </div>
            <div style={{ fontSize:12, color:B.silver, marginTop:3, fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", gap:8 }}>
              <RoleBadge role={currentUser.role}/>
              {assignedBroker && <span>Broker: <strong style={{color:B.teal}}>{assignedBroker.name}</strong></span>}
              {currentUser.licenseNo && <span>Lic: {currentUser.licenseNo}</span>}
            </div>
          </div>
        </div>
        <div style={{ display:"flex", gap:12, flexWrap:"wrap" }}>
          {[
            ["Active",   activeTx.length,  B.blue  ],
            ["Pending",  pendingTx.length,  B.gold  ],
            ["Approved", approvedTx.length, B.teal  ],
            ["Closed",   closedTx.length,   B.green ],
          ].map(([l,v,c]) => (
            <div key={l} style={{ textAlign:"center", padding:"8px 16px", borderRadius:10,
              background:c+"22", border:"1px solid "+c+"44" }}>
              <div style={{ fontSize:20, fontWeight:800, color:c, fontFamily:"'Playfair Display',serif" }}>{v}</div>
              <div style={{ fontSize:10, color:c, fontWeight:700, letterSpacing:"0.08em",
                textTransform:"uppercase", fontFamily:"'DM Sans',sans-serif" }}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Financial stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:16, marginBottom:24 }}>
        <StatCard label="Agent Net (Closed)" value={fmt(closedGCI)}
          sub={closedTx.length+" closed transaction"+(closedTx.length!==1?"s":"")} accent={B.green}/>
        <StatCard label="Agent Net (Pipeline)" value={fmt(pipelineGCI)}
          sub={activeTx.length+" active transaction"+(activeTx.length!==1?"s":"")} accent={B.blue}/>
        <StatCard label="Total Volume (Closed)" value={fmt(closedTx.reduce((s,t)=>s+t.price,0))}
          sub="Sum of closed sale prices" accent={B.red}/>
        <StatCard label="Avg Sale Price" value={closedTx.length?fmt(closedTx.reduce((s,t)=>s+t.price,0)/closedTx.length):"—"}
          sub="Closed transactions" accent={B.purple}/>
      </div>

      {/* ── Broker Alerts ── */}
      {brokerAlerts.length > 0 && (
        <div style={{ background:"#FFF5F5", border:"1px solid #FCA5A5", borderRadius:12,
          padding:"16px 20px", marginBottom:24 }}>
          <div style={{ fontSize:13, fontWeight:700, color:"#DC2626", marginBottom:12,
            fontFamily:"'DM Sans',sans-serif", display:"flex", alignItems:"center", gap:8 }}>
            ↩ Broker Feedback — {brokerAlerts.length} Transaction{brokerAlerts.length!==1?"s":""} Need Your Attention
          </div>
          {brokerAlerts.map(({ tx, entry }) => {
            const clientName = (tx.parties&&tx.parties.length>0) ? tx.parties.map(p=>p.name).filter(Boolean).join(" & ") : tx.clientName;
            return (
              <div key={tx.id} style={{ background:B.white, borderRadius:10, padding:"12px 16px",
                marginBottom:8, border:"1px solid #FEE2E2", cursor:"pointer" }}
                onClick={() => onOpenChecklist(tx)}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start",
                  flexWrap:"wrap", gap:8 }}>
                  <div>
                    <div style={{ fontSize:13, fontWeight:700, color:B.black,
                      fontFamily:"'DM Sans',sans-serif" }}>{tx.address.split(",")[0]}</div>
                    <div style={{ fontSize:11, color:B.gray, marginTop:2,
                      fontFamily:"'DM Sans',sans-serif" }}>{clientName} · {fmtDate(tx.closingDate)}</div>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                    <StageBadge stage={tx.stage}/>
                    <span style={{ fontSize:10, color:B.silver, fontFamily:"'DM Sans',sans-serif" }}>
                      {fmtTS(entry.at)}
                    </span>
                  </div>
                </div>
                {entry.comment && (
                  <div style={{ marginTop:10, padding:"8px 12px", background:"#FFF5F5",
                    borderLeft:"3px solid #DC2626", borderRadius:6, fontSize:12,
                    color:"#DC2626", fontFamily:"'DM Sans',sans-serif", fontStyle:"italic" }}>
                    "{entry.comment}"
                    <span style={{ display:"block", marginTop:4, fontSize:10,
                      color:B.silver, fontStyle:"normal" }}>— {entry.byName}</span>
                  </div>
                )}
                <div style={{ marginTop:8, fontSize:11, color:"#DC2626", fontWeight:700,
                  fontFamily:"'DM Sans',sans-serif" }}>
                  Click to open checklist and upload missing documents →
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Compliance Alerts ── */}
      {complianceIssues.length > 0 && (
        <div style={{ background:"#FFFBEB", border:"1px solid #FCD34D", borderRadius:12,
          padding:"16px 20px", marginBottom:24 }}>
          <div style={{ fontSize:13, fontWeight:700, color:B.gold, marginBottom:12,
            fontFamily:"'DM Sans',sans-serif" }}>
            📋 Missing Required Documents — {complianceIssues.length} Transaction{complianceIssues.length!==1?"s":""}
          </div>
          {complianceIssues.map(({ tx, missing }) => {
            const clientName = (tx.parties&&tx.parties.length>0) ? tx.parties.map(p=>p.name).filter(Boolean).join(" & ") : tx.clientName;
            return (
              <div key={tx.id} style={{ background:B.white, borderRadius:10, padding:"12px 16px",
                marginBottom:8, border:"1px solid #FCD34D", cursor:"pointer" }}
                onClick={() => onOpenChecklist(tx)}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
                  flexWrap:"wrap", gap:8 }}>
                  <div>
                    <div style={{ fontSize:13, fontWeight:700, color:B.black,
                      fontFamily:"'DM Sans',sans-serif" }}>{tx.address.split(",")[0]}</div>
                    <div style={{ fontSize:11, color:B.gray, marginTop:2,
                      fontFamily:"'DM Sans',sans-serif" }}>{clientName}</div>
                  </div>
                  <WfBadge wfState={tx.wfState}/>
                </div>
                <div style={{ marginTop:8, display:"flex", flexWrap:"wrap", gap:6 }}>
                  {missing.map(t => (
                    <span key={t.id} style={{ fontSize:11, padding:"2px 10px", borderRadius:20,
                      background:"#FEF3C7", color:"#92400E", border:"1px solid #FCD34D",
                      fontFamily:"'DM Sans',sans-serif", fontWeight:600 }}>
                      🔴 {t.title}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ── Upcoming Deadlines ── */}
      {deadlines.length > 0 && (
        <div style={{ background:B.white, borderRadius:12, border:"1px solid "+B.light,
          overflow:"hidden", marginBottom:24 }}>
          <div style={{ padding:"16px 24px", borderBottom:"1px solid "+B.light,
            display:"flex", alignItems:"center", justifyContent:"space-between" }}>
            <h3 style={{ margin:0, fontSize:13, fontWeight:700, color:B.black,
              fontFamily:"'DM Sans',sans-serif", letterSpacing:"0.06em", textTransform:"uppercase" }}>
              📅 Upcoming Deadlines (Next 30 Days)
            </h3>
            <span style={{ fontSize:11, color:B.silver, fontFamily:"'DM Sans',sans-serif" }}>
              {deadlines.length} deadline{deadlines.length!==1?"s":""}
            </span>
          </div>
          <div style={{ padding:"8px 16px" }}>
            {deadlines.map((d,i) => {
              const overdue  = d.due < 0;
              const urgent   = !overdue && d.due <= 3;
              const soon     = !overdue && !urgent && d.due <= 7;
              const dotColor = overdue ? "#DC2626" : urgent ? B.red : soon ? B.gold : B.green;
              return (
                <div key={i} style={{ display:"flex", alignItems:"center", gap:14,
                  padding:"10px 8px", borderBottom: i<deadlines.length-1 ? "1px solid "+B.light : "none",
                  cursor:"pointer" }}
                  onClick={() => onOpenChecklist(d.tx)}>
                  {/* Color dot */}
                  <div style={{ width:10, height:10, borderRadius:"50%",
                    background:dotColor, flexShrink:0 }}/>
                  {/* Day chip */}
                  <div style={{ width:56, textAlign:"center", padding:"4px 8px", borderRadius:8,
                    background:dotColor+"18", border:"1px solid "+dotColor+"44", flexShrink:0 }}>
                    <div style={{ fontSize:14, fontWeight:800, color:dotColor,
                      fontFamily:"'Playfair Display',serif", lineHeight:1 }}>
                      {overdue ? "−"+Math.abs(d.due) : d.due===0 ? "Today" : "+"+d.due}
                    </div>
                    <div style={{ fontSize:9, color:dotColor, fontWeight:700,
                      letterSpacing:"0.06em", fontFamily:"'DM Sans',sans-serif" }}>
                      {overdue ? "DAYS AGO" : d.due===0 ? "" : "DAYS"}
                    </div>
                  </div>
                  {/* Deadline info */}
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                      <span style={{ fontSize:12, fontWeight:700, color:dotColor,
                        fontFamily:"'DM Sans',sans-serif' " }}>{d.label} Deadline</span>
                      <span style={{ fontSize:11, color:B.silver,
                        fontFamily:"'DM Sans',sans-serif" }}>{fmtDate(d.date)}</span>
                    </div>
                    <div style={{ fontSize:11, color:B.gray, marginTop:2,
                      fontFamily:"'DM Sans',sans-serif", overflow:"hidden",
                      textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {d.addr} · {d.clientName}
                    </div>
                  </div>
                  <span style={{ fontSize:11, color:B.silver, flexShrink:0 }}>→</span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── Mini Pipeline ── */}
      <div style={{ background:B.white, borderRadius:12, border:"1px solid "+B.light,
        padding:"20px 24px", marginBottom:24 }}>
        <h3 style={{ margin:"0 0 16px", fontSize:13, fontWeight:700, color:B.black,
          fontFamily:"'DM Sans',sans-serif", letterSpacing:"0.06em", textTransform:"uppercase" }}>
          My Pipeline by Stage
        </h3>
        <div style={{ display:"flex", flexWrap:"wrap", gap:10 }}>
          {STAGES.filter(s => stageCounts[s] > 0).map(stage => (
            <div key={stage} style={{ display:"flex", alignItems:"center", gap:8,
              background:STAGE_COLORS[stage]+"15", border:"1px solid "+STAGE_COLORS[stage]+"33",
              borderRadius:8, padding:"8px 14px" }}>
              <span style={{ width:8, height:8, borderRadius:"50%",
                background:STAGE_COLORS[stage], flexShrink:0 }}/>
              <span style={{ fontSize:12, fontWeight:600, color:B.gray,
                fontFamily:"'DM Sans',sans-serif" }}>{stage}</span>
              <span style={{ fontSize:14, fontWeight:800, color:STAGE_COLORS[stage],
                fontFamily:"'Playfair Display',serif" }}>{stageCounts[stage]}</span>
            </div>
          ))}
          {Object.values(stageCounts).every(v=>v===0) && (
            <div style={{ fontSize:12, color:B.silver, fontStyle:"italic",
              fontFamily:"'DM Sans',sans-serif" }}>No active transactions yet.</div>
          )}
        </div>
      </div>

      {/* ── Closed Transaction Ledger — Last 12 Months ────────────────────── */}
      <div style={{ background:B.white, borderRadius:12, border:"1px solid "+B.light, overflow:"hidden", marginBottom:24 }}>
        <div style={{ padding:"16px 24px", borderBottom:"1px solid "+B.light, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:8 }}>
          <h3 style={{ margin:0, fontSize:13, fontWeight:700, color:B.black,
            fontFamily:"'DM Sans',sans-serif", letterSpacing:"0.06em", textTransform:"uppercase" }}>
            Closed Transactions · Last 12 Months
          </h3>
          <span style={{ fontSize:11, color:B.silver, fontFamily:"'DM Sans',sans-serif" }}>{ledgerTx.length} transaction{ledgerTx.length!==1?"s":""}</span>
        </div>
        {ledgerTx.length===0 ? (
          <div style={{ padding:"32px 20px", textAlign:"center", color:B.silver, fontSize:12, fontStyle:"italic", fontFamily:"'DM Sans',sans-serif" }}>
            No closed transactions in the last 12 months.
          </div>
        ) : (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>
              <thead>
                <tr style={{ background:B.offWhite }}>
                  {["Address","Side","Closed","Sale Price","Your Commission","Broker Commission"].map(h => (
                    <th key={h} style={{ padding:"10px 16px", textAlign:h==="Sale Price"||h.includes("Commission")?"right":"left", fontSize:10, fontWeight:700, color:B.silver, letterSpacing:"0.08em", textTransform:"uppercase", whiteSpace:"nowrap", borderBottom:"2px solid "+B.light }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ledgerTx.map((tx,i) => (
                  <tr key={tx.id} style={{ borderTop:"1px solid "+B.light, background:i%2===0?B.white:"#FAFAFA" }}>
                    <td style={{ padding:"11px 16px", fontWeight:600, color:B.black, maxWidth:220 }}>
                      <div style={{ fontSize:12 }}>{tx.address.split(",")[0]}</div>
                      <div style={{ fontSize:10, color:B.silver }}>{tx.address.split(",").slice(1).join(",").trim()}</div>
                    </td>
                    <td style={{ padding:"11px 16px" }}><SideBadge side={tx.side}/></td>
                    <td style={{ padding:"11px 16px", fontSize:12, color:B.gray, whiteSpace:"nowrap" }}>{fmtDate(tx.closingDate)}</td>
                    <td style={{ padding:"11px 16px", fontWeight:700, color:B.black, textAlign:"right", whiteSpace:"nowrap" }}>{fmt(tx.price)}</td>
                    <td style={{ padding:"11px 16px", fontWeight:700, color:B.green, textAlign:"right", whiteSpace:"nowrap" }}>{fmt(tx.agentCommission)}</td>
                    <td style={{ padding:"11px 16px", fontWeight:700, color:B.red, textAlign:"right", whiteSpace:"nowrap" }}>{fmt(tx.brokerCommission)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ borderTop:"2px solid "+B.light, background:B.offWhite }}>
                  <td colSpan={3} style={{ padding:"11px 16px", fontWeight:700, color:B.black, fontSize:12 }}>Total</td>
                  <td style={{ padding:"11px 16px", fontWeight:800, color:B.black, textAlign:"right", whiteSpace:"nowrap" }}>{fmt(ledgerTx.reduce((s,t)=>s+t.price,0))}</td>
                  <td style={{ padding:"11px 16px", fontWeight:800, color:B.green, textAlign:"right", whiteSpace:"nowrap" }}>{fmt(ledgerTx.reduce((s,t)=>s+t.agentCommission,0))}</td>
                  <td style={{ padding:"11px 16px", fontWeight:800, color:B.red, textAlign:"right", whiteSpace:"nowrap" }}>{fmt(ledgerTx.reduce((s,t)=>s+t.brokerCommission,0))}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>

      {/* ── Recent Activity ── */}
      {myTx.length > 0 && (
        <div style={{ background:B.white, borderRadius:12, border:"1px solid "+B.light, overflow:"hidden" }}>
          <div style={{ padding:"16px 24px", borderBottom:"1px solid "+B.light }}>
            <h3 style={{ margin:0, fontSize:13, fontWeight:700, color:B.black,
              fontFamily:"'DM Sans',sans-serif", letterSpacing:"0.06em", textTransform:"uppercase" }}>
              My Transactions
            </h3>
          </div>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12,
            fontFamily:"'DM Sans',sans-serif" }}>
            <thead>
              <tr style={{ background:B.offWhite }}>
                {["Property","Client","Side","Price","Stage","Status","Checklist"].map(h => (
                  <th key={h} style={{ padding:"10px 16px", textAlign:"left", fontSize:10,
                    fontWeight:700, color:B.silver, letterSpacing:"0.1em", textTransform:"uppercase" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...myTx].sort((a,b)=>(b.closingDate||"").localeCompare(a.closingDate||"")).map((tx,i) => {
                const clientName = (tx.parties&&tx.parties.length>0) ? tx.parties.map(p=>p.name).filter(Boolean).join(" & ") : tx.clientName;
                const mandatory  = (tx.tasks||[]).filter(t=>t.mandatory);
                const done       = mandatory.filter(t=>t.documents.length>0).length;
                const allDone    = done === mandatory.length;
                return (
                  <tr key={tx.id} style={{ borderTop:"1px solid "+B.light,
                    background:i%2===0?B.white:"#FAFAFA", cursor:"pointer" }}
                    onClick={() => onOpenChecklist(tx)}>
                    <td style={{ padding:"11px 16px", fontWeight:600, color:B.black, maxWidth:160 }}>
                      <div style={{ overflow:"hidden", textOverflow:"ellipsis",
                        whiteSpace:"nowrap" }}>{tx.address.split(",")[0]}</div>
                      <div style={{ fontSize:10, color:B.silver,
                        fontWeight:400 }}>{fmtDate(tx.closingDate)}</div>
                    </td>
                    <td style={{ padding:"11px 16px", color:B.gray, maxWidth:140 }}>
                      <div style={{ overflow:"hidden", textOverflow:"ellipsis",
                        whiteSpace:"nowrap" }}>{clientName}</div>
                    </td>
                    <td style={{ padding:"11px 16px" }}><SideBadge side={tx.side}/></td>
                    <td style={{ padding:"11px 16px", fontWeight:700,
                      color:B.black }}>{fmt(tx.price)}</td>
                    <td style={{ padding:"11px 16px" }}><StageBadge stage={tx.stage}/></td>
                    <td style={{ padding:"11px 16px" }}><WfBadge wfState={tx.wfState}/></td>
                    <td style={{ padding:"11px 16px" }}>
                      <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                        <div style={{ flex:1, height:4, background:B.light,
                          borderRadius:2, minWidth:40 }}>
                          <div style={{ height:"100%", borderRadius:2,
                            background:allDone?B.green:B.red,
                            width:mandatory.length?Math.round(done/mandatory.length*100)+"%":"0%" }}/>
                        </div>
                        <span style={{ fontSize:10, color:allDone?B.green:B.red,
                          fontWeight:700, whiteSpace:"nowrap" }}>{done}/{mandatory.length}</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── Dashboard ────────────────────────────────────────────────────────────────
function Dashboard({ currentUser, transactions, users, onReview, onCloseTx }) {
  const isPrincipal = currentUser.role==="principal_broker";
  const isAssocBroker = currentUser.role==="associate_broker";

  // Toggle between the broker's own transactions and everything they're allowed to see
  // (whole brokerage for principal, own team for associate broker).
  const [viewScope, setViewScope] = useState("mine"); // "all" | "mine"

  // Each broker sees their team's transactions + their own
  const teamVisibleTx = transactions.filter(tx => canUserSeeTransaction(currentUser,tx,users));
  const myTx = viewScope==="mine" ? teamVisibleTx.filter(tx=>tx.agentId===currentUser.id) : teamVisibleTx;
  const closedTx  = myTx.filter(t=>t.wfState==="closed");
  const activeTx  = myTx.filter(t=>!["closed","fallen_through"].includes(t.wfState));
  const pendingReview = myTx.filter(t=>t.wfState==="submitted" && canReviewSubmission(currentUser,t,users));
  const approvedTx = myTx.filter(t=>t.wfState==="approved" && canReviewTransaction(currentUser,t,users))
    .sort((a,b)=>new Date(a.closingDate)-new Date(b.closingDate));
  const totalGCI  = closedTx.reduce((s,t)=>s+calcNetGCI(t.price,t.commissionPct,t.referralFee),0);
  const pendingGCI = activeTx.reduce((s,t)=>s+calcNetGCI(t.price,t.commissionPct,t.referralFee),0);

  // My team members
  const myTeam = isPrincipal
    ? users.filter(u=>u.id!==currentUser.id)
    : users.filter(u=>u.brokerId===currentUser.id);

  const flagged = myTx.filter(tx=>{
    if(["closed","fallen_through"].includes(tx.wfState)) return false;
    const missing=(tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0);
    if(missing.length===0) return false;
    const closingSoon=tx.closingDate&&daysUntil(tx.closingDate)<=14;
    const hasOverdue=(tx.tasks||[]).some(t=>{const d=daysUntil(t.dueDate);return d!==null&&d<0&&t.documents.length===0;});
    // Approved transactions are blocked from closing by missing docs regardless of date — always flag them.
    return closingSoon||hasOverdue||tx.wfState==="approved";
  }).sort((a,b)=>new Date(a.closingDate)-new Date(b.closingDate));

  const stageCounts=useMemo(()=>{const m={};STAGES.forEach(s=>{m[s]=0;});myTx.forEach(t=>{if(m[t.stage]!==undefined)m[t.stage]++;});return m;},[myTx]);

  // ── Financial performance: monthly GCI/volume trend (last 12 months) ──────
  const monthlyData = useMemo(() => {
    const now = new Date();
    const months = [];
    for (let i=11; i>=0; i--) {
      const d = new Date(now.getFullYear(), now.getMonth()-i, 1);
      months.push({ key: d.toISOString().slice(0,7), label: d.toLocaleDateString("en-US",{month:"short",year:"2-digit"}), volume:0, gci:0, deals:0 });
    }
    const byKey = Object.fromEntries(months.map(m=>[m.key,m]));
    closedTx.forEach(tx => {
      if (!tx.closingDate) return;
      const key = tx.closingDate.slice(0,7);
      if (byKey[key]) {
        byKey[key].volume += tx.price;
        byKey[key].gci += calcNetGCI(tx.price, tx.commissionPct, tx.referralFee);
        byKey[key].deals += 1;
      }
    });
    return months;
  }, [closedTx]);

  const avgSalePrice = closedTx.length ? closedTx.reduce((s,t)=>s+t.price,0)/closedTx.length : 0;
  const thisYear = new Date().getFullYear();
  const ytdClosed = closedTx.filter(t=>t.closingDate && new Date(t.closingDate+"T00:00:00").getFullYear()===thisYear);
  const ytdGCI = ytdClosed.reduce((s,t)=>s+calcNetGCI(t.price,t.commissionPct,t.referralFee),0);
  const fallenThroughTx = myTx.filter(t=>t.wfState==="fallen_through");
  const fallThroughRate = (closedTx.length+fallenThroughTx.length)>0
    ? Math.round(fallenThroughTx.length/(closedTx.length+fallenThroughTx.length)*100) : 0;

  // ── 12-month closed transaction ledger — address, side, price, agent/broker commission ──
  const ledgerTx = useMemo(() => {
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    return closedTx
      .filter(tx => tx.closingDate && new Date(tx.closingDate+"T00:00:00") >= oneYearAgo)
      .map(tx => {
        const agent = users.find(u=>u.id===tx.agentId);
        // Use the transaction's OWN stored fee terms (snapshotted at creation/edit time),
        // not the agent's current profile — a later profile change shouldn't alter
        // the recorded commission split on a historical deal.
        const fees = {
          agentSplit:     tx.agentSplit,
          transactionFee: tx.transactionFee,
          eoFee:          tx.eoFee,
          customFees:     tx.customFees || [],
        };
        const calc = calcAgentNetFull(tx.price, tx.commissionPct, tx.referralFee, fees);
        return { ...tx, agent, agentCommission: calc.agentNet, brokerCommission: calc.brokerageKeeps };
      })
      .sort((a,b) => new Date(b.closingDate) - new Date(a.closingDate));
  }, [closedTx, users]);

  return(
    <div>
      {/* Scope label */}
      <div style={{background:isAssocBroker?B.teal+"11":B.red+"11",border:"1px solid "+(isAssocBroker?B.teal:B.red)+"33",borderRadius:10,padding:"10px 16px",marginBottom:20,display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <Avatar name={currentUser.name} role={currentUser.role} size={32} photo={currentUser.photo||null}/>
          <div style={{fontSize:12,fontFamily:"'DM Sans',sans-serif",color:B.black}}>
            <strong>{currentUser.name}</strong> — {ROLES[currentUser.role].label}
            {viewScope==="mine" && <span style={{color:B.silver,marginLeft:8}}>· Viewing your {myTx.length} own transaction{myTx.length!==1?"s":""}</span>}
            {viewScope==="all" && isPrincipal && <span style={{color:B.silver,marginLeft:8}}>· Viewing all {myTx.length} brokerage transactions</span>}
            {viewScope==="all" && isAssocBroker && <span style={{color:B.silver,marginLeft:8}}>· Viewing your team's {myTx.length} transactions</span>}
          </div>
        </div>
        <div style={{display:"flex",background:B.white,border:"1px solid "+B.light,borderRadius:8,padding:2,gap:2}}>
          <button onClick={()=>setViewScope("mine")} style={{padding:"6px 14px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",background:viewScope==="mine"?B.black:"transparent",color:viewScope==="mine"?B.white:B.gray}}>
            My Transactions
          </button>
          <button onClick={()=>setViewScope("all")} style={{padding:"6px 14px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",background:viewScope==="all"?B.black:"transparent",color:viewScope==="all"?B.white:B.gray}}>
            {isPrincipal?"Brokerage":"Team"}
          </button>
        </div>
      </div>

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:16,marginBottom:24}}>
        <StatCard label="Closed Volume" value={fmt(closedTx.reduce((s,t)=>s+t.price,0))} sub={closedTx.length+" transactions"} accent={B.red}/>
        <StatCard label="GCI (Closed)" value={fmt(totalGCI)} accent={B.green}/>
        <StatCard label="Active Pipeline" value={fmt(activeTx.reduce((s,t)=>s+t.price,0))} sub={activeTx.length+" active"} accent={B.blue}/>
        <StatCard label="Pending GCI" value={fmt(pendingGCI)} sub="Projected from active pipeline" accent={B.teal}/>
        <StatCard label="Pending Review" value={pendingReview.length} sub="Awaiting your review" accent={B.gold}/>
      </div>

      {/* Ready to close + Compliance alerts — side by side */}
      {(approvedTx.length>0||flagged.length>0)&&(
        <div style={{display:"grid",gridTemplateColumns:approvedTx.length>0&&flagged.length>0?"repeat(auto-fit,minmax(340px,1fr))":"1fr",gap:20,marginBottom:20,alignItems:"start"}}>
          {/* Ready to close */}
          {approvedTx.length>0&&(
            <div style={{background:"#ECFEFF",border:"1px solid #67E8F9",borderRadius:12,padding:"16px 20px"}}>
              <div style={{fontSize:13,fontWeight:700,color:B.teal,marginBottom:12,fontFamily:"'DM Sans',sans-serif"}}>✓ Ready to Close ({approvedTx.length})</div>
              {approvedTx.map(tx=>{
                const agent=users.find(u=>u.id===tx.agentId);
                return(
                  <div key={tx.id} style={{background:B.white,borderRadius:8,padding:"12px 16px",marginBottom:8,border:"1px solid #67E8F9",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{tx.address.split(",")[0]} — <span style={{color:B.teal}}>{fmtDate(tx.closingDate)}</span></div>
                      <div style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif",marginTop:2}}>{(tx.parties&&tx.parties.length>0)?tx.parties.map(p=>p.name).filter(Boolean).join(" & "):tx.clientName} · {fmt(tx.price)}</div>
                    </div>
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      {agent&&<RoleBadge role={agent.role}/>}
{(()=>{
                        const missingCount=(tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0).length;
                        return missingCount>0
                          ? <div style={{display:"flex",alignItems:"center",gap:6,padding:"6px 12px",borderRadius:8,border:"1px solid #DC262444",background:"#FFF5F5"}}>
                              <span style={{fontSize:11}}>🔒</span>
                              <span style={{fontSize:11,color:"#DC2626",fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>{missingCount} doc{missingCount!==1?"s":""} missing</span>
                            </div>
                          : <button onClick={()=>onCloseTx(tx)} style={{padding:"7px 16px",borderRadius:8,border:"none",background:B.green,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>🏁 Close</button>;
                      })()}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Compliance flags */}
          {flagged.length>0&&(
            <div style={{background:"#FFF5F5",border:"1px solid #FCA5A5",borderRadius:12,padding:"16px 20px"}}>
              <div style={{fontSize:13,fontWeight:700,color:"#DC2626",marginBottom:12,fontFamily:"'DM Sans',sans-serif"}}>⚠ Compliance Alerts ({flagged.length})</div>
              {flagged.map(tx=>{
                const missing=(tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0);
                const due=daysUntil(tx.closingDate);
                return(
                  <div key={tx.id} style={{background:B.white,borderRadius:8,padding:"10px 14px",marginBottom:8,border:"1px solid #FEE2E2",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
                    <div>
                      <div style={{fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{tx.address.split(",")[0]}</div>
                      <div style={{fontSize:11,color:"#DC2626",fontFamily:"'DM Sans',sans-serif",marginTop:2}}>Missing: {missing.map(t=>t.title).join(" · ")}{due!==null&&<span style={{marginLeft:8}}>{due<0?"· "+Math.abs(due)+"d past closing":"· Closing in "+due+"d"}</span>}</div>
                    </div>
                    <StageBadge stage={tx.stage}/>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* Stage breakdown */}
      <div style={{background:B.white,borderRadius:12,border:"1px solid "+B.light,padding:"20px 24px",marginBottom:20}}>
        <h3 style={{margin:"0 0 16px",fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif",letterSpacing:"0.06em",textTransform:"uppercase"}}>Pipeline by Stage</h3>
        <div style={{display:"flex",flexWrap:"wrap",gap:10}}>
          {STAGES.map(stage=>(
            <div key={stage} style={{display:"flex",alignItems:"center",gap:8,background:STAGE_COLORS[stage]+"15",border:"1px solid "+STAGE_COLORS[stage]+"33",borderRadius:8,padding:"8px 14px"}}>
              <span style={{width:8,height:8,borderRadius:"50%",background:STAGE_COLORS[stage],flexShrink:0}}/>
              <span style={{fontSize:12,fontWeight:600,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{stage}</span>
              <span style={{fontSize:14,fontWeight:800,color:STAGE_COLORS[stage],fontFamily:"'Playfair Display',serif"}}>{stageCounts[stage]}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── Transaction Ledger — Last 12 Months ───────────────────────────── */}
      <div style={{background:B.white,borderRadius:12,border:"1px solid "+B.light,overflow:"hidden",marginBottom:20}}>
        <div style={{padding:"16px 24px",borderBottom:"1px solid "+B.light,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:8}}>
          <h3 style={{margin:0,fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif",letterSpacing:"0.06em",textTransform:"uppercase"}}>Closed Transactions · Last 12 Months</h3>
          <span style={{fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{ledgerTx.length} transaction{ledgerTx.length!==1?"s":""}</span>
        </div>
        {ledgerTx.length===0 ? (
          <div style={{padding:"32px 20px",textAlign:"center",color:B.silver,fontSize:12,fontStyle:"italic",fontFamily:"'DM Sans',sans-serif"}}>
            No closed transactions in the last 12 months.
          </div>
        ) : (
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,fontFamily:"'DM Sans',sans-serif"}}>
              <thead>
                <tr style={{background:B.offWhite}}>
                  {["Address","Agent","Side","Closed","Sale Price","Agent Commission","Broker Commission"].map(h=>(
                    <th key={h} style={{padding:"10px 16px",textAlign:h==="Sale Price"||h.includes("Commission")?"right":"left",fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",whiteSpace:"nowrap",borderBottom:"2px solid "+B.light}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ledgerTx.map((tx,i) => (
                  <tr key={tx.id} style={{borderTop:"1px solid "+B.light,background:i%2===0?B.white:"#FAFAFA"}}>
                    <td style={{padding:"11px 16px",fontWeight:600,color:B.black,maxWidth:220}}>
                      <div style={{fontSize:12}}>{tx.address.split(",")[0]}</div>
                      <div style={{fontSize:10,color:B.silver}}>{tx.address.split(",").slice(1).join(",").trim()}</div>
                    </td>
                    <td style={{padding:"11px 16px",fontSize:12}}>
                      {tx.agent && <div style={{display:"flex",alignItems:"center",gap:8}}><Avatar name={tx.agent.name} role={tx.agent.role} size={22} photo={tx.agent.photo||null}/><span style={{color:B.gray}}>{tx.agent.name}</span></div>}
                    </td>
                    <td style={{padding:"11px 16px"}}><SideBadge side={tx.side}/></td>
                    <td style={{padding:"11px 16px",fontSize:12,color:B.gray,whiteSpace:"nowrap"}}>{fmtDate(tx.closingDate)}</td>
                    <td style={{padding:"11px 16px",fontWeight:700,color:B.black,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(tx.price)}</td>
                    <td style={{padding:"11px 16px",fontWeight:700,color:B.green,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(tx.agentCommission)}</td>
                    <td style={{padding:"11px 16px",fontWeight:700,color:B.red,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(tx.brokerCommission)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{borderTop:"2px solid "+B.light,background:B.offWhite}}>
                  <td colSpan={4} style={{padding:"11px 16px",fontWeight:700,color:B.black,fontSize:12}}>Total</td>
                  <td style={{padding:"11px 16px",fontWeight:800,color:B.black,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(ledgerTx.reduce((s,t)=>s+t.price,0))}</td>
                  <td style={{padding:"11px 16px",fontWeight:800,color:B.green,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(ledgerTx.reduce((s,t)=>s+t.agentCommission,0))}</td>
                  <td style={{padding:"11px 16px",fontWeight:800,color:B.red,textAlign:"right",whiteSpace:"nowrap"}}>{fmt(ledgerTx.reduce((s,t)=>s+t.brokerCommission,0))}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>

      {/* ── Financial Performance ─────────────────────────────────────────── */}
      <div style={{background:B.white,borderRadius:12,border:"1px solid "+B.light,padding:"20px 24px",marginBottom:20}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:12}}>
          <h3 style={{margin:0,fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif",letterSpacing:"0.06em",textTransform:"uppercase"}}>Financial Performance · Last 12 Months</h3>
          <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
            <div>
              <div style={{fontSize:9,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif"}}>YTD GCI ({thisYear})</div>
              <div style={{fontSize:16,fontWeight:800,color:B.green,fontFamily:"'Playfair Display',serif"}}>{fmt(ytdGCI)}</div>
            </div>
            <div>
              <div style={{fontSize:9,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif"}}>Avg Sale Price</div>
              <div style={{fontSize:16,fontWeight:800,color:B.black,fontFamily:"'Playfair Display',serif"}}>{closedTx.length?fmt(avgSalePrice):"—"}</div>
            </div>
            <div>
              <div style={{fontSize:9,fontWeight:700,color:B.silver,letterSpacing:"0.08em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif"}}>Fall-Through Rate</div>
              <div style={{fontSize:16,fontWeight:800,color:fallThroughRate>15?"#DC2626":B.black,fontFamily:"'Playfair Display',serif"}}>{fallThroughRate}%</div>
            </div>
          </div>
        </div>
        {closedTx.length===0 ? (
          <div style={{padding:"32px 20px",textAlign:"center",color:B.silver,fontSize:12,fontStyle:"italic",fontFamily:"'DM Sans',sans-serif"}}>
            No closed transactions yet — chart will populate as deals close.
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={monthlyData} margin={{top:5,right:5,left:5,bottom:5}}>
              <CartesianGrid strokeDasharray="3 3" stroke={B.light}/>
              <XAxis dataKey="label" tick={{fontSize:11,fontFamily:"DM Sans",fill:B.silver}} axisLine={{stroke:B.light}} tickLine={false}/>
              <YAxis tick={{fontSize:10,fontFamily:"DM Sans",fill:B.silver}} axisLine={false} tickLine={false}
                tickFormatter={v=>v>=1000?`$${(v/1000).toFixed(0)}k`:`$${v}`}/>
              <Tooltip
                formatter={(value,name)=>[fmt(value), name==="gci"?"GCI":"Volume"]}
                labelStyle={{fontFamily:"DM Sans",fontWeight:700,color:B.black}}
                contentStyle={{fontFamily:"DM Sans",fontSize:12,borderRadius:8,border:"1px solid "+B.light}}/>
              <Bar dataKey="volume" fill={B.blue+"55"} radius={[4,4,0,0]} name="volume"/>
              <Bar dataKey="gci" fill={B.green} radius={[4,4,0,0]} name="gci"/>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>

      {/* Review queue */}
      {pendingReview.length>0&&(
        <div style={{background:"#FFFBEB",border:"1px solid #FCD34D",borderRadius:12,padding:"16px 20px",marginBottom:20}}>
          <div style={{fontSize:13,fontWeight:700,color:B.gold,marginBottom:12,fontFamily:"'DM Sans',sans-serif"}}>⏳ Review Queue ({pendingReview.length})</div>
          {pendingReview.map(tx=>{
            const agent=users.find(u=>u.id===tx.agentId);
            const due=daysUntil(tx.closingDate);
            return(
              <div key={tx.id} style={{background:B.white,borderRadius:8,padding:"12px 16px",marginBottom:8,border:"1px solid #FCD34D",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{tx.address.split(",")[0]}</div>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginTop:4,flexWrap:"wrap"}}>
                    {agent&&<><Avatar name={agent.name} role={agent.role} size={20} photo={agent.photo||null}/><span style={{fontSize:11,color:B.gray,fontFamily:"'DM Sans',sans-serif"}}>{agent.name}</span><RoleBadge role={agent.role}/></>}
                    {due!==null&&<span style={{fontSize:11,color:due<=7?"#DC2626":B.gold,fontWeight:600,fontFamily:"'DM Sans',sans-serif"}}>{due<0?"⚠ Closing "+Math.abs(due)+"d ago":"Closing in "+due+"d"}</span>}
                  </div>
                </div>
                <button onClick={()=>onReview(tx)} style={{padding:"7px 16px",borderRadius:8,border:"none",background:B.teal,color:B.white,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>🔍 Review</button>
              </div>
            );
          })}
        </div>
      )}

      {/* Team performance */}
      {myTeam.length>0&&(
        <div style={{background:B.white,borderRadius:12,border:"1px solid "+B.light,overflow:"hidden"}}>
          <div style={{padding:"16px 24px",borderBottom:"1px solid "+B.light}}>
            <h3 style={{margin:0,fontSize:13,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif",letterSpacing:"0.06em",textTransform:"uppercase"}}>{isPrincipal?"Brokerage Team Performance":"My Team Performance"}</h3>
          </div>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,fontFamily:"'DM Sans',sans-serif"}}>
            <thead><tr style={{background:B.offWhite}}>{["Member","Role","Active","Closed","GCI"].map(h=><th key={h} style={{padding:"10px 18px",textAlign:"left",fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase"}}>{h}</th>)}</tr></thead>
            <tbody>
              {myTeam.map((u,i)=>{
                const utx=transactions.filter(t=>t.agentId===u.id);
                const uClosed=utx.filter(t=>t.wfState==="closed");
                const uActive=utx.filter(t=>!["closed","fallen_through"].includes(t.wfState));
                const uGCI=uClosed.reduce((s,t)=>s+calcNetGCI(t.price,t.commissionPct,t.referralFee),0);
                return(
                  <tr key={u.id} style={{borderTop:"1px solid "+B.light,background:i%2===0?B.white:"#FAFAFA"}}>
                    <td style={{padding:"13px 18px"}}>
                      <div style={{display:"flex",alignItems:"center",gap:10}}><Avatar name={u.name} role={u.role} size={30} photo={u.photo||null}/><span style={{fontWeight:600,color:B.black}}>{u.name}</span></div>
                    </td>
                    <td style={{padding:"13px 18px"}}><RoleBadge role={u.role}/></td>
                    <td style={{padding:"13px 18px"}}><span style={{background:B.blue+"22",color:B.blue,padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:700}}>{uActive.length}</span></td>
                    <td style={{padding:"13px 18px"}}><span style={{background:B.green+"22",color:B.green,padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:700}}>{uClosed.length}</span></td>
                    <td style={{padding:"13px 18px",fontWeight:700,color:B.red,fontFamily:"'Playfair Display',serif",fontSize:15}}>{fmt(uGCI)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── Transaction Table ────────────────────────────────────────────────────────
function TransactionTable({ transactions, currentUser, users, onEdit, onDelete, onOpenChecklist, onSubmit, onReview, onCloseTx, onReopen, onSelfApprove, onVoid, onArchive }) {
  const PAGE_SIZE = 25;
  const [sort,setSort]=useState({key:"closingDate",dir:-1}); // -1 = most recent first
  const [page,setPage]=useState(1);
  const sorted=useMemo(()=>[...transactions].sort((a,b)=>{const av=a[sort.key]||"",bv=b[sort.key]||"";return av<bv?-sort.dir:av>bv?sort.dir:0}),[transactions,sort]);
  const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
  const pageClamped = Math.min(page, totalPages);
  const paged = sorted.slice((pageClamped-1)*PAGE_SIZE, pageClamped*PAGE_SIZE);
  // Reset to page 1 whenever the underlying transaction list or sort changes
  useEffect(() => { setPage(1); }, [transactions.length, sort.key, sort.dir]); // eslint-disable-line
  const isPrincipal=currentUser.role==="principal_broker";
  const isBroker=currentUser.role!=="realtor";
  const th=(label,key)=>(
    <th onClick={()=>setSort(s=>({key,dir:s.key===key?-s.dir:1}))} style={{padding:"10px 12px",textAlign:"left",fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase",cursor:"pointer",fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap",background:B.offWhite,borderBottom:"2px solid "+B.light}}>
      {label}{sort.key===key?(sort.dir===1?" ↑":" ↓"):""}
    </th>
  );
  return(
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,fontFamily:"'DM Sans',sans-serif"}}>
        <thead><tr>{th("Address","address")}{th("Client","clientName")}{th("Agent","agentId")}{th("Side","side")}{th("Price","price")}{th("Stage · Dates","stage")}<th style={{padding:"10px 12px",background:B.offWhite,borderBottom:"2px solid "+B.light,fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase"}}>Status</th><th style={{padding:"10px 12px",background:B.offWhite,borderBottom:"2px solid "+B.light,fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase"}}>Checklist</th><th style={{padding:"10px 12px",background:B.offWhite,borderBottom:"2px solid "+B.light,fontSize:10,fontWeight:700,color:B.silver,letterSpacing:"0.1em",textTransform:"uppercase"}}>Action</th><th style={{padding:"10px 12px",background:B.offWhite,borderBottom:"2px solid "+B.light}}></th></tr></thead>
        <tbody>
          {paged.map((tx,i)=>{
            const agent=users.find(u=>u.id===tx.agentId);
            const mandatory=(tx.tasks||[]).filter(t=>t.mandatory);
            const done=mandatory.filter(t=>t.documents.length>0).length;
            const allDone=done===mandatory.length;
            const isLocked=["submitted","approved","closed","fallen_through"].includes(tx.wfState);
            return(
              <tr key={tx.id} style={{background:i%2===0?B.white:"#FAFAFA",borderBottom:"1px solid "+B.light}}>
                <td style={{padding:"11px 12px",fontWeight:600,color:B.black,maxWidth:170}}>
                  <div style={{fontSize:12}}>{tx.address.split(",")[0]}</div>
                  <div style={{fontSize:10,color:B.silver}}>{tx.address.split(",").slice(1).join(",").trim()}</div>
                </td>
                <td style={{padding:"11px 12px",color:B.gray,fontSize:12}}>
                  <div>{(tx.parties&&tx.parties.length>0)?tx.parties.map(p=>p.name).filter(Boolean).join(" & "):tx.clientName}</div>
                  {tx.contacts&&tx.contacts.length>0&&<div style={{fontSize:10,color:B.silver,marginTop:2}}>{tx.contacts.map(c=>c.name).filter(Boolean).join(" · ")}</div>}
                </td>
                <td style={{padding:"11px 12px",fontSize:12}}>
                  {agent&&<div style={{display:"flex",alignItems:"center",gap:8}}><Avatar name={agent.name} role={agent.role} size={24} photo={agent.photo||null}/><div><div style={{fontWeight:600,color:B.black}}>{agent.name}</div><div style={{marginTop:1}}><RoleBadge role={agent.role}/></div></div></div>}
                </td>
                <td style={{padding:"11px 12px"}}><SideBadge side={tx.side}/></td>
                <td style={{padding:"11px 12px",fontWeight:700,color:B.black,whiteSpace:"nowrap"}}>{fmt(tx.price)}</td>
                <td style={{padding:"11px 12px"}}>
                  <StageBadge stage={tx.stage}/>
                  <div style={{fontSize:10,color:B.silver,marginTop:5,fontFamily:"'DM Sans',sans-serif",lineHeight:1.6,whiteSpace:"nowrap"}}>
                    <div>📝 {fmtDate(tx.contractDate)}</div>
                    <div>🏁 {fmtDate(tx.closingDate)}</div>
                  </div>
                </td>
                <td style={{padding:"11px 12px"}}><WfBadge wfState={tx.wfState}/></td>
                <td style={{padding:"11px 12px"}}>
                  <button onClick={()=>onOpenChecklist(tx)} style={{display:"flex",alignItems:"center",gap:5,padding:"5px 10px",borderRadius:8,border:"1px solid "+(allDone?"#16A34A44":B.light),background:allDone?"#F0FDF4":B.white,cursor:"pointer",fontSize:11,fontFamily:"'DM Sans',sans-serif",fontWeight:700,color:allDone?B.green:B.gray,whiteSpace:"nowrap"}}>
                    {allDone?"✓":"📋"} {done}/{mandatory.length}
                  </button>
                </td>
                <td style={{padding:"11px 12px",minWidth:160}}>
                  <WorkflowActionBar tx={tx} currentUser={currentUser} users={users} onSubmit={onSubmit} onReview={onReview} onCloseTx={onCloseTx} onReopen={onReopen} onSelfApprove={onSelfApprove}/>
                </td>
                <td style={{padding:"11px 12px"}}>
                  <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                    {(!isLocked||isBroker)&&<button onClick={()=>onEdit(tx)} style={{padding:"4px 10px",borderRadius:6,border:"1px solid "+B.light,background:B.white,cursor:"pointer",fontSize:11,color:B.gray}}>Edit</button>}
                    {isBroker&&tx.wfState==="closed"&&<button onClick={()=>onReopen(tx)} style={{padding:"4px 10px",borderRadius:6,border:"1px solid #D9770644",background:"#FFFBEB",cursor:"pointer",fontSize:11,color:"#D97706",fontWeight:700}}>↩ Reopen</button>}
                    {/* Agent can void their own draft or changes_requested transactions */}
                    {!isBroker&&tx.agentId===currentUser.id&&(tx.wfState==="draft"||tx.wfState==="changes_requested")&&onVoid&&(
                      <button onClick={()=>onVoid(tx)}
                        style={{padding:"4px 10px",borderRadius:6,border:"1px solid #DDD6FE",background:"#F5F3FF",cursor:"pointer",fontSize:11,color:"#7C3AED",fontWeight:700}}>
                        ✕ Void
                      </button>
                    )}
                    {isPrincipal&&<button onClick={()=>onArchive(tx)}
                      style={{padding:"4px 10px",borderRadius:6,border:"1px solid #FCD34D",
                        background:"#FFFBEB",cursor:"pointer",fontSize:11,
                        color:"#92400E",fontWeight:700}}>
                      📦 Archive
                    </button>}
                  </div>
                </td>
              </tr>
            );
          })}
          {sorted.length===0&&<tr><td colSpan={10} style={{padding:32,textAlign:"center",color:B.silver,fontStyle:"italic"}}>No transactions found.</td></tr>}
        </tbody>
      </table>
      {sorted.length > PAGE_SIZE && (
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",
          padding:"14px 12px",flexWrap:"wrap",gap:10}}>
          <div style={{fontSize:12,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>
            Showing {(pageClamped-1)*PAGE_SIZE+1}–{Math.min(pageClamped*PAGE_SIZE,sorted.length)} of {sorted.length}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <button onClick={()=>setPage(p=>Math.max(1,p-1))} disabled={pageClamped===1}
              style={{padding:"6px 12px",borderRadius:8,border:"1px solid "+B.light,
                background:pageClamped===1?B.offWhite:B.white,
                color:pageClamped===1?B.silver:B.gray,
                cursor:pageClamped===1?"not-allowed":"pointer",
                fontSize:12,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
              ← Prev
            </button>
            <span style={{fontSize:12,color:B.gray,fontFamily:"'DM Sans',sans-serif",padding:"0 8px"}}>
              Page {pageClamped} of {totalPages}
            </span>
            <button onClick={()=>setPage(p=>Math.min(totalPages,p+1))} disabled={pageClamped===totalPages}
              style={{padding:"6px 12px",borderRadius:8,border:"1px solid "+B.light,
                background:pageClamped===totalPages?B.offWhite:B.white,
                color:pageClamped===totalPages?B.silver:B.gray,
                cursor:pageClamped===totalPages?"not-allowed":"pointer",
                fontSize:12,fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
              Next →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Pipeline ────────────────────────────────────────────────────────────────
function PipelineView({ transactions, currentUser, users, onOpenChecklist, onSubmit, onReview, onCloseTx, onReopen, onSelfApprove, onStageChange }) {
  const isPrincipal = currentUser.role==="principal_broker";
  const isAssocBroker = currentUser.role==="associate_broker";
  const canToggleScope = isPrincipal || isAssocBroker;

  // Toggle between the broker's own transactions and everything they're scoped to see
  // (whole brokerage for principal, own team for associate broker) — same as Dashboard.
  const [viewScope, setViewScope] = useState("mine"); // "all" | "mine"
  const scopedTx = canToggleScope && viewScope==="mine"
    ? transactions.filter(tx=>tx.agentId===currentUser.id)
    : transactions;

  const byStage=useMemo(()=>{const m={};STAGES.forEach(s=>{m[s]=[];});scopedTx.forEach(tx=>{if(m[tx.stage])m[tx.stage].push(tx);});return m;},[scopedTx]);
  const [dragTxId, setDragTxId] = useState(null);
  const [dragOverStage, setDragOverStage] = useState(null);

  function handleDragStart(e, tx) {
    setDragTxId(tx.id);
    e.dataTransfer.effectAllowed = "move";
  }
  function handleDragOver(e, stage) {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (dragOverStage !== stage) setDragOverStage(stage);
  }
  function handleDragLeave(stage) {
    if (dragOverStage === stage) setDragOverStage(null);
  }
  function handleDrop(e, stage) {
    e.preventDefault();
    setDragOverStage(null);
    if (dragTxId && onStageChange) {
      const tx = scopedTx.find(t => t.id === dragTxId);
      if (tx && tx.stage !== stage) onStageChange(tx, stage);
    }
    setDragTxId(null);
  }

  return(
    <div>
      {canToggleScope && (
        <div style={{display:"flex",justifyContent:"flex-end",marginBottom:12}}>
          <div style={{display:"flex",background:B.white,border:"1px solid "+B.light,borderRadius:8,padding:2,gap:2}}>
            <button onClick={()=>setViewScope("mine")} style={{padding:"6px 14px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",background:viewScope==="mine"?B.black:"transparent",color:viewScope==="mine"?B.white:B.gray}}>
              My Transactions
            </button>
            <button onClick={()=>setViewScope("all")} style={{padding:"6px 14px",borderRadius:6,border:"none",cursor:"pointer",fontSize:11,fontWeight:700,fontFamily:"'DM Sans',sans-serif",background:viewScope==="all"?B.black:"transparent",color:viewScope==="all"?B.white:B.gray}}>
              {isPrincipal?"Brokerage":"Team"}
            </button>
          </div>
        </div>
      )}
      <div style={{overflowX:"auto",paddingBottom:12}}>
      <div style={{display:"flex",gap:12,minWidth:"max-content"}}>
        {STAGES.map(stage=>(
          <div key={stage} style={{width:240,flexShrink:0}}
            onDragOver={e=>handleDragOver(e,stage)}
            onDragLeave={()=>handleDragLeave(stage)}
            onDrop={e=>handleDrop(e,stage)}>
            <div style={{padding:"8px 12px",borderRadius:"8px 8px 0 0",background:STAGE_COLORS[stage],color:B.white,fontSize:10,fontWeight:700,letterSpacing:"0.06em",textTransform:"uppercase",fontFamily:"'DM Sans',sans-serif",display:"flex",justifyContent:"space-between"}}>
              <span>{stage}</span><span style={{background:"rgba(255,255,255,0.25)",borderRadius:10,padding:"0 7px"}}>{byStage[stage].length}</span>
            </div>
            <div style={{background:dragOverStage===stage?STAGE_COLORS[stage]+"18":B.offWhite,
              borderRadius:"0 0 8px 8px",minHeight:120,padding:8,display:"flex",flexDirection:"column",gap:8,
              border:dragOverStage===stage?"2px dashed "+STAGE_COLORS[stage]:"2px dashed transparent",
              transition:"background 0.15s,border 0.15s"}}>
              {byStage[stage].map(tx=>{
                const agent=users.find(u=>u.id===tx.agentId);
                const mandatory=(tx.tasks||[]).filter(t=>t.mandatory);
                const done=mandatory.filter(t=>t.documents.length>0).length;
                return(
                  <div key={tx.id} draggable
                    onDragStart={e=>handleDragStart(e,tx)}
                    style={{background:B.white,borderRadius:8,padding:"10px 12px",
                      boxShadow:"0 1px 3px rgba(0,0,0,0.08)",borderLeft:"3px solid "+STAGE_COLORS[stage],
                      cursor:dragTxId===tx.id?"grabbing":"grab",
                      opacity:dragTxId===tx.id?0.4:1}}>
                    <div onClick={()=>onOpenChecklist(tx)} style={{cursor:"pointer"}}>
                      <div style={{fontSize:11,fontWeight:700,color:B.black,marginBottom:2,lineHeight:1.3,fontFamily:"'DM Sans',sans-serif"}}>{tx.address.split(",")[0]}</div>
                      <div style={{fontSize:10,color:B.silver,marginBottom:6,fontFamily:"'DM Sans',sans-serif"}}>{(tx.parties&&tx.parties.length>0)?tx.parties.map(p=>p.name).filter(Boolean).join(" & "):tx.clientName}</div>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}><SideBadge side={tx.side}/><span style={{fontSize:11,fontWeight:700,color:B.black,fontFamily:"'DM Sans',sans-serif"}}>{fmt(tx.price)}</span></div>
                      <div style={{marginBottom:4}}><WfBadge wfState={tx.wfState}/></div>
                      {agent&&<div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}><Avatar name={agent.name} role={agent.role} size={16} photo={agent.photo||null}/><span style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>{agent.name}</span></div>}
                      <div style={{height:3,background:B.light,borderRadius:2}}><div style={{height:"100%",borderRadius:2,background:done===mandatory.length&&mandatory.length>0?B.green:B.red,width:mandatory.length?Math.round(done/mandatory.length*100)+"%":"0%"}}/></div>
                      <div style={{fontSize:9,color:done===mandatory.length&&mandatory.length>0?B.green:B.red,marginTop:2,fontFamily:"'DM Sans',sans-serif",fontWeight:700}}>Req docs: {done}/{mandatory.length}</div>
                    </div>
                    {/* Action buttons — same workflow logic as Transactions table */}
                    <div style={{marginTop:8,paddingTop:8,borderTop:"1px solid "+B.light}} onClick={e=>e.stopPropagation()}>
                      <WorkflowActionBar tx={tx} currentUser={currentUser} users={users}
                        onSubmit={onSubmit} onReview={onReview} onCloseTx={onCloseTx}
                        onReopen={onReopen} onSelfApprove={onSelfApprove}/>
                    </div>
                  </div>
                );
              })}
              {byStage[stage].length===0 && (
                <div style={{padding:"20px 8px",textAlign:"center",fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif",fontStyle:"italic"}}>
                  Drop here
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
}

// ─── Main App ─────────────────────────────────────────────────────────────────
export default function App({
  supabaseUser        = null,   // logged-in user from Supabase
  supabaseUsers       = null,   // all users from Supabase
  supabaseTransactions= null,   // all transactions from Supabase
  supabaseChecklistTemplates = null, // this brokerage's checklist template list
  supabaseBrokerage   = null,   // this user's brokerage (name/logo/color) — null in demo mode
  dbOps               = null,   // Supabase operation callbacks
} = {}) {
  const useSupabase = !!dbOps;
  const [brokerage,setBrokerage]       = useState(supabaseBrokerage);
  const [users,setUsers]               = useState(supabaseUsers || INITIAL_USERS);
  const [currentUser,setCurrentUser]   = useState(supabaseUser || null);
  const [transactions,setTransactions] = useState(supabaseTransactions || null);
  const [checklistTemplates,setChecklistTemplates] = useState(supabaseChecklistTemplates || defaultChecklistTemplates());
  const [view,setView]                 = useState("dashboard");
  const [modal,setModal]               = useState(null);
  const [checklistTx,setChecklistTx]   = useState(null);
  const [reviewTx,setReviewTx]         = useState(null);
  const [closingTx,setClosingTx]       = useState(null);
  const [showUserMgmt,setShowUserMgmt] = useState(false);
  const [showChecklistTemplates,setShowChecklistTemplates] = useState(false);
  const [showBranding,setShowBranding] = useState(false);
  const [profileUser,setProfileUser]   = useState(null);
  const [reopenTarget,setReopenTarget]         = useState(null);
  const [voidTarget,setVoidTarget]           = useState(null);
  const [archiveTarget,setArchiveTarget]     = useState(null);
  const [showArchive,setShowArchive]         = useState(false);
  const [showDocumentImport,setShowDocumentImport] = useState(false);
  const [selfApproveTarget,setSelfApproveTarget] = useState(null);
  const [filterStage,setFilterStage]   = useState("All");
  const [filterSide,setFilterSide]     = useState("All");
  const [filterWf,setFilterWf]         = useState("All");
  const [searchQ,setSearchQ]           = useState("");
  const [pendingDraft,setPendingDraft] = useState(null); // {key, isNew, txId, address, savedAt}
  // Transactions page — agent/team scope filter: "mine" | "all" | "team:<brokerId>" | "user:<userId>"
  const [filterAgent,setFilterAgent]   = useState("mine");
  // Transactions page — closing date range: "thisYear" | "all" | "custom"
  const [dateRangeMode,setDateRangeMode] = useState("thisYear");
  const [customFrom,setCustomFrom]     = useState("");
  const [customTo,setCustomTo]         = useState("");

  function login(user) {
    setCurrentUser(user);
    if (!useSupabase && !transactions) setTransactions(makeSample(users));
    setView("dashboard");
  }

  // ── Scan localStorage for any unsaved transaction draft on load ──────────
  // Surfaces a banner so the agent knows their work survived a tab discard/reload
  useEffect(() => {
    if (!currentUser) return;
    try {
      const keys = Object.keys(localStorage).filter(k => k.startsWith("aks_draft_tx_"));
      if (keys.length === 0) return;
      // Find the most recent draft
      let newest = null;
      for (const key of keys) {
        try {
          const raw = JSON.parse(localStorage.getItem(key));
          if (!raw?.savedAt) continue;
          // Skip stale drafts older than 7 days
          if (Date.now() - raw.savedAt > 7*24*60*60*1000) { localStorage.removeItem(key); continue; }
          // Only show drafts belonging to this agent (avoid showing another user's draft on a shared computer)
          if (raw.form?.agentId && raw.form.agentId !== currentUser.id) continue;
          if (!newest || raw.savedAt > newest.savedAt) {
            newest = { key, isNew: key === "aks_draft_tx_new",
              txId: key.replace("aks_draft_tx_", ""),
              address: raw.form?.address || "(no address yet)",
              savedAt: raw.savedAt };
          }
        } catch {}
      }
      if (newest) setPendingDraft(newest);
    } catch {}
  }, [currentUser]); // eslint-disable-line

  function reopenDraft() {
    if (!pendingDraft) return;
    if (pendingDraft.isNew) {
      setModal({}); // opens TransactionModal in "new" mode — it will auto-restore the draft
    } else {
      const existingTx = (transactions||[]).find(t => t.id === pendingDraft.txId);
      setModal(existingTx || {});
    }
    setPendingDraft(null);
  }

  function dismissDraft() {
    try { localStorage.removeItem(pendingDraft.key); } catch {}
    setPendingDraft(null);
  }

  // ── Sync Supabase props into local state atomically ──────────────────────
  useEffect(() => {
    if (!useSupabase) return;
    // Batch all state updates to prevent partial renders
    if (supabaseUser)        setCurrentUser(supabaseUser);
    if (supabaseUsers)       setUsers(supabaseUsers);
    if (supabaseTransactions) setTransactions(supabaseTransactions);
    if (supabaseChecklistTemplates) setChecklistTemplates(supabaseChecklistTemplates);
    if (supabaseBrokerage)   setBrokerage(supabaseBrokerage);
  }, [supabaseUser, supabaseUsers, supabaseTransactions, supabaseChecklistTemplates, supabaseBrokerage]); // eslint-disable-line

  const isPrincipal = currentUser?.role==="principal_broker";
  const isAssocBroker = currentUser?.role==="associate_broker";

  const visible = useMemo(()=>{
    if (!transactions||!currentUser) return [];
    // Exclude archived transactions from all normal views
    let txs = transactions.filter(tx=>tx.wfState!=="archived"&&canUserSeeTransaction(currentUser,tx,users));
    if(filterStage!=="All") txs=txs.filter(t=>t.stage===filterStage);
    if(filterSide!=="All")  txs=txs.filter(t=>t.side===filterSide);
    if(filterWf!=="All")    txs=txs.filter(t=>t.wfState===filterWf);
    if(searchQ){const q=searchQ.toLowerCase();txs=txs.filter(t=>t.address.toLowerCase().includes(q)||t.clientName.toLowerCase().includes(q)||(t.parties||[]).some(p=>p.name.toLowerCase().includes(q))||(t.contacts||[]).some(c=>c.name.toLowerCase().includes(q)));}
    return txs;
  },[transactions,currentUser,users,filterStage,filterSide,filterWf,searchQ]);

  // ── Transactions page — agent/team scope + closing-date range ──────────────
  // Layered on top of `visible` so Pipeline (which uses `visible` directly) is unaffected.
  const visibleForList = useMemo(()=>{
    let txs = visible;
    if(filterAgent==="mine"){
      txs = txs.filter(t=>t.agentId===currentUser.id);
    } else if(filterAgent!=="all"){
      if(filterAgent.startsWith("team:")){
        const brokerId = filterAgent.slice(5);
        txs = txs.filter(t=>{
          const agent = users.find(u=>u.id===t.agentId);
          return t.agentId===brokerId || agent?.brokerId===brokerId;
        });
      } else if(filterAgent.startsWith("user:")){
        const uid = filterAgent.slice(5);
        txs = txs.filter(t=>t.agentId===uid);
      }
    }
    if(dateRangeMode==="thisYear"){
      const y = new Date().getFullYear();
      // Transactions with no closing date yet (e.g. new drafts) always stay visible.
      txs = txs.filter(t=>!t.closingDate || new Date(t.closingDate+"T00:00:00").getFullYear()===y);
    } else if(dateRangeMode==="custom" && (customFrom||customTo)){
      txs = txs.filter(t=>{
        if(!t.closingDate) return true;
        const d = new Date(t.closingDate+"T00:00:00");
        if(customFrom && d < new Date(customFrom+"T00:00:00")) return false;
        if(customTo && d > new Date(customTo+"T23:59:59")) return false;
        return true;
      });
    }
    return txs;
  },[visible,users,currentUser,filterAgent,dateRangeMode,customFrom,customTo]);

  // ── Clear any localStorage draft for a transaction ─────────────────────────
  function clearTxDraft(txId) {
    try {
      // Clear both the "new" draft and the edit draft for this transaction
      localStorage.removeItem("aks_draft_tx_new");
      if (txId) localStorage.removeItem("aks_draft_tx_" + txId);
      setPendingDraft(null);
    } catch {}
  }

  // ── Change a transaction's pipeline stage (drag-and-drop on Pipeline board) ──
  async function changeStage(tx, newStage) {
    const updates = { stage: newStage };
    // Keep wfState in sync when a card is dragged onto a terminal stage — otherwise
    // the transaction still reads as active (e.g. stuck in Ready to Close) even
    // though the board shows it as Closed/Fallen Through.
    if (newStage === "Fallen Through" && tx.wfState !== "fallen_through") {
      updates.wfState = "fallen_through";
    } else if (newStage === "Closed" && tx.wfState !== "closed") {
      updates.wfState = "closed";
    }
    if (useSupabase) {
      try { await dbOps.updateTx(tx.id, updates); }
      catch(e) { alert("Error moving transaction: "+e.message); return; }
    } else {
      setTransactions(prev => prev.map(t => t.id===tx.id ? {...t, ...updates} : t));
    }
  }

  async function saveTx(tx){
    if (useSupabase) {
      try {
        if (transactions?.find(t=>t.id===tx.id)) {
          await dbOps.updateTx(tx.id, tx);
        } else {
          await dbOps.createTx(tx);
        }
      } catch(e) { alert("Error saving transaction: "+e.message); return; }
    } else {
      setTransactions(prev=>prev.find(t=>t.id===tx.id)?prev.map(t=>t.id===tx.id?tx:t):[...prev,tx]);
    }
    // Clear any localStorage draft now that the transaction has been saved
    clearTxDraft(tx.id);
    setModal(null);
  }
  async function deleteTx(id){
    if(!window.confirm("Remove this transaction?")) return;
    if (useSupabase) {
      try { await dbOps.deleteTx(id); }
      catch(e) { alert("Error deleting: "+e.message); return; }
    } else {
      setTransactions(prev=>prev.filter(t=>t.id!==id));
    }
  }
  async function updateTasks(txId,tasks){
    if (useSupabase) {
      try { await dbOps.saveTasks(txId, tasks); }
      catch(e) {
        console.error("Error saving tasks:", e);
        alert("Error saving checklist: "+e.message+"\n\nSome changes may not have been saved. Please try again.");
      }
    } else {
      setTransactions(prev=>prev.map(t=>t.id===txId?{...t,tasks}:t));
    }
  }

  async function submitForReview(txId){
    // Hard guard — enforce mandatory docs even if UI is bypassed
    const tx = transactions.find(t=>t.id===txId);
    if (!tx) return;
    const missing = (tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0);
    if (missing.length > 0) {
      alert("Cannot submit for review. Missing required documents:\n\n"+missing.map(t=>"\u2022 "+t.title).join("\n")+"\n\nPlease upload all required documents first.");
      return;
    }
    const now = new Date().toISOString();
    const newLog = [...(tx.reviewLog||[]),{id:genId(),action:"submitted",by:currentUser.id,byName:currentUser.name,at:now,comment:""}];
    if (useSupabase) {
      try { await dbOps.updateTx(txId,{wfState:"submitted",submittedAt:now,reviewLog:newLog}); }
      catch(e) { alert("Error submitting: "+e.message); return; }
    } else {
      setTransactions(prev=>prev.map(t=>t.id!==txId?t:{...t,wfState:"submitted",submittedAt:now,reviewLog:newLog}));
    }
  }
  async function brokerAction(txId,action,comment){
    const tx = transactions.find(t=>t.id===txId);
    const entry={id:genId(),action,by:currentUser.id,byName:currentUser.name,at:new Date().toISOString(),comment};
    const newState = action==="approve"?"approved":"changes_requested";
    const newLog = [...(tx.reviewLog||[]),entry];
    if (useSupabase) {
      try { await dbOps.updateTx(txId,{wfState:newState,reviewLog:newLog}); }
      catch(e) { alert("Error updating transaction: "+e.message); return; }
    } else {
      setTransactions(prev=>prev.map(t=>t.id!==txId?t:{...t,wfState:newState,reviewLog:newLog}));
    }
    setReviewTx(null);
  }
  async function closeTx(txId,note){
    // Hard guard — all mandatory docs must be present
    const tx = transactions.find(t=>t.id===txId);
    if (!tx) return;
    const missing = (tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0);
    if (missing.length > 0) {
      alert("Cannot close transaction. Missing required documents:\n\n"+missing.map(t=>"\u2022 "+t.title).join("\n")+"\n\nAll required documents must be uploaded before closing.");
      setClosingTx(null);
      return;
    }
    const entry = {id:genId(),action:"closed",by:currentUser.id,byName:currentUser.name,at:new Date().toISOString(),comment:note||""};
    const newLog = [...(tx.reviewLog||[]),entry];
    const updates = {wfState:"closed",stage:"Closed",reviewLog:newLog};

    if (useSupabase) {
      try { await dbOps.updateTx(txId, updates); }
      catch(e) { alert("Error closing transaction: "+e.message); return; }
    } else {
      setTransactions(prev=>prev.map(t=>t.id===txId?{...t,...updates}:t));
    }
    clearTxDraft(txId);
    setClosingTx(null);
  }

  // ── Archive transaction (Principal Broker only) ─────────────────────────
  async function archiveTx(txId, note) {
    const tx = transactions.find(t => t.id === txId);
    if (!tx) return;
    const entry = { id:genId(), action:"archived", by:currentUser.id,
      byName:currentUser.name, at:new Date().toISOString(), comment:note||"" };
    const updates = { wfState:"archived", reviewLog:[...(tx.reviewLog||[]),entry] };
    if (useSupabase) {
      try { await dbOps.updateTx(txId, updates); }
      catch(e) { alert("Error archiving: "+e.message); return; }
    } else {
      setTransactions(prev => prev.map(t => t.id===txId ? {...t,...updates} : t));
    }
    setArchiveTarget(null);
  }

  // ── Restore archived transaction ──────────────────────────────────────────
  async function restoreTx(tx) {
    const entry = { id:genId(), action:"restored", by:currentUser.id,
      byName:currentUser.name, at:new Date().toISOString(), comment:"Restored from archive." };
    // Restore to previous non-archived state — default to draft if unknown
    const prevState = tx.reviewLog?.slice().reverse()
      .find(e => e.action !== "archived")?.action === "closed" ? "closed" : "draft";
    const updates = { wfState:prevState, reviewLog:[...(tx.reviewLog||[]),entry] };
    if (useSupabase) {
      try { await dbOps.updateTx(tx.id, updates); }
      catch(e) { alert("Error restoring: "+e.message); return; }
    } else {
      setTransactions(prev => prev.map(t => t.id===tx.id ? {...t,...updates} : t));
    }
  }

  // ── Void transaction (agent only, draft/changes_requested) ──────────────
  async function voidTx(txId, reason) {
    const tx = transactions.find(t => t.id === txId);
    if (!tx) return;
    const entry = { id:genId(), action:"voided", by:currentUser.id, byName:currentUser.name,
      at:new Date().toISOString(), comment:reason };
    const updates = { wfState:"fallen_through", stage:"Fallen Through", reviewLog:[...(tx.reviewLog||[]),entry] };
    if (useSupabase) {
      try { await dbOps.updateTx(txId, updates); }
      catch(e) { alert("Error voiding transaction: "+e.message); return; }
    } else {
      setTransactions(prev => prev.map(t => t.id===txId ? {...t,...updates} : t));
    }
    clearTxDraft(txId);
    setVoidTarget(null);
  }

  // ── Reopen a closed transaction (broker only) ──
  // Principal Broker self-approves and closes their own transaction
  async function selfApproveTx(tx, note="") {
    const missing = (tx.tasks||[]).filter(t=>t.mandatory&&t.documents.length===0);
    if (missing.length > 0) {
      alert("Cannot close. Missing required documents:\n\n"+missing.map(t=>"\u2022 "+t.title).join("\n"));
      return;
    }
    const now = new Date().toISOString();
    const entries = [
      {id:genId(),action:"approved", by:currentUser.id,byName:currentUser.name,at:now,comment:"Self-approved by Principal Broker."},
      {id:genId(),action:"closed",   by:currentUser.id,byName:currentUser.name,at:now,comment:note||"Closed by Principal Broker (own transaction)."},
    ];
    const newLog = [...(tx.reviewLog||[]), ...entries];
    const updates = { wfState:"closed", stage:"Closed", reviewLog:newLog };

    if (useSupabase) {
      try { await dbOps.updateTx(tx.id, updates); }
      catch(e) { alert("Error closing transaction: "+e.message); return; }
    } else {
      setTransactions(prev=>prev.map(t=>t.id===tx.id ? {...t, ...updates} : t));
    }
    clearTxDraft(tx.id);
  }

  async function reopenTx(txId, reason){
    const txR = transactions.find(t=>t.id===txId);
    const entry={id:genId(),action:"reopened",by:currentUser.id,byName:currentUser.name,at:new Date().toISOString(),comment:reason||""};
    const newStage = txR.stage==="Closed"?"Clear to Close":txR.stage;
    const newLog = [...(txR.reviewLog||[]),entry];
    if (useSupabase) {
      try { await dbOps.updateTx(txId,{wfState:"changes_requested",stage:newStage,reviewLog:newLog}); }
      catch(e) { alert("Error reopening: "+e.message); return; }
    } else {
      setTransactions(prev=>prev.map(t=>t.id!==txId?t:{...t,wfState:"changes_requested",stage:newStage,reviewLog:newLog}));
    }
    setReopenTarget(null);
  }
  async function openChecklist(tx) {
    const latestTx = transactions.find(t=>t.id===tx.id) || tx;
    setChecklistTx(latestTx); // open immediately with what we have
    if (useSupabase && dbOps?.loadChecklist) {
      try {
        const tasks = await dbOps.loadChecklist(latestTx.id);
        const updated = { ...latestTx, tasks };
        setChecklistTx(updated);
        setTransactions(prev => prev.map(t => t.id === latestTx.id ? updated : t));
      } catch(e) {
        console.warn("Could not refresh tasks for checklist:", e.message);
      }
    }
  }

  const pendingReview = transactions ? transactions.filter(t=>t.wfState==="submitted"&&currentUser&&canReviewSubmission(currentUser,t,users)).length : 0;

  // ── Login screen ──
  if(!currentUser && !useSupabase){
    const grouped = {
      principal_broker: users.filter(u=>u.role==="principal_broker"),
      associate_broker: users.filter(u=>u.role==="associate_broker"),
      realtor:          users.filter(u=>u.role==="realtor"),
    };
    return(
      <div style={{minHeight:"100vh",background:B.black,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",fontFamily:"'DM Sans',sans-serif",padding:20}}>
        <FontLink/>
        <div style={{textAlign:"center",marginBottom:36}}>
          <div style={{width:80,height:80,borderRadius:"50%",overflow:"hidden",margin:"0 auto 16px",boxShadow:"0 4px 20px rgba(165,28,48,0.4)"}}><img src={AKS_LOGO} alt="AKS Realty Group" style={{width:"100%",height:"100%",objectFit:"cover"}}/></div>
          <h1 style={{margin:"0 0 4px",fontSize:26,fontWeight:800,color:B.white,fontFamily:"'Playfair Display',serif"}}>AKS Realty Group, LLC</h1>
          <p style={{margin:0,color:B.silver,fontSize:12,letterSpacing:"0.08em",textTransform:"uppercase"}}>Transaction Management System</p>
        </div>
        <div style={{background:B.charcoal,borderRadius:16,padding:28,width:"100%",maxWidth:440,boxShadow:"0 20px 60px rgba(0,0,0,0.4)"}}>
          <p style={{margin:"0 0 20px",color:B.silver,fontSize:12,textAlign:"center"}}>Select your profile to continue</p>
          {Object.entries(grouped).map(([role,members])=>members.length>0&&(
            <div key={role} style={{marginBottom:16}}>
              <div style={{fontSize:10,fontWeight:700,color:ROLES[role].color,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:8,fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",gap:6}}>{ROLES[role].icon} {ROLES[role].label}{members.length>1?"s":""}</div>
              {members.map(u=>(
                <button key={u.id} onClick={()=>login(u)}
                  style={{width:"100%",padding:"12px 16px",borderRadius:10,border:`1px solid ${ROLES[u.role].color}33`,background:ROLES[u.role].color+"15",cursor:"pointer",display:"flex",alignItems:"center",gap:12,textAlign:"left",marginBottom:8}}>
                  <Avatar name={u.name} role={u.role} size={36} photo={u.photo||null}/>
                  <div>
                    <div style={{fontSize:13,fontWeight:700,color:B.white,fontFamily:"'DM Sans',sans-serif"}}>{u.name}</div>
                    <div style={{fontSize:10,color:ROLES[u.role].color,letterSpacing:"0.06em",fontFamily:"'DM Sans',sans-serif",marginTop:2}}>{ROLES[u.role].label}{u.licenseNo?" · "+u.licenseNo:""}</div>
                  </div>
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }

  const navItems=[
    // All roles get a dashboard now
    {key:"dashboard", label: currentUser.role==="realtor" ? "Dashboard" : `Dashboard${pendingReview>0?` (${pendingReview})`:``}`, highlight: currentUser.role!=="realtor" && pendingReview>0},
    {key:"pipeline",label:"Pipeline"},
    {key:"list",label:"Transactions"},
  ];

  return(
    <div style={{minHeight:"100vh",background:B.offWhite,fontFamily:"'DM Sans',sans-serif"}}>
      <FontLink/>
      <header style={{background:B.black,padding:"0 24px",display:"flex",alignItems:"center",justifyContent:"space-between",height:58,boxShadow:"0 2px 12px rgba(0,0,0,0.3)"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{width:34,height:34,borderRadius:"50%",overflow:"hidden",flexShrink:0,boxShadow:"0 2px 8px rgba(165,28,48,0.5)",background:B.red,display:"flex",alignItems:"center",justifyContent:"center"}}>
            {brokerage?.logoUrl
              ? <img src={brokerage.logoUrl} alt={brokerage.name} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
              : <span style={{fontSize:16}}>🏠</span>}
          </div>
          <div><div style={{fontSize:14,fontWeight:800,color:B.white,fontFamily:"'Playfair Display',serif",lineHeight:1.1}}>{brokerage?.name||"AKS Realty Group"}</div><div style={{fontSize:9,color:B.silver,letterSpacing:"0.12em",textTransform:"uppercase"}}>Transaction Manager</div></div>
        </div>
        <nav style={{display:"flex",gap:4}}>
          {navItems.map(item=>(
            <button key={item.key} onClick={()=>setView(item.key)}
              style={{padding:"6px 14px",borderRadius:8,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"'DM Sans',sans-serif",background:view===item.key?B.red:"transparent",color:view===item.key?B.white:item.highlight?B.gold:B.silver}}>
              {item.label}
            </button>
          ))}
        </nav>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          {isPrincipal&&(
            <button onClick={()=>setShowUserMgmt(true)}
              style={{padding:"6px 14px",borderRadius:8,border:"1px solid "+B.teal+"66",background:B.teal+"18",cursor:"pointer",fontSize:11,fontWeight:700,color:B.teal,fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
              👥 Team
            </button>
          )}
          {isPrincipal&&(
            <button onClick={()=>setShowChecklistTemplates(true)}
              style={{padding:"6px 14px",borderRadius:8,border:"1px solid "+B.purple+"66",background:B.purple+"18",cursor:"pointer",fontSize:11,fontWeight:700,color:B.purple,fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
              📋 Checklist
            </button>
          )}
          {isPrincipal&&(
            <button onClick={()=>setShowBranding(true)}
              style={{padding:"6px 14px",borderRadius:8,border:"1px solid "+B.blue+"66",background:B.blue+"18",cursor:"pointer",fontSize:11,fontWeight:700,color:B.blue,fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
              🎨 Branding
            </button>
          )}
          {isPrincipal&&(
            <button onClick={()=>setShowArchive(true)}
              style={{padding:"6px 14px",borderRadius:8,border:"1px solid #FCD34D66",background:"#FFFBEB",cursor:"pointer",fontSize:11,fontWeight:700,color:"#92400E",fontFamily:"'DM Sans',sans-serif",display:"flex",alignItems:"center",gap:5,flexShrink:0}}>
              📦 Archive
            </button>
          )}
          <button onClick={()=>setProfileUser(currentUser)}
            style={{display:"flex",alignItems:"center",gap:8,padding:"5px 10px",borderRadius:8,border:"1px solid "+B.gray,background:"transparent",cursor:"pointer",flexShrink:0}}>
            <Avatar name={currentUser.name} role={currentUser.role} size={24} photo={currentUser.photo||null}/>
            <div style={{textAlign:"left"}}>
              <div style={{fontSize:11,fontWeight:700,color:B.white,fontFamily:"'DM Sans',sans-serif",whiteSpace:"nowrap"}}>{currentUser.name}</div>
              <div style={{fontSize:9,color:ROLES[currentUser.role].color,letterSpacing:"0.04em",fontFamily:"'DM Sans',sans-serif"}}>{ROLES[currentUser.role].label}</div>
            </div>
          </button>
          {useSupabase ? (
            <button onClick={()=>dbOps.signOut()}
              style={{padding:"5px 10px",borderRadius:8,border:"1px solid "+B.gray,background:"transparent",cursor:"pointer",fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif",flexShrink:0}}>
              Sign Out
            </button>
          ) : (
            <button onClick={()=>setCurrentUser(null)}
              style={{padding:"5px 10px",borderRadius:8,border:"1px solid "+B.gray,background:"transparent",cursor:"pointer",fontSize:11,color:B.silver,fontFamily:"'DM Sans',sans-serif",flexShrink:0}}>
              Switch
            </button>
          )}
        </div>
      </header>

      <main style={{maxWidth:1440,margin:"0 auto",padding:"24px 20px"}}>
        {pendingDraft && (
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:14,
            background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:12,
            padding:"14px 20px",marginBottom:20,flexWrap:"wrap"}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <span style={{fontSize:22}}>💾</span>
              <div>
                <div style={{fontSize:13,fontWeight:700,color:"#1E40AF",fontFamily:"'DM Sans',sans-serif"}}>
                  You have an unsaved transaction draft
                </div>
                <div style={{fontSize:12,color:"#3B82F6",marginTop:2,fontFamily:"'DM Sans',sans-serif"}}>
                  {pendingDraft.address} · saved {fmtTS(new Date(pendingDraft.savedAt).toISOString())}
                </div>
              </div>
            </div>
            <div style={{display:"flex",gap:8,flexShrink:0}}>
              <button onClick={dismissDraft}
                style={{padding:"8px 14px",borderRadius:8,border:"1px solid #BFDBFE",
                  background:"transparent",cursor:"pointer",fontSize:12,color:"#1E40AF",
                  fontFamily:"'DM Sans',sans-serif",fontWeight:600}}>
                Dismiss
              </button>
              <button onClick={reopenDraft}
                style={{padding:"8px 18px",borderRadius:8,border:"none",
                  background:"#1E40AF",color:B.white,cursor:"pointer",fontSize:12,
                  fontWeight:700,fontFamily:"'DM Sans',sans-serif"}}>
                Reopen Draft →
              </button>
            </div>
          </div>
        )}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:12}}>
          <div>
            <h1 style={{margin:0,fontSize:20,fontWeight:800,color:B.black,fontFamily:"'Playfair Display',serif"}}>
              {view==="dashboard"?"Dashboard":view==="pipeline"?"Pipeline":"Transactions"}
            </h1>
            <p style={{margin:"3px 0 0",fontSize:11,color:B.silver}}>
              {(()=>{const count=view==="list"?visibleForList.length:visible.length;
                return currentUser.role==="realtor"?`${count} transaction${count!==1?"s":""} assigned to you`:`${count} transactions in your scope`;})()}
            </p>
          </div>
          <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
            {brokerage?.documentImportQuota>0 && (
              <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                <button onClick={()=>setShowDocumentImport(true)} style={{padding:"7px 18px 7px 7px",borderRadius:10,border:"none",background:"linear-gradient(135deg,#7C3AED,#DB2777)",color:B.white,cursor:"pointer",fontSize:13,fontWeight:700,display:"flex",alignItems:"center",gap:9,fontFamily:"'DM Sans',sans-serif",boxShadow:"0 4px 14px rgba(124,58,237,0.4)"}}>
                  <span style={{width:26,height:26,borderRadius:"50%",background:B.white,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0,boxShadow:"0 1px 3px rgba(0,0,0,0.25)"}}>🧞</span>
                  Transaction Genie
                </button>
                <span style={{fontSize:10,color:B.silver,fontFamily:"'DM Sans',sans-serif"}}>
                  {Math.max(0,brokerage.documentImportQuota-brokerage.documentImportUsed)} of {brokerage.documentImportQuota} imports remaining
                </span>
              </div>
            )}
            <button onClick={()=>setModal({})} style={{padding:"9px 18px",borderRadius:10,border:"none",background:B.red,color:B.white,cursor:"pointer",fontSize:13,fontWeight:700,display:"flex",alignItems:"center",gap:8,fontFamily:"'DM Sans',sans-serif"}}>
              <span style={{fontSize:16,lineHeight:1}}>+</span> New Transaction
            </button>
          </div>
        </div>

        {view!=="dashboard"&&(
          <div style={{display:"flex",gap:10,marginBottom:18,flexWrap:"wrap"}}>
            <input value={searchQ} onChange={e=>setSearchQ(e.target.value)} placeholder="Search address or client…"
              style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,minWidth:200,outline:"none",color:B.black}}/>
            <select value={filterStage} onChange={e=>setFilterStage(e.target.value)} style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,color:B.black,outline:"none"}}>
              <option value="All">All Stages</option>{STAGES.map(s=><option key={s}>{s}</option>)}
            </select>
            <select value={filterSide} onChange={e=>setFilterSide(e.target.value)} style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,color:B.black,outline:"none"}}>
              <option value="All">Both Sides</option><option>Buyer</option><option>Seller</option>
            </select>
            <select value={filterWf} onChange={e=>setFilterWf(e.target.value)} style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,color:B.black,outline:"none"}}>
              <option value="All">All Statuses</option>
              {Object.entries(WF_STATES).map(([k,v])=><option key={k} value={k}>{v.label}</option>)}
            </select>

            {view==="list"&&(isPrincipal||isAssocBroker)&&(
              <select value={filterAgent} onChange={e=>setFilterAgent(e.target.value)} style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,color:B.black,outline:"none"}}>
                <option value="mine">My Transactions</option>
                <option value="all">{isPrincipal?"All Brokerage":"All My Team"}</option>
                {isPrincipal&&users.filter(u=>u.role==="associate_broker").map(b=>
                  <option key={"team:"+b.id} value={"team:"+b.id}>Team: {b.name}</option>
                )}
                {users.filter(u=>u.role==="realtor"&&(isPrincipal||u.brokerId===currentUser.id)).map(r=>
                  <option key={"user:"+r.id} value={"user:"+r.id}>{r.name}</option>
                )}
              </select>
            )}

            {view==="list"&&(
              <>
                <select value={dateRangeMode} onChange={e=>setDateRangeMode(e.target.value)} style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,color:B.black,outline:"none"}}>
                  <option value="thisYear">This Year</option>
                  <option value="all">All Time</option>
                  <option value="custom">Custom Range</option>
                </select>
                {dateRangeMode==="custom"&&(
                  <>
                    <input type="date" value={customFrom} onChange={e=>setCustomFrom(e.target.value)}
                      style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,color:B.black,outline:"none"}}/>
                    <span style={{alignSelf:"center",fontSize:12,color:B.silver}}>to</span>
                    <input type="date" value={customTo} onChange={e=>setCustomTo(e.target.value)}
                      style={{padding:"7px 12px",borderRadius:8,border:"1px solid "+B.light,fontSize:12,fontFamily:"'DM Sans',sans-serif",background:B.white,color:B.black,outline:"none"}}/>
                  </>
                )}
              </>
            )}
          </div>
        )}

        {view==="dashboard"&&transactions&&(
          currentUser.role==="realtor"
            ? <RealtorDashboard currentUser={currentUser} transactions={transactions} users={users} onOpenChecklist={openChecklist}/>
            : <Dashboard currentUser={currentUser} transactions={transactions} users={users} onReview={setReviewTx} onCloseTx={setClosingTx}/>
        )}
        {view==="pipeline"&&<PipelineView transactions={visible} currentUser={currentUser} users={users} onOpenChecklist={openChecklist} onSubmit={submitForReview} onReview={setReviewTx} onCloseTx={setClosingTx} onReopen={setReopenTarget} onSelfApprove={setSelfApproveTarget} onStageChange={changeStage}/>}
        {view==="list"&&<div style={{background:B.white,borderRadius:12,border:"1px solid "+B.light,overflow:"hidden",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}><TransactionTable transactions={visibleForList} currentUser={currentUser} users={users} onEdit={setModal} onDelete={deleteTx} onOpenChecklist={openChecklist} onSubmit={submitForReview} onReview={setReviewTx} onCloseTx={setClosingTx} onReopen={setReopenTarget} onSelfApprove={setSelfApproveTarget} onVoid={setVoidTarget} onArchive={setArchiveTarget}/></div>}
      </main>

      {modal!==null&&<TransactionModal tx={modal} currentUser={currentUser} users={users} checklistTemplates={checklistTemplates} onClose={()=>setModal(null)} onSave={saveTx} onOpenChecklist={tx=>{setModal(null);openChecklist(tx);}}/>}
      {showDocumentImport&&<DocumentImportModal currentUser={currentUser} users={users} checklistTemplates={checklistTemplates} transactions={transactions} brokerage={brokerage} dbOps={dbOps} onClose={()=>setShowDocumentImport(false)} onImported={tx=>openChecklist(tx)} onQuotaUpdate={updates=>setBrokerage(b=>b?{...b,...updates}:b)}/>}
      {checklistTx&&<TaskPanel tx={checklistTx} currentUser={currentUser} users={users} onUpdateTasks={(id,tasks)=>{updateTasks(id,tasks);setChecklistTx(p=>({...p,tasks}));}} onSubmit={submitForReview} onReview={setReviewTx} onCloseTx={setClosingTx} onReopen={setReopenTarget} onSelfApprove={setSelfApproveTarget} onClose={()=>setChecklistTx(null)} onUploadDoc={useSupabase?dbOps.uploadDoc:undefined} onDeleteDoc={useSupabase?dbOps.deleteDoc:undefined}/>}
      {reviewTx&&<BrokerReviewModal tx={reviewTx} currentUser={currentUser} users={users} onAction={brokerAction} onClose={()=>setReviewTx(null)}/>}
      {closingTx&&<CloseTransactionModal tx={closingTx} users={users} onClose={()=>setClosingTx(null)} onConfirm={closeTx}/>}
      {reopenTarget&&<ReopenTransactionModal tx={reopenTarget} currentUser={currentUser} onClose={()=>setReopenTarget(null)} onConfirm={reopenTx}/>}
      {voidTarget&&<VoidTransactionModal tx={voidTarget} currentUser={currentUser} onClose={()=>setVoidTarget(null)} onConfirm={voidTx}/>}
      {archiveTarget&&<ArchiveTransactionModal tx={archiveTarget} currentUser={currentUser} onClose={()=>setArchiveTarget(null)} onConfirm={archiveTx}/>}
      {showArchive&&<ArchivePanel transactions={transactions} currentUser={currentUser} users={users} onRestore={restoreTx} onPermanentDelete={deleteTx} onClose={()=>setShowArchive(false)}/>}
      {selfApproveTarget&&<SelfApproveConfirmModal tx={selfApproveTarget} currentUser={currentUser} onClose={()=>setSelfApproveTarget(null)} onConfirm={(tx,note)=>{selfApproveTx(tx,note);setSelfApproveTarget(null);}}/>}
      {showUserMgmt&&<UserManagementPanel users={users} currentUser={currentUser} onUpdateUsers={setUsers} onClose={()=>setShowUserMgmt(false)} onViewProfile={setProfileUser} onInviteUser={dbOps?.inviteUser} onDeleteUser={dbOps?.deleteUser}/>}
      {showChecklistTemplates&&<ChecklistTemplatePanel templates={checklistTemplates} currentUser={currentUser} onClose={()=>setShowChecklistTemplates(false)} onCreate={dbOps?.createChecklistTemplate} onUpdate={dbOps?.updateChecklistTemplate} onDelete={dbOps?.deleteChecklistTemplate} onSync={setChecklistTemplates}/>}
      {showBranding&&<BrandingPanel brokerage={brokerage} currentUser={currentUser} users={users} transactions={transactions} onClose={()=>setShowBranding(false)} onUpdate={dbOps?.updateBrokerage} onUploadLogo={dbOps?.uploadBrokerageLogo}/>}
      {profileUser&&<UserProfilePanel targetUser={profileUser} currentUser={currentUser} onSave={async saved=>{
        if (useSupabase) {
          try {
            const persisted = await dbOps.saveUser(saved);
            setUsers(prev=>prev.map(u=>u.id===persisted.id?persisted:u));
            if (currentUser.id===persisted.id) setCurrentUser(persisted);
          } catch(e) { alert("Error saving profile: "+e.message); return; }
        } else {
          setUsers(prev=>prev.map(u=>u.id===saved.id?saved:u));
          if (currentUser.id===saved.id) setCurrentUser(saved);
        }
      }} onClose={()=>setProfileUser(null)}/>}
      <HelpChatbot currentUser={currentUser} onNavigate={setView}/>
    </div>
  );
}
